import queryString from 'query-string';
import { getKwargsHasErrors } from 'js/components/data_sources/kwargsValidationState';
import { clearKwargsFromExtraData } from 'js/components/data_sources/useAIFunctionKwargs';
import React from 'react';
import { Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import _, { clone, has, omit } from 'lodash';
import cx from 'classnames';
import { MAX_UPLOAD_FILE_SIZE } from 'js/constants/config';
import {
  CONNECTION_CATEGORY_DATABASE,
  CONNECTION_CATEGORY_FILE,
  CONNECTION_CATEGORY_FILE_UPLOAD,
  CONNECTION_CATEGORY_KAFKA,
  CONNECTION_CATEGORY_NEXLA_MONITOR,
  CONNECTION_CATEGORY_NOSQL,
  CONNECTION_CATEGORY_REST,
  CONNECTION_CATEGORY_SOAP,
  CONNECTION_CATEGORY_SYSLOG,
  CONNECTION_CATEGORY_TEMPLATIZED_API,
  CONNECTION_CATEGORY_TEMPLATIZED_API_MULTI,
  CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT,
  CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT,
  CONNECTION_CATEGORY_WEBHOOK,
  CONNECTOR_CODE_SQL_RUNNER,
} from 'js/constants/connectionCategories';
import { FORM_TYPE_CREATE_DATA_SOURCE } from 'js/constants/formTypes';
import { ROUTE_PIPELINES, ROUTE_SELECT_PIPELINE_TYPE } from 'js/constants/pathnames';
import { CONNECTORS_RESOURCE_TYPES } from 'js/constants/resourceTypes';
import { SUPPORT_KEY_SOURCE_FORM_COMMON } from 'js/constants/supportPageKeys';
import { ACLQueryModeTypes } from 'js/constants/visibilityFilters';
import { formatNUIURL, isNUIURLEquals, isNUIURLStartsWith } from 'js/lib/URLUtils';
import { applyMacroReplacement } from 'js/lib/MacroReplacementUtils';
import Form from '../elements/forms/Form';
import FormPage from '../elements/forms/FormPage';
import AuthenticateDataSource from './add_ds_form/AuthenticateDataSource';
import ConfigureAPI from './add_ds_form/ConfigureAPI';
import { FileUploadConfiguration } from 'js/components/data_sources/add_ds_form/FileUploadConfiguration/FileUploadConfiguration';
import { SyslogConfiguration } from 'js/components/data_sources/add_ds_form/SyslogConfiguration/SyslogConfiguration';
import { IncomingWebhookConfiguration } from 'js/components/data_sources/add_ds_form/IncomingWebhookConfiguration';
import ConfigureKafkaContainer from './add_ds_form/ConfigureKafkaContainer';
import ConfigureSOAP from './add_ds_form/ConfigureSOAP';
import ConfigureTemplatizedAPI from './add_ds_form/ConfigureTemplatizedAPI';
import { FlowTriggerHelper } from './add_ds_form/MonitoringInterval/FlowTriggerHelper';
import ConfigureTemplatizedScript from './add_ds_form/ConfigureTemplatizedScript';
import SelectBucket from 'js/components/data_sources/add_ds_form/SelectBucket';
import SelectConnection from './add_ds_form/SelectConnection';
import { EmailScriptConfiguration } from './add_ds_form/vendors/email/EmailScriptConfiguration/EmailScriptConfiguration';

import { getConnectionOrVendorType, isSqlAutomation } from 'js/lib/ResourceUtils';
import { didVendorEndpointJustArrive, hasVendorEndpoint } from 'js/lib/templatizedApiEditGuards';
import { getExistingReusableCustomProcessorId } from 'js/lib/sourceCustomProcessor/sourceCustomProcessorUtils';
import UIUtils from '../../lib/UIUtils';
import DatabaseConfigurator from './add_ds_form/database/DatabaseConfigurator';
import NoSQLConfigurator from './add_ds_form/database/NoSQLConfigurator';

import Constants, { CONNECTORS_WITHOUT_PATH } from '../../Constants';
import { bytesToString, formatCode } from 'js/lib/FormatUtils';
import JSONUtils from '../../lib/JSONUtils';
import {
  getEmptyRequiredFields,
  formatValidationErrorMessage,
  validateDataPath,
} from 'js/lib/ValidationUtils';
import { selectXPath } from 'js/lib/XMLUtils';

import RoutePrefixContext from '../../../new/contexts/RoutePrefixContext';
import { API_SERVER_URL } from 'js/constants/api';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import ConfigureNexlaMonitor from './add_ds_form/ConfigureNexlaMonitor';

import './AddDataSourceForm.scss';
import { flowDataMap } from 'new/elements/flows/dataMap';
import { cleanObject } from 'new/utils';
import { ConnectionLoader } from 'new/elements/ConnectionLoader/ConnectionLoader';
import FileDataFormatSection from 'new/components/flows/types/DirectFlow/steps/FileDataFormatSection/FileDataFormatSection';
import RuntimeSelection from 'new/modules/settings/capsules/components/RuntimeSelection/RuntimeSelection';
import RuntimeSelectionDescription from 'new/modules/settings/capsules/components/RuntimeSelection/RuntimeSelectionDescription';
import { TransformType } from 'new/components/ReusableTransform/types';
import { Base64 } from 'js-base64';
import flowTypes from 'new/components/flows/types/flowTypes';
import { ELTSourceSetup } from 'new/components/flows/configure/ELT/ELTSourceSetup';
import { createResourceSetupService as createELTService } from 'new/components/flows/configure/ELT/ELTSourceSetup/service/createResourceSetupService';
import UserConfirmation, {
  CustomUserConfirmation,
} from 'js/components/route_utils/UserConfirmation';
import { shouldRenderRunAction } from 'js/components/pipelines/cards/components/ExpandActions/utils/shouldRenderSourceAction';
import {
  assignFlowToProjectIfPresent,
  redirectToProjectIfNeeded,
} from 'new/utils/projectAssignment';
import { getFeatureFlagValue } from 'new/constants/featureFlags';
import RawFileDataCheckbox from 'js/components/data_sources/add_ds_form/RawFileDataCheckbox';
import AnalyticsUtils from 'js/lib/AnalyticsUtils';
import { UiMode } from 'new/constants/uiMode';
import { isUiModeCode, withUiModeDefault, withUiModeRemoved } from 'new/utils/uiMode';
import {
  filterActionEndpointOptions,
  getDefaultDataEndpoint,
  getEndpointFlowType,
} from 'new/utils/actionEndpoints';
import { withSnackbar } from 'js/utils/withSnackbar';
import { getClusterIdFromSource } from './getClusterIdFromSource';

const PIPELINE_FORM_PATH_PATTERN = new RegExp(`${ROUTE_PIPELINES}/\\d+/edit`);
const PIPELINE_PROJECTS_PATH_PATTERN = new RegExp(`(.*)/projects(.*)`);
const API_URL_PLACEHOLDER_PATTERN = /{[a-zA-Z]+\d+\.\w+}/g;
const ADVANCED_EXIT_CONFIRMATION_TITLE = 'Exit Editor';
const ADVANCED_EXIT_CONFIRMATION_MESSAGE =
  'Are you sure you want to exit this editor? All of your current changes will be discarded.';
const ITERATION_TYPE_TO_FIELDS_MAP = {
  'paging.incrementing': [
    'param.id',
    'start.page.from',
    'end.page.to',
    'param.page.size',
    'page.expected.rows',
    'request.parallelism.count',
  ],
  'paging.incrementing.offset': [
    'param.offset',
    'start.offset.from',
    'end.offset.to',
    'param.page.size',
    'page.expected.rows',
  ],
  'paging.next.token': ['response.next.token.data.path', 'param.id', 'end.token.to'],
  'paging.next.url': ['response.next.url.data.path', 'end.url.to'],
  'link.header': ['link'],
  'response.id.number': [
    'param.id',
    'start.id.from',
    'end.id.to',
    'response.id.field.name',
    'param.id.inclusive',
  ],
  'response.id.string': ['param.id', 'start.id.from', 'end.id.to', 'response.id.field.name'],
  'graphql.page': ['graphql.page.name', 'graphql.page.start'],
  'graphql.cursor': [
    'graphql.cursor.name',
    'response.graphql.cursor.path',
    'graphql.cursor.template',
  ],
  'data.map.key.queue': ['map.id'],
  'async.poll': ['async.iteration.path', 'async.iteration.value'],
  'body.as.file': ['file.response.format'],
  'static.url': [],
};

const EMAIL_ENDPOINT_NAME = 'email_with_mode_selector';

const _getIterationKey = (dataMapId = null, stageIndex = -1) => {
  return dataMapId
    ? `${Constants.IterationPrefixes.DATA_MAP}${dataMapId}`
    : `${Constants.IterationPrefixes.STAGE}${stageIndex + 1}`;
};

export class AddDataSourceForm extends React.Component {
  static contextType = RoutePrefixContext;

  constructor(props) {
    super(props);

    this.state = {
      selectedTemplate: (() => {
        const { selectedCredentialInfo, selectedConnection } = props;
        const { templates } = props.selectedConnection
          ? props.paging.connAuthById[
              (selectedCredentialInfo && selectedCredentialInfo._vendorConnectionType) ||
                selectedConnection
            ]
          : {};
        return templates && templates.length ? templates[0].id : null;
      })(),
      apiResponseByStage: {},
      apiResponseUpdateTime: null,
      dataPathValidationResultByStage: {},
      soapDataPathValidationResult: null,
      selectCredentialAwaitingCreation: false,
      selectCredentialAwaitingProbe: false,
      scriptCredentialAwaitingCreation: false,
      restValidationStageIndex: -1,
      configureAPIAwaitingSample: false,
      configureAPIAwaitingDataPathValidation: false,
      configureAPIAwaitingDataSource: false,
      configureFileAwaitingDataSource: false,
      configureSyslogAwaitingDataSource: false,
      configureWebhookAwaitingDataSource: false,
      configureScriptAwaitingDataSource: false,
      configureSOAPAwaitingDataSource: false,
      configureTemplatizedAPIAwaitingDataSource: false,
      configureTemplatizedScriptAwaitingDataSource: false,
      configureKafkaAwaitingDataSource: false,
      configureFileUploadAwaitingDataSource: false,
      configureFileUploadAwaitingUpload: false,
      configureNexlaMonitorAwaitingDataSource: false,
      configureELTAwaitingDataSource: false,
      selectedFeeds: [],
      sourceName:
        props.sourceBeingEdited && has(props.sourceBeingEdited, 'name')
          ? props.sourceBeingEdited.name
          : props.addedDataSource
            ? props.addedDataSource.name
            : null,
      sourceDescription:
        props.sourceBeingEdited && has(props.sourceBeingEdited, 'description')
          ? props.sourceBeingEdited.description
          : props.addedDataSource
            ? props.addedDataSource.description
            : null,
      selectedFile: null,
      selectedFiles: [],
      redirectPath: null,
      isRedirecting: false,
      runWithIngestion: false,
      showSaveConfirmation: false,
      showAdvancedExitConfirmation: false,
      isSaving: false,
      pendingValidation: null,
      initialSourceConfig: null,
      initialApiConfig: null,
      initialTemplatizedScriptConfig: null,
      editedSamples: null,
      clusterId: props.sourceBeingEdited
        ? getClusterIdFromSource(props.sourceBeingEdited)
        : undefined,
      selectBucketRuntimeSectionVisible: true,
    };

    // Track credential ID for early intent calls when selectCredentialAwaitingProbe transitions
    this.probeCredentialIdRef = null;
    this.prevCredentialProbeStatusRef = null;
    // When true, skip auto-advance to next step after credential selection (e.g. edit mode)
    this.skipAutoRedirectionRef = { current: false };
    // Probe after creating a new credential (unified snackbar vs existing-credential probe)
    this.probeAfterNewCredentialRef = false;

    this._initializeCreateForm = this._initializeCreateForm.bind(this);
    this._initializeEditForm = this._initializeEditForm.bind(this);
    this._loadCredentials = this._loadCredentials.bind(this);
    this._handleConnectionSelected = this._handleConnectionSelected.bind(this);
    this._handleCredSelectionChanged = this._handleCredSelectionChanged.bind(this);
    this._handleCredentialFormInputChanged = this._handleCredentialFormInputChanged.bind(this);
    this._onBucketSelected = this._onBucketSelected.bind(this);
    this._onTableSelected = this._onTableSelected.bind(this);
    this._onCollectionSelected = this._onCollectionSelected.bind(this);
    this._onAPIConfigChanged = this._onAPIConfigChanged.bind(this);
    this._onSOAPConfigChanged = this._onSOAPConfigChanged.bind(this);
    this._onResetSOAPConfig = this._onResetSOAPConfig.bind(this);
    this._onTemplatizedAPIConfigChanged = this._onTemplatizedAPIConfigChanged.bind(this);
    this._onNexlaMonitorConfigChanged = this._onNexlaMonitorConfigChanged.bind(this);
    this._onTemplatizedScriptConfigChanged = this._onTemplatizedScriptConfigChanged.bind(this);
    this._onScriptCredentialInputChanged = this._onScriptCredentialInputChanged.bind(this);
    this._onSaveNewScriptCredential = this._onSaveNewScriptCredential.bind(this);
    this._onProbeClearSample = this._onProbeClearSample.bind(this);
    this._onProbeGetSample = this._onProbeGetSample.bind(this);
    this._onProbeTemplatizedAPI = this._onProbeTemplatizedAPI.bind(this);
    this._onProbeNexlaMonitor = this._onProbeNexlaMonitor.bind(this);
    this._onProbeDatabase = this._onProbeDatabase.bind(this);
    this._onProbeNoSQL = this._onProbeNoSQL.bind(this);

    this._onGetParameterizedURLs = this._onGetParameterizedURLs.bind(this);
    this._onAddRestStep = this._onAddRestStep.bind(this);
    this._onRemoveRestStep = this._onRemoveRestStep.bind(this);
    this._onRestValidationComplete = this._onRestValidationComplete.bind(this);
    this._onRequestSourceCreation = this._onRequestSourceCreation.bind(this);
    this._onRequestCredentialCreation = this._onRequestCredentialCreation.bind(this);
    this._onRequestCredentialProbe = this._onRequestCredentialProbe.bind(this);
    this._onRequestProbeTree = this._onRequestProbeTree.bind(this);
    this._onRequestInitialDBProbeTree = this._onRequestInitialDBProbeTree.bind(this);
    this._onToggleNodeProbeTree = this._onToggleNodeProbeTree.bind(this);
    this._onProbeGetWSDL = this._onProbeGetWSDL.bind(this);
    this._onProbeCallSOAP = this._onProbeCallSOAP.bind(this);

    this._onMetaInfoChanged = this._onMetaInfoChanged.bind(this);
    this._onWebhookMetaInfoChanged = this._onWebhookMetaInfoChanged.bind(this);
    this._onWebhookSourceCreate = this._onWebhookSourceCreate.bind(this);
    this._onEmailSourceCreate = this._onEmailSourceCreate.bind(this);
    this._onFileUploadFileSelected = this._onFileUploadFileSelected.bind(this);
    this._onFileUploadFilesSelected = this._onFileUploadFilesSelected.bind(this);
    this._onFileUploadFileRemoved = this._onFileUploadFileRemoved.bind(this);
    this._handleSourceConfigChanged = this._handleSourceConfigChanged.bind(this);
    this._handleFormDataUpdate = this._handleFormDataUpdate.bind(this);

    this._buildSourceConfigFromDefaults = this._buildSourceConfigFromDefaults.bind(this);
    this._buildSourceConfigFromProps = this._buildSourceConfigFromProps.bind(this);
    this._getFormDataFromCredential = this._getFormDataFromCredential.bind(this);
    this._getDataPathFromAPIConfig = this._getDataPathFromAPIConfig.bind(this);
    this._getNonDataMapIterations = this._getNonDataMapIterations.bind(this);
    this._getPipelineFormPath = this._getPipelineFormPath.bind(this);

    this._validateSelectConnection = this._validateSelectConnection.bind(this);
    this._validateSelectCredential = this._validateSelectCredential.bind(this);
    this._validateConfigureRestSource = this._validateConfigureRestSource.bind(this);
    this._validateConfigureRestSourceRequiredFields =
      this._validateConfigureRestSourceRequiredFields.bind(this);
    this._validateConfigureWebhookSource = this._validateConfigureWebhookSource.bind(this);
    this._validateConfigureEmailScriptSource = this._validateConfigureEmailScriptSource.bind(this);

    this._createFileDataSource = this._createFileDataSource.bind(this);
    this._validateConfigureFileUploadSource = this._validateConfigureFileUploadSource.bind(this);
    this._validateConfigureSyslogSource = this._validateConfigureSyslogSource.bind(this);

    this._validateConfigureSOAPSource = this._validateConfigureSOAPSource.bind(this);
    this._validateConfigureTemplatizedAPISource =
      this._validateConfigureTemplatizedAPISource.bind(this);
    this._validateConfigureTemplatizedScriptSource =
      this._validateConfigureTemplatizedScriptSource.bind(this);
    this._validateDataPath = this._validateDataPath.bind(this);
    this._validateSOAPDataPath = this._validateSOAPDataPath.bind(this);
    this._validateConfigureKafkaSource = this._validateConfigureKafkaSource.bind(this);
    this._validateConfigureFileSource = this._validateConfigureFileSource.bind(this);
    this._validateConfigureELTSource = this._validateConfigureELTSource.bind(this);
    this._validateRequiredFields = this._validateRequiredFields.bind(this);
    this._validateNexlaMonitorFields = this._validateNexlaMonitorFields.bind(this);
    this._validateNexlaMonitorSource = this._validateNexlaMonitorSource.bind(this);

    this._handleFormDismissed = this._handleFormDismissed.bind(this);

    this._getNexlaMonitorConfig = this._getNexlaMonitorConfig.bind(this);
    this._form = null;
  }

  async componentDidMount() {
    const {
      paging: { metaInfoById },
      sourceBeingEditedId,
      sourceBeingEdited,
      isLoadingInitialData,
      dataMapsLastUpdated,
      loadDataSource,
      vendors,
      loadDataMaps,
      parentDataSet,
      parentDataSetSamples,
    } = this.props;

    if (sourceBeingEditedId) {
      const needsSourceDetail =
        !sourceBeingEdited || !sourceBeingEdited.source_config || !sourceBeingEdited?.flow_triggers;

      if (needsSourceDetail && !this.props.isLoadingDataSource) {
        loadDataSource(sourceBeingEditedId, {
          aclQueryMode: ACLQueryModeTypes.MODE_COLLABORATOR.key,
        });
      } else if (
        sourceBeingEdited &&
        sourceBeingEdited.source_type &&
        metaInfoById[sourceBeingEdited.source_type]?.connectionCategory ===
          CONNECTION_CATEGORY_REST &&
        !dataMapsLastUpdated
      ) {
        loadDataMaps(false, ACLQueryModeTypes.MODE_COLLABORATOR.key);
      }
    }

    if (sourceBeingEdited && sourceBeingEdited?.vendor_id) {
      const vendor = vendors?.[sourceBeingEdited?.vendor_id];
      const vendorName = vendor?.name;
      if (vendorName) {
        this.loadVendorInfo(vendorName).then(() => {
          this.setState({
            selectedTemplate: this.getInitialTemplate(),
          });
          this._initializeEditForm();
        });
      }
    }

    if (!isLoadingInitialData) {
      this._loadCredentials();

      if (sourceBeingEditedId) {
        this._initializeEditForm();
      } else {
        // Check for modal queryParams first, then URL parameters to pre-select connection
        const preselectedConnection =
          this.props.queryParams?.selectedConnection ||
          new URLSearchParams(window.location.search).get('connection');

        if (preselectedConnection) {
          this.loadVendorInfo(preselectedConnection);
          this._initializeCreateForm(preselectedConnection, true, true, 1);
        } else {
          this._initializeCreateForm();
        }
      }
    }
    this.props.setContextualSupport(SUPPORT_KEY_SOURCE_FORM_COMMON);

    this._initializeChangeDetection();
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      dataMapSamples,
      dataMapsLastUpdated,
      selectedConnection,
      paging,
      credentialCreationStatus,
      credentialProbeStatus,
      probeSample,
      addedDataSource,
      sourceBeingEditedId,
      sourceBeingEdited,
      isLoadingInitialData,
      lastFileUploaded,
      loadDataMaps,
      vendors,
      loadDataMapSamples,
    } = this.props;
    const { metaInfoById } = paging;
    const {
      dataPathValidationResultByStage,
      selectCredentialAwaitingCreation,
      selectCredentialAwaitingProbe,
      scriptCredentialAwaitingCreation,
      configureAPIAwaitingSample,
      configureAPIAwaitingDataPathValidation,
      configureAPIAwaitingDataSource,
      configureFileAwaitingDataSource,
      configureSyslogAwaitingDataSource,
      configureWebhookAwaitingDataSource,
      configureSOAPAwaitingDataSource,
      configureTemplatizedAPIAwaitingDataSource,
      configureTemplatizedScriptAwaitingDataSource,
      configureKafkaAwaitingDataSource,
      configureELTAwaitingDataSource,
      configureScriptAwaitingDataSource,
      configureFileUploadAwaitingDataSource,
      configureFileUploadAwaitingUpload,
      configureNexlaMonitorAwaitingDataSource,
    } = this.state;

    const prevSelectCredentialAwaitingProbe = prevState.selectCredentialAwaitingProbe;

    if (
      credentialProbeStatus &&
      credentialProbeStatus?.isValid &&
      credentialProbeStatus?.credential === this.probeCredentialIdRef
    ) {
      this.prevCredentialProbeStatusRef = credentialProbeStatus;
    }
    // Only call setEarlyIntent when probe transitions from true to false AND probe was successful
    if (
      prevSelectCredentialAwaitingProbe &&
      !selectCredentialAwaitingProbe &&
      this.probeCredentialIdRef &&
      this.prevCredentialProbeStatusRef &&
      this.prevCredentialProbeStatusRef &&
      this.prevCredentialProbeStatusRef?.credential === this.probeCredentialIdRef
    ) {
      this.prevCredentialProbeStatusRef = null;
      this.setEarlyIntent(this.probeCredentialIdRef);
    }

    const selectedConnectionMeta = selectedConnection
      ? paging.metaInfoById[selectedConnection]
      : null;

    const isEditingRESTSource =
      sourceBeingEdited &&
      sourceBeingEdited.source_type &&
      paging.metaInfoById[sourceBeingEdited.source_type] &&
      paging.metaInfoById[sourceBeingEdited.source_type].connectionCategory ===
        CONNECTION_CATEGORY_REST;

    /**
     * Sync the cluster ID from the edited source to the state.
     */
    const previousEditedSourceClusterId = getClusterIdFromSource(prevProps.sourceBeingEdited);
    const clusterIdFromLoadedSource = getClusterIdFromSource(sourceBeingEdited);
    const shouldSyncClusterIdFromEditedSource =
      sourceBeingEditedId &&
      sourceBeingEdited &&
      previousEditedSourceClusterId !== clusterIdFromLoadedSource;

    if (shouldSyncClusterIdFromEditedSource) {
      const clusterId = clusterIdFromLoadedSource ?? null;
      this.setState({ clusterId });
    }

    if (
      sourceBeingEdited?.vendor_id !== prevProps.sourceBeingEdited?.vendor_id &&
      !this.props.loadingVendorInfo
    ) {
      const vendor = vendors?.[sourceBeingEdited?.vendor_id];
      const vendorName = vendor?.name;
      if (vendorName) {
        this.loadVendorInfo(vendorName).then(() => {
          this.setState({
            selectedTemplate: this.getInitialTemplate(),
          });
          if (!this.props.isLoadingInitialData) {
            this._initializeEditForm();
          }
        });
      }
    }

    // init edit form from the loaded source
    if (prevProps.isLoadingInitialData && !isLoadingInitialData) {
      this._loadCredentials();

      if (sourceBeingEditedId) {
        // load data map samples
        if (isEditingRESTSource) {
          _.forEach(sourceBeingEdited.source_config['rest.iterations'], (iteration) => {
            if (
              iteration['iteration.type'] === 'data.map.key.queue' &&
              !has(dataMapSamples, iteration['map.id'])
            ) {
              loadDataMapSamples(iteration['map.id'], 1, 5);
            }
          });
        }

        this._initializeEditForm();
      } else {
        this._initializeCreateForm();
      }
    }

    // If vendor_endpoint arrived after initial load completed, re-init
    // to pick up the endpoint data for the dropdown.
    const becameReadyAfterInitialLoad = prevProps.isLoadingInitialData && !isLoadingInitialData;
    if (
      sourceBeingEditedId &&
      !isLoadingInitialData &&
      !becameReadyAfterInitialLoad &&
      didVendorEndpointJustArrive(prevProps.sourceBeingEdited, sourceBeingEdited)
    ) {
      this._initializeEditForm();
    }

    // load data maps
    if (
      isEditingRESTSource &&
      sourceBeingEdited !== prevProps.sourceBeingEdited &&
      !dataMapsLastUpdated
    ) {
      loadDataMaps(false, ACLQueryModeTypes.MODE_COLLABORATOR.key);
    }
    // extract api response
    if (
      selectedConnectionMeta &&
      (selectedConnectionMeta.connectionCategory === CONNECTION_CATEGORY_NEXLA_MONITOR ||
        selectedConnectionMeta.connectionCategory === CONNECTION_CATEGORY_REST ||
        (selectedConnectionMeta.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API &&
          selectedConnectionMeta.connectionTypeCategory === CONNECTION_CATEGORY_REST)) &&
      probeSample
    ) {
      const isRest =
        selectedConnectionMeta.connectionCategory === CONNECTION_CATEGORY_REST ||
        selectedConnectionMeta.connectionCategory === CONNECTION_CATEGORY_NEXLA_MONITOR ||
        (selectedConnectionMeta.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API &&
          selectedConnectionMeta.connectionTypeCategory === CONNECTION_CATEGORY_REST);

      // api response formatting
      if (!_.isEqual(probeSample, prevProps.probeSample)) {
        const apiResponseByStage = _.mapValues(probeSample, (stageProbeSample, stageIndex) => {
          const { response, error } = stageProbeSample;
          let contentType;

          if (response) {
            const { response: responseString, statusCode } = response.output;
            const responseCode = statusCode;

            if (statusCode > 0 && statusCode < 400) {
              contentType = response.output.contentType;
              const prettyResponse = formatCode(responseString, contentType);

              if (isRest && !_.isNaN(parseInt(stageIndex, 10))) {
                this._onAPIConfigChanged('contentType', contentType, stageIndex);
              }

              const apiResponseParsedContent = JSONUtils.parseJson(prettyResponse);

              const apiResponseContentLength =
                apiResponseParsedContent &&
                (Array.isArray(apiResponseParsedContent)
                  ? apiResponseParsedContent.length
                  : typeof apiResponseParsedContent === 'object'
                    ? Object.values(apiResponseParsedContent)?.[0]?.length
                    : null);

              // The body is in `response`; surface the remaining probe-output
              // attributes (status, content type, any response headers, etc.) in
              // the Headers tab. Prefer real headers if the service returns them.
              const responseMeta = { ...response.output };
              delete responseMeta.response;

              return {
                apiResponseContent: prettyResponse,
                apiResponseContentLength,
                apiResponseContentType: contentType,
                apiResponseCode: responseCode,
                apiResponseMessage: '',
                apiResponseHeaders:
                  response.output.responseHeaders || response.output.headers || responseMeta,
              };
            }
            // 3rd party API error
            return {
              apiResponseContent: responseString,
              apiResponseContentLength: null,
              apiResponseContentType: 'text/plain',
              apiResponseCode: responseCode,
              apiResponseMessage: response.output.errorMessage,
            };
          } else if (error) {
            const responseCode = error.code;
            return {
              apiResponseContent: '',
              apiResponseContentLength: null,
              apiResponseContentType: 'text/plain',
              apiResponseCode: responseCode || 500,
              apiResponseMessage: 'Please check the URL or try again later',
            };
          }

          return {
            apiResponseContent: '',
            apiResponseContentLength: null,
            apiResponseContentType: 'text/plain',
            apiResponseCode: null,
            apiResponseMessage: null,
          };
        });
        let now = Date.now();

        this.setState({ apiResponseByStage, apiResponseUpdateTime: now }, () => {
          // resume api config validation
          if (isRest && this.state.configureAPIAwaitingSample) {
            this._boundValidateConfigureRestSource();
          }
        });
      } else if (isRest && configureAPIAwaitingSample) {
        // resume api config validation even if sample hasn't changed
        this._boundValidateConfigureRestSource();
      }
    }

    // resume credential validation
    if (
      (selectCredentialAwaitingCreation &&
        credentialCreationStatus &&
        credentialCreationStatus.credential &&
        credentialCreationStatus !== prevProps.credentialCreationStatus) ||
      (selectCredentialAwaitingProbe &&
        credentialProbeStatus &&
        credentialProbeStatus.credential &&
        credentialProbeStatus !== prevProps.credentialProbeStatus)
    ) {
      this._boundValidateSelectCredential();
    }

    if (
      scriptCredentialAwaitingCreation &&
      credentialCreationStatus &&
      credentialCreationStatus.credential &&
      credentialCreationStatus !== prevProps.credentialCreationStatus
    ) {
      this._boundSaveNewScriptCredential();
    }

    // resume api config validation
    if (
      (configureAPIAwaitingDataSource && addedDataSource) ||
      (configureAPIAwaitingDataPathValidation &&
        dataPathValidationResultByStage &&
        dataPathValidationResultByStage !== prevState.dataPathValidationResultByStage)
    ) {
      this._boundValidateConfigureRestSource();
    }

    // resume file upload validation
    const isAddedDataSourceActiveOrPaused =
      addedDataSource &&
      [Constants.SourceStatus.ACTIVE, Constants.SourceStatus.PAUSED].includes(
        addedDataSource.status,
      );
    const hasNewFileUploaded = lastFileUploaded !== prevProps.lastFileUploaded;

    if (
      (configureFileUploadAwaitingDataSource && isAddedDataSourceActiveOrPaused) ||
      (configureFileUploadAwaitingUpload && hasNewFileUploaded)
    ) {
      this._boundValidateConfigureFileUploadSource();
    }

    // resume file config validation
    if (configureFileAwaitingDataSource && addedDataSource) {
      this._boundValidateConfigureFileSource();
    }

    if (configureSyslogAwaitingDataSource && addedDataSource) {
      this._boundValidateConfigureSyslogSource();
    }

    if (configureWebhookAwaitingDataSource && addedDataSource) {
      this._boundValidateConfigureWebhookSource();
    }

    if (configureScriptAwaitingDataSource && addedDataSource) {
      this._boundValidateConfigureScriptSource();
    }

    if (configureSOAPAwaitingDataSource && addedDataSource) {
      this._boundValidateConfigureSOAPSource();
    }

    if (configureTemplatizedAPIAwaitingDataSource && addedDataSource) {
      this._boundValidateConfigureTemplatizedAPISource();
    }

    if (configureTemplatizedScriptAwaitingDataSource && addedDataSource) {
      this._boundValidateConfigureTemplatizedScriptSource();
    }

    if (configureKafkaAwaitingDataSource && addedDataSource) {
      this._boundValidateConfigureKafkaSource();
    }

    if (configureNexlaMonitorAwaitingDataSource && addedDataSource) {
      this._boundValidateConfigureNexlaMonitorSource();
    }

    if (configureELTAwaitingDataSource && addedDataSource) {
      this._boundValidateConfigureELTSource();
    }
  }

  componentWillUnmount() {
    this.props.probeClearAll();
    this.props.unsetContextualSupport(SUPPORT_KEY_SOURCE_FORM_COMMON);
  }

  // API Server targets (created under a parent Nexset) may use action endpoints; ETL sources can't
  _getEndpointFlowType() {
    return getEndpointFlowType({
      flowType: this.props.flowType,
      isAPIServerTarget: !!this.props.parentDataSet,
    });
  }

  getInitialTemplate() {
    const { selectedCredentialInfo, selectedConnection } = this.props;
    const { templates } = this.props.selectedConnection
      ? this.props.paging.connAuthById[
          (selectedCredentialInfo && selectedCredentialInfo._vendorConnectionType) ||
            selectedConnection
        ]
      : {};
    return templates && templates.length ? templates[0].id : null;
  }

  _initializeCreateForm(
    connectionType = null,
    resetCredential = true,
    resetValidationStatus = true,
    targetStage = null,
  ) {
    const selectedConnection = connectionType || this.props.selectedConnection;
    const sourceConfig = selectedConnection
      ? this._buildSourceConfigFromDefaults(selectedConnection, true)
      : null;
    const defaultIteration = {
      isPaginated: false,
      'iteration.type': 'paging.incrementing',
      'request.parallelism.count': 1,
      method: 'GET',
      'date.format': 'yyyy-MM-dd',
      'date.time.unit': 'dd',
    };
    defaultIteration.key = this._getIterationKeyFromIteration(defaultIteration, 0);
    const resetFields = ['credentialCreationStatus', 'credentialProbeStatus', 'selectedBucket'];

    if (resetCredential) {
      resetFields.push('selectedCredential', 'selectedCredentialId', 'selectedCredentialInfo');
    }

    this.props.resetFormData(FORM_TYPE_CREATE_DATA_SOURCE, resetFields, resetValidationStatus);

    const formData = {
      selectedConnection,
      sourceConfig,
      apiConfig: {
        'rest.iterations': [defaultIteration],
      },
      soapConfig: {
        params: [],
      },
      nexlaMonitorApiConfig: {},
      // Seed the default schedule so a re-initialized config (e.g. re-selecting a
      // connector after going back to Select) behaves like a fresh source. Without
      // this, templatizedAPIConfig resets to {} and the schedule control no longer
      // writes a default on mount (NEX-21476), so the required "Fetch data"
      // (start.cron) field is empty → validation fails. Skip api-server targets,
      // which don't show scheduling.
      templatizedAPIConfig: this.props.parentDataSet
        ? {}
        : { 'start.cron': FlowTriggerHelper.getDefaultOnceCron() },
      templatizedScriptConfig: {},
      scriptCredentialsData: {},
      discoveryResults: {
        allFeedsFetched: false,
        availableFeeds: [],
        discoveryErrors: [],
      },
    };

    // select the default script endpoint
    const meta = this.props.paging.metaInfoById[selectedConnection];
    const sourceConfigFields = this.props.paging.sourceConfigById[selectedConnection];
    const endpointField = _.find(sourceConfigFields, {
      name: 'vendor_endpoint_id',
    });

    if (
      meta &&
      (meta.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT ||
        meta.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT)
    ) {
      let endpointId;

      if (endpointField) {
        if (meta.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT) {
          // ETL sources never auto-select an action endpoint (API Server targets may)
          const scriptOptions = filterActionEndpointOptions(endpointField.options, {
            flowType: this._getEndpointFlowType(),
          });
          if (scriptOptions.length === 1) {
            endpointId = scriptOptions[0].value;
          }
        } else {
          //TODO: This is a hack, we should probably handle supporting different endpoints
          const endpointOption = _.find(
            endpointField.options,
            (option) =>
              this.props.vendorEndpoints[option.value] &&
              this.props.vendorEndpoints[option.value].name === EMAIL_ENDPOINT_NAME,
          );
          endpointId = endpointOption && endpointOption.value;
        }
      }

      if (endpointId) {
        formData.templatizedScriptConfig = UIUtils.configWithMissingDefaults(
          { vendor_endpoint_id: endpointId },
          sourceConfigFields,
        );
      }
    } else if (
      meta &&
      meta.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API &&
      endpointField &&
      !_.isEmpty(endpointField.options)
    ) {
      // select the first endpoint (options are already in display order); ETL sources skip
      // action endpoints, API Server targets may default to one
      const [defaultOption] = filterActionEndpointOptions(endpointField.options, {
        flowType: this._getEndpointFlowType(),
      });
      if (defaultOption) {
        formData.templatizedAPIConfig = UIUtils.configWithMissingDefaults(
          { vendor_endpoint_id: defaultOption.value },
          sourceConfigFields,
        );
        // FrequencyFieldRedesign only auto-dispatches its default on first mount; on
        // subsequent connector switches the picker does not remount, so a freshly
        // reset templatizedAPIConfig leaves start.cron undefined while the picker
        // still shows a cron visually — and _validateRequiredFields then reports
        // "Fetch Data" missing. Seed it here so picker state and redux stay aligned.
        const restCronField = this.props.paging.sourceConfigById.rest?.find(
          (field) => field.name === 'start.cron',
        );
        if (
          restCronField &&
          !this.props.parentDataSet &&
          !has(formData.templatizedAPIConfig, 'start.cron')
        ) {
          formData.templatizedAPIConfig['start.cron'] = UIUtils.getCron(
            UIUtils.getCurrentDateAndTime('Day'),
          );
        }
      }
    } else if (meta && meta.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API_MULTI) {
      // set default vendor_endpoint_id for TEMPLATIZED_API_MULTI
      const { vendorId } = meta;
      const defaultEndpoint = getDefaultDataEndpoint(
        _.values(
          _.pick(this.props.vendorEndpoints, this.props.vendors[vendorId]?.vendor_endpoints),
        ),
        { flowType: this._getEndpointFlowType() },
      );

      if (defaultEndpoint) {
        formData.sourceConfig = {
          ...formData.sourceConfig,
          vendor_endpoint_id: defaultEndpoint.id,
        };
        formData.templateConfig = UIUtils.configWithMissingDefaults(
          { vendor_endpoint_id: defaultEndpoint.id },
          sourceConfigFields,
        );
      }
    } else if (meta && meta.connectionCategory === CONNECTION_CATEGORY_FILE) {
      formData.sourceConfig = {
        ...formData.sourceConfig,
        'ignore.files.older.than.ms': Date.now() - 7 * 24 * 3600 * 1000,
      };
    } else if (
      meta?.connectionCategory === CONNECTION_CATEGORY_DATABASE &&
      this.props.parentDataSet
    ) {
      formData.sourceConfig = {
        ...formData.sourceConfig,
        db_query_mode: 'Query',
      };
    } else if (meta && meta.connectionCategory === CONNECTION_CATEGORY_NEXLA_MONITOR) {
      let template = _.get(this.props.nmTemplates, `${meta.connectionCategory}.[0]`, {});
      let templateFields = _.get(template, 'fields', []);
      formData.nexlaMonitorApiConfig = UIUtils.configWithMissingDefaults(
        { template },
        templateFields,
      );
    }

    this.props.updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, formData, resetValidationStatus);

    // Set the target stage if specified (for URL parameter pre-selection)
    if (targetStage !== null && targetStage > 0) {
      this.props.setFormStageIndex(FORM_TYPE_CREATE_DATA_SOURCE, targetStage);
    }

    const { selectedCredentialInfo, paging } = this.props;

    let effectiveConnectionType =
      (selectedCredentialInfo && selectedCredentialInfo._vendorConnectionType) ||
      selectedConnection;

    const { templates, items } = selectedConnection
      ? paging.connAuthById[effectiveConnectionType]
      : {};

    this.setState({
      connectionAuthFields: this.getActiveItems(templates, items),
      selectedTemplate: this.getInitialTemplate(),
      apiResponseByStage: {},
      apiResponseUpdateTime: null,
      dataPathValidationResultByStage: {},
      soapDataPathValidationResult: null,
      clusterId: undefined,
      selectBucketRuntimeSectionVisible: true,
    });
  }

  _initializeEditForm() {
    // initialize form state
    const {
      sourceBeingEdited,
      sourceBeingEdited: { source_config, data_credentials, data_credentials_id, flow_triggers },
      credentials,
      paging: { metaInfoById, sourceConfigById },
      updateFormData,
      setFormStageIndex,
      dataMaps,
      vendors,
      nmTemplates,
    } = this.props;
    const sourceConfig = { ...source_config };
    const credentialId = data_credentials || data_credentials_id;
    const selectedCredential = credentials[credentialId];

    const connectionOrVendorType = getConnectionOrVendorType(
      sourceBeingEdited,
      vendors,
      'source_type',
      'vendor_id',
    );
    const behaviorType = isSqlAutomation(sourceBeingEdited, vendors)
      ? 'sql_runner'
      : connectionOrVendorType;

    const connectionInfo =
      behaviorType && has(metaInfoById, behaviorType) ? metaInfoById[behaviorType] : null;
    const connectionCategory =
      connectionInfo && has(connectionInfo, 'connectionCategory')
        ? connectionInfo.connectionCategory
        : null;

    // If the source has a vendor_endpoint at root, wait for vendor endpoint
    // details to load before initializing the form (loadVendorInfo().then()
    // will call _initializeEditForm again when ready).
    if (hasVendorEndpoint(sourceBeingEdited) && this.props.loadingVendorInfo) {
      return;
    }

    const formData = {
      selectedConnection: behaviorType,
      displayConnectionType: connectionOrVendorType,
      sourceConfig,
      selectedCredentialId: credentialId,
      selectedCredential,
    };

    switch (connectionCategory) {
      case CONNECTION_CATEGORY_REST:
      case CONNECTION_CATEGORY_TEMPLATIZED_API:
        // update legacy source config
        if (!has(sourceConfig, 'rest.iterations')) {
          const iteration = _.omit(sourceConfig, 'start.cron');

          formData.apiConfig = {
            'start.cron': sourceConfig['start.cron'],
            'rest.iterations': [
              {
                ...iteration,
                key: this._getIterationKeyFromIteration(iteration, 0),
              },
            ],
          };
        } else {
          //get the dataMaps out as dataMapIds.
          let restIterations = sourceConfig['rest.iterations'];
          if (_.isString(restIterations)) {
            restIterations = JSONUtils.parseJson(restIterations);
          }
          let dataMapIds = [];
          let modifiedIterations = this._getNonDataMapIterations(restIterations);

          modifiedIterations = _.map(modifiedIterations, (itStage) => {
            const newIteration = { ...itStage };

            // set default date.format and date.time.unit in old sources
            if (!newIteration['date.format']) {
              newIteration['date.format'] = 'yyyy-MM-dd';
            }

            if (!newIteration['date.time.unit']) {
              newIteration['date.time.unit'] = 'dd';
            }

            if (newIteration['response.data.path.additional']) {
              newIteration['response.data.path.additional'] = _.join(
                newIteration['response.data.path.additional'],
              );
            }

            return newIteration;
          });
          //TODO: legacy data map iteration (from v1.6)
          let hasLegacyDM = false;
          let lookupKey = null;
          _.each(restIterations, (itStage, idx) => {
            if (
              has(itStage, 'iteration.type') &&
              itStage['iteration.type'] === 'data.map.key.queue'
            ) {
              dataMapIds.push(itStage['map.id']);
              //legacy data map iteration (from v1.6)
              if (itStage.key === 'dm1') {
                let key = this._getIterationKeyFromIteration(itStage);
                lookupKey = key;
                hasLegacyDM = true;
                modifiedIterations.push({ ...itStage, key });
              } else {
                modifiedIterations.push(itStage);
              }
            }
          });

          if (hasLegacyDM === true && lookupKey) {
            //legacy data map iteration (from v1.6)
            modifiedIterations = _.map(modifiedIterations, (itStage) => {
              if (
                has(itStage, 'iteration.type') &&
                itStage['iteration.type'] !== 'data.map.key.queue' &&
                has(itStage, 'url.template')
              ) {
                let urlTemplate = itStage['url.template'];
                //replace {dm1. in template with {lookupKey.
                urlTemplate = _.replace(urlTemplate, '{dm1.', `{${lookupKey}.`);
                return { ...itStage, 'url.template': urlTemplate };
              } else {
                return itStage;
              }
            });
          }

          dataMapIds = _.map(dataMapIds, (m) => {
            if (dataMaps && has(dataMaps, m)) {
              return {
                label: dataMaps[m].name,
                value: m,
              };
            } else {
              return {
                label: m,
                value: m,
              };
            }
          });

          let dataMapKeys = {};
          if (dataMaps) {
            _.each(dataMapIds, (m) => {
              let selectedDataMap = has(dataMaps, m.value) ? dataMaps[m.value] : null;

              let thisMapKeys = has(selectedDataMap, 'map_entry_schema.properties')
                ? _.keys(selectedDataMap.map_entry_schema.properties)
                : [];
              let keyName = _getIterationKey(m.value);
              dataMapKeys[keyName] = thisMapKeys;
            });
          }

          formData.apiConfig = {
            ...sourceConfig,
            'rest.iterations': modifiedIterations,
            dataMapIds,
            dataMapKeys,
          };
        }

        formData.apiConfig['rest.iterations'] = _.map(
          formData.apiConfig['rest.iterations'],
          (iteration) => ({
            ...iteration,
            isPaginated:
              iteration['iteration.type'] &&
              iteration['iteration.type'] !== 'data.map.key.queue' &&
              iteration['iteration.type'] !== 'static.url',
          }),
        );

        // templatized API
        formData.templatizedAPIConfig =
          UIUtils.buildTemplatizedAPIConfigFromSource(sourceBeingEdited);
        break;

      case CONNECTION_CATEGORY_TEMPLATIZED_API_MULTI:
        {
          const service = createELTService(flowTypes.streaming);

          formData.sourceConfig = {
            ...(sourceBeingEdited?.template_config?.params || {}),
            vendor_endpoint_id: sourceBeingEdited.vendor_endpoint,
            'start.cron': sourceBeingEdited?.template_config?.['start.cron'],
          };

          let selectedFeeds = service.buildSelectFeeds(
            sourceBeingEdited,
            this.props.paging.sourceConfigById[formData.selectedConnection],
          );
          formData.selectedFeeds = selectedFeeds;
        }
        break;
      case CONNECTION_CATEGORY_SOAP:
        const soapConfig = _.omit(sourceConfig, ['soap.params', 'soap.port.type']);
        const soapParams = _.map(sourceConfig['soap.params'], (value, path) => ({
          path,
          value,
        }));
        soapConfig.params = _.sortBy(soapParams, ['path']);

        formData.soapConfig = soapConfig;
        break;

      case CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT:
      case CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT:
        const vendor = vendors?.[sourceBeingEdited?.vendor_id];
        const isSqlRunner = vendor?.name === CONNECTOR_CODE_SQL_RUNNER;
        const { templatizedScriptConfig, scriptCredentialsData } = isSqlRunner
          ? UIUtils.buildTemplatizedScriptConfigFromSqlRunnerSource(
              sourceBeingEdited,
              sourceConfigById[formData.selectedConnection],
              credentials,
            )
          : UIUtils.buildTemplatizedScriptConfigFromSource(
              sourceBeingEdited,
              sourceConfigById[formData.selectedConnection],
              credentials,
            );
        formData.templatizedScriptConfig = templatizedScriptConfig;
        formData.scriptCredentialsData = scriptCredentialsData;
        break;

      case CONNECTION_CATEGORY_FILE:
        const { bucket, prefix, path, 'ui.display_path': displayPath } = sourceConfig;
        let effectivePath;

        if (path) {
          effectivePath = path;
        } else if (bucket) {
          effectivePath = bucket;

          if (prefix) {
            const separator = effectivePath.endsWith('/') || prefix.startsWith('/') ? '' : '/';
            effectivePath += `${separator}${prefix}`;
          }
        }

        if (effectivePath) {
          const id = effectivePath;
          const lastSlashIndex = id.lastIndexOf('/');
          const name = id.substr(lastSlashIndex + 1);
          const parent = lastSlashIndex > -1 ? id.substr(0, lastSlashIndex) : null;
          const numSlashes = (id.match(/\//g) || []).length;
          const level = numSlashes + 1;

          formData.selectedBucket = {
            id,
            path: effectivePath,
            displayPath: displayPath || effectivePath,
            name,
            parent,
            scanned: false,
            open: false,
            error: null,
            level,
            children: [],
          };
        }

        // update sourceConfig of legacy sources
        formData.sourceConfig = _.omit(formData.sourceConfig, ['bucket', 'prefix']);
        formData.sourceConfig.path = effectivePath;

        if (displayPath) {
          formData.sourceConfig['ui.display_path'] = displayPath;
        }

        break;

      case CONNECTION_CATEGORY_NEXLA_MONITOR:
        let nexlaMonitorApiConfig = _.cloneDeep(sourceConfig);
        let tempalateID = _.get(nexlaMonitorApiConfig, 'uiconfig.template', null);
        let advanced_templatized_api = _.get(
          nexlaMonitorApiConfig,
          'advanced_templatized_api',
          false,
        );
        let uiConfigParams = _.get(nexlaMonitorApiConfig, 'uiconfig', {});
        let template = {};
        if (tempalateID) {
          let templates = _.get(nmTemplates, connectionCategory, []);
          template = _.find(templates, (template) => template.id === tempalateID);
        }
        formData.nexlaMonitorApiConfig = {
          ...uiConfigParams,
          template,
          advanced_templatized_api,
        };
        formData.apiConfig = {
          ...nexlaMonitorApiConfig,
        };
        if (
          has(formData.apiConfig, 'uiconfig') &&
          has(formData.apiConfig.uiconfig, 'advanced_templatized_api')
        ) {
          formData.apiConfig = {
            ...formData.apiConfig,
            uiconfig: {
              ...formData.apiConfig.uiconfig,
              advanced_templatized_api,
            },
          };
        }
        formData.sourceConfig = {
          ...formData.sourceConfig,
        };
        break;

      case CONNECTION_CATEGORY_NOSQL:
        // NSTODO: we are forcing a default mode of '' for nosql that should be stripped out

        // if (sourceConfig.db_query_mode === 'Query') {
        //   formData.sourceConfig.mode = 'Query';
        // }

        if (!sourceConfig.mode) {
          formData.sourceConfig.mode = 'default';
        }
        break;
      default:
    }

    if (
      (connectionCategory === CONNECTION_CATEGORY_FILE ||
        connectionCategory === CONNECTION_CATEGORY_FILE_UPLOAD) &&
      formData.sourceConfig
    ) {
      const existingCustomProcessorId = getExistingReusableCustomProcessorId(sourceBeingEdited);

      if (existingCustomProcessorId) {
        formData.sourceConfig.customProcessorId = existingCustomProcessorId;
      }
    }

    // add flow triggers to the config
    const hasFlowTriggers = Array.isArray(flow_triggers) && flow_triggers.length > 0;

    const applyFlowTriggers = (config) => {
      return hasFlowTriggers ? { ...config, flow_triggers } : config;
    };

    if (formData.sourceConfig) {
      formData.sourceConfig = applyFlowTriggers(formData.sourceConfig);
    }

    if (formData.apiConfig) {
      formData.apiConfig = applyFlowTriggers(formData.apiConfig);
    }

    if (formData.templatizedAPIConfig) {
      formData.templatizedAPIConfig = applyFlowTriggers(formData.templatizedAPIConfig);
    }

    if (formData.templatizedScriptConfig) {
      formData.templatizedScriptConfig = applyFlowTriggers(formData.templatizedScriptConfig);
    }

    if (formData.nexlaMonitorApiConfig) {
      formData.nexlaMonitorApiConfig = applyFlowTriggers(formData.nexlaMonitorApiConfig);
    }

    if (formData.soapConfig) {
      formData.soapConfig = applyFlowTriggers(formData.soapConfig);
    }

    const formStageIndex =
      connectionCategory === CONNECTION_CATEGORY_WEBHOOK ||
      connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT ||
      connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT ||
      connectionCategory === CONNECTION_CATEGORY_FILE_UPLOAD ||
      connectionCategory === CONNECTION_CATEGORY_SYSLOG
        ? 1
        : 2;
    updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, formData);
    setFormStageIndex(FORM_TYPE_CREATE_DATA_SOURCE, formStageIndex);

    this.setState({
      sourceName: sourceBeingEdited.name,
      sourceDescription: sourceBeingEdited?.description,
      selectedTemplate:
        selectedCredential?.auth_template?.id || selectedCredential?.auth_template_id,
      clusterId: getClusterIdFromSource(sourceBeingEdited),
    });

    // Initialize change detection after form is set up
    setTimeout(() => {
      this._initializeChangeDetection();
    }, 0);
  }

  _loadCredentials() {
    this.props.loadDataCredentials(ACLQueryModeTypes.MODE_COLLABORATOR.key);
  }

  //Action calls from each form state
  //1. select a connection
  _handleConnectionSelected(selectedConnection) {
    return this._initializeCreateForm(selectedConnection);
  }

  _handleCredSelectionChanged(
    selectedCredential,
    resetValidationStatus = true,
    skipAutoRedirection = false,
  ) {
    this.skipAutoRedirectionRef.current = skipAutoRedirection;

    if (!this.props.sourceBeingEdited) {
      this._initializeCreateForm(null, false, resetValidationStatus);
    }

    this.props.updateFormData(
      FORM_TYPE_CREATE_DATA_SOURCE,
      {
        selectedCredential,
      },
      resetValidationStatus,
    );

    const credentialId = selectedCredential.id;
    if (credentialId) {
      this._verifySelectedCredential(selectedCredential.id);
    }
  }

  _goToNextStep = () => {
    const { setFormStageIndex, currentStage } = this.props;
    setFormStageIndex(FORM_TYPE_CREATE_DATA_SOURCE, currentStage + 1);
  };

  _verifySelectedCredential = async (credentialId) => {
    const { verifyCredentialSilent, setFormError, setFormAwaitingValidation, updateFormData } =
      this.props;

    if (this.skipAutoRedirectionRef.current) return;

    setFormAwaitingValidation(FORM_TYPE_CREATE_DATA_SOURCE, true);
    try {
      const verification = await verifyCredentialSilent(credentialId);
      setFormError(FORM_TYPE_CREATE_DATA_SOURCE, null);

      const isCreateFlow = !this.props.sourceBeingEdited;
      const connectionIsRest = this._getSelectedConnectionCategory() === CONNECTION_CATEGORY_REST;

      if (isCreateFlow && connectionIsRest) {
        const nonSecureData = verification?.credential?.credentials_non_secure_data;
        const formFieldsFromCredential = nonSecureData
          ? this._getFormDataFromCredential(nonSecureData)
          : {};

        if (!_.isEmpty(formFieldsFromCredential)) {
          updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, formFieldsFromCredential);
        }
      }

      this._goToNextStep();
    } catch (error) {
      const msg = error.message || 'Unable to authenticate.';
      setFormError(FORM_TYPE_CREATE_DATA_SOURCE, msg);
    } finally {
      setFormAwaitingValidation(FORM_TYPE_CREATE_DATA_SOURCE, false);
    }
  };

  _handleCredentialFormInputChanged(input, resetValidationStatus = true) {
    const id = input?.selectedCredentialInfo?.template;
    const info = { ...input };

    if (!_.isNil(id) && id != this.state.selectedTemplate) {
      this.state.connectionAuthFields.forEach((field) => {
        delete info?.selectedCredentialInfo[field.name];
      });
    }

    this.props.updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, info, resetValidationStatus);
  }

  _onAPIConfigChanged(name, value, stageIndex = -1, data = undefined) {
    const {
      paging: { metaInfoById, sourceConfigById },
      apiConfig,
      selectedConnection,
      dataMaps,
      dataMapSamples,
      updateFormData,
      isFormAwaitingValidation,
      loadDataMapSamples,
      vendorEndpoints,
      selectedCredential,
      templatizedAPIConfig,
    } = this.props;
    const newAPIConfig = { ...apiConfig };
    let iterations = [...apiConfig['rest.iterations']];

    if (
      _.includes(
        [
          'start.cron',
          'flow_triggers',
          'advanced_templatized_api',
          ...Constants.HC_SOURCE_FIELD_NAMES,
        ],
        name,
      )
    ) {
      Object.assign(newAPIConfig, FlowTriggerHelper.pickScheduleFields(data));
      newAPIConfig[name] = value;

      if (name === 'advanced_templatized_api') {
        if (value) {
          newAPIConfig.vendor_id = metaInfoById[selectedConnection].vendorId;

          // Entering Advanced: if the advanced iterations haven't been derived from
          // the selected endpoint yet (the default/first endpoint never fired a
          // change event), derive them now from its source_template so Advanced shows
          // the endpoint's URL even before the user changes the dropdown. Guarded on
          // an empty url.template so it never clobbers existing advanced edits.
          // Mirrors the derivation in _onTemplatizedAPIConfigChanged.
          const endpointId = templatizedAPIConfig?.vendor_endpoint_id;
          const firstUrl = iterations?.[0]?.['url.template'];
          if (
            !firstUrl &&
            endpointId &&
            vendorEndpoints?.[endpointId] &&
            !_.isEmpty(vendorEndpoints[endpointId].source_template)
          ) {
            const template = vendorEndpoints[endpointId].source_template;
            const placeholderPattern = /\$\{([\w.-]+?)\}/g;
            iterations = _.map(template['rest.iterations'], (iteration) =>
              _.mapValues(iteration, (val, key) => {
                if (!val || !_.isString(val)) {
                  return val;
                }
                let updatedValue = UIUtils.replaceMacros({
                  templateURL: val,
                  config: templatizedAPIConfig,
                  fields: sourceConfigById[selectedConnection],
                  placeholderPattern,
                  selectedCredential,
                });
                if (
                  key === 'url.template' &&
                  placeholderPattern.test(updatedValue) &&
                  selectedCredential &&
                  has(selectedCredential.credentials_non_secure_data, 'test.url')
                ) {
                  updatedValue = selectedCredential.credentials_non_secure_data['test.url'];
                }
                return updatedValue;
              }),
            ).map((iteration) =>
              has(iteration, 'iteration.type') &&
              iteration['iteration.type'] !== 'static.url' &&
              !has(iteration, 'isPaginated')
                ? { ...iteration, isPaginated: true }
                : iteration,
            );
          }
        } else {
          delete newAPIConfig.vendor_id;
        }
      }
    } else if (stageIndex > -1 && stageIndex < iterations.length) {
      iterations[stageIndex] = {
        ...iterations[stageIndex],
        [name]: value,
      };
    } else if (name === 'dataMapIds') {
      const nonDataMapIterations = this._getNonDataMapIterations();
      const dataMapIterations = _.map(value, (dataMapOption) => {
        // fetch data map samples
        const mapId = dataMapOption.value;

        if (!has(dataMapSamples, mapId)) {
          loadDataMapSamples(mapId, 1, 5);
        }

        const iteration = {
          'iteration.type': 'data.map.key.queue',
          'map.id': mapId,
        };
        iteration.key = this._getIterationKeyFromIteration(iteration);
        return iteration;
      });

      let dataMapKeys = {};
      if (dataMaps) {
        _.each(value, (m) => {
          let selectedDataMap = has(dataMaps, m.value) ? dataMaps[m.value] : null;

          let thisMapKeys = has(selectedDataMap, 'map_entry_schema.properties')
            ? _.keys(selectedDataMap.map_entry_schema.properties)
            : [];
          let keyName = _getIterationKey(m.value);
          dataMapKeys[keyName] = thisMapKeys;
        });
      }

      iterations = [...nonDataMapIterations, ...dataMapIterations];
      newAPIConfig[name] = value;
      newAPIConfig['dataMapKeys'] = dataMapKeys;
    } else {
      this._onAddRestStep();
      return;
    }
    newAPIConfig['rest.iterations'] = iterations;
    updateFormData(
      FORM_TYPE_CREATE_DATA_SOURCE,
      {
        apiConfig: newAPIConfig,
      },
      !isFormAwaitingValidation,
    );
  }

  _onSOAPConfigChanged(name, value, data = undefined) {
    const { soapConfig, updateFormData } = this.props;
    const newSOAPConfig = {
      ...soapConfig,
      ...FlowTriggerHelper.pickScheduleFields(data),
      [name]: value,
    };

    if (name === 'soap.operation' && value !== soapConfig['soap.operation']) {
      newSOAPConfig.params = [];
    }

    updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
      soapConfig: newSOAPConfig,
    });
  }

  _onResetSOAPConfig() {
    const { soapConfig, updateFormData } = this.props;
    const newSOAPConfig = _.omit(soapConfig, [
      'soap.service',
      'soap.service.port',
      'soap.binding',
      'soap.operation',
    ]);
    newSOAPConfig.params = [];

    updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
      soapConfig: newSOAPConfig,
    });
  }

  _onNexlaMonitorConfigChanged(name, value, data) {
    const { nexlaMonitorApiConfig, updateFormData, apiConfig, selectedConnection, paging } =
      this.props;

    let newConfig = {
      ...nexlaMonitorApiConfig,
      ...data,
      [name]: value,
    };

    // Apply conditional defaults for nexla monitor templates
    // Use the new template if it's being set, otherwise use the existing template
    const template = name === 'template' ? value : newConfig.template;
    if (template && template.fields) {
      newConfig = UIUtils.configWithMissingDefaults(newConfig, template.fields);
    }

    const formData = {
      nexlaMonitorApiConfig: newConfig,
      apiConfig,
    };
    // If advance mode enabled, generate config
    if (name === 'advanced_templatized_api') {
      // Need to update apiConfig, if we switch to advance mode
      formData.apiConfig = {
        ...formData.apiConfig,
        ...this._getNexlaMonitorConfig(newConfig),
        [name]: value,
      };
    }
    updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, formData);
  }

  setUIModeToCode = (config) => {
    if (!config) return;
    config['ui.mode'] = UiMode.CODE;
  };

  /**
   * updates the existing API configuration by merging new configuration values,
   * including name-value pairs or an advanced configuration object.
   */
  updateTemplatizedConfig = (name, value, newConfig) => {
    const {
      paging: { sourceConfigById },
      selectedConnection,
      templatizedAPIConfig,
    } = this.props;

    let newTemplatizedAPIConfig = {};

    if (name) {
      newTemplatizedAPIConfig = {
        ...templatizedAPIConfig,
        [name]: value,
      };

      if (name === 'vendor_endpoint_id' && templatizedAPIConfig.vendor_endpoint_id !== value) {
        newTemplatizedAPIConfig = UIUtils.configWithMissingDefaults(
          newTemplatizedAPIConfig,
          sourceConfigById[selectedConnection],
        );
      }
    }

    /**
     * Used as advanced configuration mode
     */
    if (newConfig) {
      newTemplatizedAPIConfig = { ...newConfig };

      if (
        newConfig.vendor_endpoint_id &&
        templatizedAPIConfig.vendor_endpoint_id !== newConfig.vendor_endpoint_id
      ) {
        newTemplatizedAPIConfig = UIUtils.configWithMissingDefaults(
          newTemplatizedAPIConfig,
          sourceConfigById[selectedConnection],
        );
      }
    }

    return newTemplatizedAPIConfig;
  };

  _onTemplatizedAPIConfigChanged(name, value, advancedConfig = undefined, data = {}) {
    const {
      paging: { sourceConfigById },
      vendorEndpoints,
      selectedConnection,
      selectedCredential,
      apiConfig,
      updateFormData,
    } = this.props;

    const newTemplatizedAPIConfig = advancedConfig
      ? this.updateTemplatizedConfig(undefined, undefined, advancedConfig)
      : this.updateTemplatizedConfig(name, value, undefined);

    const formData = {
      templatizedAPIConfig: { ...newTemplatizedAPIConfig, ...data },
    };

    // derive source_config from template_config to keep Advanced Mode in sync
    const { vendor_endpoint_id: endpointId } = newTemplatizedAPIConfig;

    if (
      endpointId &&
      vendorEndpoints[endpointId] &&
      !_.isEmpty(vendorEndpoints[endpointId].source_template)
    ) {
      // replace placeholders inside source_template values
      const template = vendorEndpoints[endpointId].source_template;
      const placeholderPattern = /\$\{([\w.-]+?)\}/g;
      const newAPIConfig = {
        ...apiConfig,
        'rest.iterations': _.map(template['rest.iterations'], (iteration) =>
          _.mapValues(iteration, (value, key) => {
            if (!value || !_.isString(value)) {
              return value;
            }
            let updatedValue = UIUtils.replaceMacros({
              templateURL: value,
              config: newTemplatizedAPIConfig,
              fields: sourceConfigById[selectedConnection],
              placeholderPattern,
              selectedCredential,
            });

            if (
              key === 'url.template' &&
              placeholderPattern.test(updatedValue) &&
              selectedCredential &&
              has(selectedCredential.credentials_non_secure_data, 'test.url')
            ) {
              //if macros could not be replaced, fall back to using credential test url
              updatedValue = selectedCredential.credentials_non_secure_data['test.url'];
            }

            return updatedValue;
          }),
        ),
      };

      //backward compatibility: when switching to advanced view lets just add a isPaginated=== true property when using valid paginated iterations.
      if (
        has(newAPIConfig, 'advanced_templatized_api') &&
        newAPIConfig.advanced_templatized_api === true
      ) {
        formData.apiConfig = {
          ...newAPIConfig,
          'rest.iterations': _.map(newAPIConfig['rest.iterations'], (iteration) => {
            if (
              has(iteration, 'iteration.type') &&
              iteration['iteration.type'] !== 'static.url' &&
              !has(iteration, 'isPaginated')
            ) {
              // not static url iteration
              return { ...iteration, isPaginated: true };
            } else {
              return iteration;
            }
          }),
        };
      } else {
        formData.apiConfig = newAPIConfig;
      }
    }

    if (advancedConfig) {
      this.setUIModeToCode(formData?.apiConfig);
      this.setUIModeToCode(formData?.templatizedAPIConfig);
    }

    updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, formData);
  }

  onTemplatizedAPIConfigChangedAdvancedMode = (advancedConfig = {}) => {
    // if advanced templatized api, we need persist the changes on apiConfig
    if (advancedConfig?.advanced_templatized_api === true) {
      this.onAPIConfigChanged(advancedConfig);
      return;
    }
    // default handler when advanced_templatized_api is not true
    this._onTemplatizedAPIConfigChanged(undefined, undefined, advancedConfig);
  };

  onAPIConfigChanged = (config) => {
    const { updateFormData } = this.props;
    const apiConfigWithMode = withUiModeDefault(config);
    const formDataUpdate = { apiConfig: apiConfigWithMode };

    updateFormData(
      FORM_TYPE_CREATE_DATA_SOURCE,
      formDataUpdate,
      !this.props.isFormAwaitingValidation,
    );
  };

  _onTemplatizedScriptConfigChanged(data, name, value) {
    const {
      paging: { sourceConfigById },
      selectedConnection,
      templatizedScriptConfig,
      updateFormData,
    } = this.props;
    let newTemplatizedScriptConfig = {
      ...templatizedScriptConfig,
      ...data,
      [name]: value,
    };

    //// TODO: NEX-4340: conditional defaults should not be limited to vendor endpoint id
    //// Make sure this doesn't break anything!
    // if (
    //   name === 'vendor_endpoint_id' &&
    //   templatizedScriptConfig.vendor_endpoint_id !== value
    // ) {
    newTemplatizedScriptConfig = UIUtils.configWithMissingDefaults(
      newTemplatizedScriptConfig,
      sourceConfigById[selectedConnection],
    );
    // }

    updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
      templatizedScriptConfig: newTemplatizedScriptConfig,
    });
  }

  _onScriptCredentialInputChanged(name, input) {
    const { scriptCredentialsData, templatizedScriptConfig, updateFormData } = this.props;
    const thisCredentialData = scriptCredentialsData[name] || {};
    const updatedCredentialData = { ...thisCredentialData, ...input };
    const newData = {
      ...scriptCredentialsData,
      [name]: updatedCredentialData,
    };
    const newTemplatizedScriptConfig = { ...templatizedScriptConfig };

    if (_.isInteger(updatedCredentialData.selectedCredentialId)) {
      newTemplatizedScriptConfig[name] = updatedCredentialData.selectedCredentialId;
    } else {
      delete newTemplatizedScriptConfig[name];
    }

    updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
      scriptCredentialsData: newData,
      templatizedScriptConfig: newTemplatizedScriptConfig,
    });
  }

  _onSaveNewScriptCredential(name) {
    const {
      paging: { sourceConfigById, connAuthById },
      scriptCredentialsData,
      templatizedScriptConfig,
      selectedConnection,
      credentialCreationStatus,
      setFormError,
      updateFormData,
    } = this.props;
    const { scriptCredentialAwaitingCreation } = this.state;
    const thisCredentialData = scriptCredentialsData[name] || {};
    const { selectedCredentialInfo } = thisCredentialData;

    // required field validation
    const { credential_type } = _.find(sourceConfigById[selectedConnection], {
      name,
    });
    const { templates, items } =
      connAuthById[
        (selectedCredentialInfo && selectedCredentialInfo._vendorConnectionType) || credential_type
      ];
    const connectionAuthFields = this.getActiveItems(templates, items);
    const missingFields = getEmptyRequiredFields(connectionAuthFields, selectedCredentialInfo);

    // check if credential name has been added or not.
    if (!_.get(selectedCredentialInfo, 'cred_name')) {
      missingFields.unshift({
        name: 'cred_name',
        display_name: 'Credential Name',
      });
    }

    const errorMessage = formatValidationErrorMessage(missingFields);

    if (errorMessage) {
      setFormError(FORM_TYPE_CREATE_DATA_SOURCE, errorMessage);
      return;
    }

    // create new credential
    this._boundSaveNewScriptCredential = this._onSaveNewScriptCredential.bind(this, ...arguments);

    if (scriptCredentialAwaitingCreation) {
      this.setState({
        scriptCredentialAwaitingCreation: false,
      });

      // if creation failed, error
      if (credentialCreationStatus.message) {
        setFormError(FORM_TYPE_CREATE_DATA_SOURCE, credentialCreationStatus.message);
        return;
      }

      // if cred created, select it
      const updatedCredentialData = {
        ...thisCredentialData,
        isNewCredential: false,
        selectedCredentialId: credentialCreationStatus.credential,
      };
      const newData = {
        ...scriptCredentialsData,
        [name]: updatedCredentialData,
      };
      const newTemplatizedScriptConfig = {
        ...templatizedScriptConfig,
        [name]: updatedCredentialData.selectedCredentialId,
      };

      updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
        scriptCredentialsData: newData,
        templatizedScriptConfig: newTemplatizedScriptConfig,
        credentialCreationStatus: null,
      });

      return;
    }

    // request cred creation
    this.setState(
      {
        scriptCredentialAwaitingCreation: true,
      },
      () => {
        const credentialId = credentialCreationStatus ? credentialCreationStatus.credential : null;
        this._onRequestCredentialCreation(
          { ...selectedCredentialInfo, _vendorConnectionType: credential_type },
          credentialId,
        );
      },
    );
  }

  _onProbeClearSample() {
    // leave vendor_resource_data_* entries intact
    const { dataPathValidationResultByStage } = this.state;
    const now = Date.now();
    const apiResponseByStage = _.mapValues(this.state.apiResponseByStage, (value, key) =>
      _.startsWith(key, 'vendor_resource_data_')
        ? value
        : {
            apiResponseContent: '',
            apiResponseContentType: 'text/plain',
            apiResponseCode: null,
            apiResponseMessage: null,
          },
    );
    const newDataPathValidationResultByStage = {
      ...dataPathValidationResultByStage,
    };

    _.forEach(dataPathValidationResultByStage, (value, key) => {
      if (!_.startsWith(key, 'vendor_resource_data_')) {
        delete newDataPathValidationResultByStage[key];
      }
    });

    this.setState(
      {
        apiResponseByStage,
        apiResponseUpdateTime: now,
        dataPathValidationResultByStage: newDataPathValidationResultByStage,
      },
      () => {
        const { selectedCredentialId, probeSample, probeRemoveRestStage } = this.props;

        _.forEach(probeSample, (value, key) => {
          if (!_.startsWith(key, 'vendor_resource_data_')) {
            probeRemoveRestStage(selectedCredentialId, key);
          }
        });
      },
    );
  }

  // apply dataset macro replacement to the source config
  _applyDatasetMacroReplacement(sourceConfig) {
    const { parentDataSet, parentDataSetSamples } = this.props;
    const editedSamples = this.state?.editedSamples || null;
    return applyMacroReplacement(sourceConfig, parentDataSet, parentDataSetSamples, editedSamples);
  }

  _handleEditedSamplesChanged = (editedSamples) => {
    this.setState({ editedSamples });
  };

  _onProbeGetSample(stageIndex) {
    const { selectedCredentialId, probeGetSample, setFormError, apiConfig } = this.props;

    // validate required fields
    if (!isUiModeCode(apiConfig)) {
      const requiredFieldErrorMessage = this._validateConfigureRestSourceRequiredFields(stageIndex);

      if (requiredFieldErrorMessage) {
        // When the *only* missing required fields are the pagination settings, say so
        // explicitly in the error header (clearer than the generic field list).
        const isPaginationSettingsError = this._isRestPaginationFieldsMissing(stageIndex);
        setFormError(
          FORM_TYPE_CREATE_DATA_SOURCE,
          isPaginationSettingsError
            ? { title: 'Error: Missing pagination settings', message: requiredFieldErrorMessage }
            : requiredFieldErrorMessage,
        );
        return;
      }
    }

    // NEX-20282: Removed validation that blocked Get Sample when parameterized URL
    // placeholders couldn't be resolved for preview. This check was overly restrictive
    // because:
    // 1. _onGetParameterizedURLs is only used for UI preview (Sample URLs display)
    // 2. The actual API call uses _applyDatasetMacroReplacement for macro substitution
    // 3. The backend can handle unresolved placeholders appropriately
    // The preview functionality still works as _onGetParameterizedURLs is called
    // separately in the render path for ParameterizedURLPreview component.

    // substitute parameter values into parameterized URL

    // const parameterizedURLs = this._onGetParameterizedURLs(stageIndex);

    // if (parameterizedURLs) {
    //   const { urls } = parameterizedURLs;

    //   if (_.isEmpty(urls)) {
    //     setFormError(
    //       FORM_TYPE_CREATE_DATA_SOURCE,
    //       'The selected macro has no values.'
    //     );
    //     return;
    //   }
    // }

    let sourceConfig = this._buildSourceConfigFromProps(stageIndex);

    // temporary - awaiting backend fix: apply dataset macro replacement for api_server flows
    sourceConfig = this._applyDatasetMacroReplacement(sourceConfig);

    probeGetSample(selectedCredentialId, stageIndex, sourceConfig);
  }

  _onProbeTemplatizedAPI() {
    const {
      selectedCredentialId,
      templatizedAPIConfig,
      probeGetSample,
      setFormError,
      paging: { sourceConfigById },
      selectedConnection,
    } = this.props;
    // validate required fields — but NOT the schedule ("Fetch data" / start.cron). A
    // Test only probes for a sample, which doesn't need a schedule; requiring it here
    // blocked Test when the schedule hadn't been touched. (Schedule is still required
    // at Create/Save.)
    if (!isUiModeCode(templatizedAPIConfig)) {
      const probeFields = (sourceConfigById[selectedConnection] || []).filter(
        (field) => field && field.name !== 'start.cron',
      );
      const requiredFieldsError = this._validateRequiredFields(templatizedAPIConfig, probeFields);

      if (requiredFieldsError) {
        setFormError(FORM_TYPE_CREATE_DATA_SOURCE, requiredFieldsError);
        return;
      }
    }

    // get sample
    const sourceConfig = this._buildSourceConfigFromProps();
    sourceConfig.resource_type = 'SOURCE';

    probeGetSample(selectedCredentialId, 0, sourceConfig);
  }

  _onProbeNexlaMonitor() {
    const { selectedCredentialId, probeGetSample, setFormError, nexlaMonitorApiConfig } =
      this.props;

    // validate required fields
    if (!isUiModeCode(nexlaMonitorApiConfig)) {
      const requiredFieldErrorMessage = this._validateNexlaMonitorFields();
      if (requiredFieldErrorMessage) {
        setFormError(FORM_TYPE_CREATE_DATA_SOURCE, requiredFieldErrorMessage);
        return;
      }
    }

    const sourceConfig = this._getNexlaMonitorConfig();
    probeGetSample(selectedCredentialId, sourceConfig['rest.iterations'].length - 1, sourceConfig);
  }

  _onProbeDatabase() {
    const { selectedCredentialId, probeGetSample, setFormError, paging, selectedConnection } =
      this.props;

    let sourceConfig = this._buildSourceConfigFromProps();
    const sourceConfigFields = paging.sourceConfigById[selectedConnection];

    if (!isUiModeCode(sourceConfig)) {
      let error = this._validateRequiredFields(sourceConfig, sourceConfigFields);
      if (error !== null) {
        setFormError(FORM_TYPE_CREATE_DATA_SOURCE, error);
        return;
      }
    }

    // temporary - awaiting backend fix: apply dataset macro replacement for api_server flows
    sourceConfig = this._applyDatasetMacroReplacement(sourceConfig);

    probeGetSample(selectedCredentialId, 0, sourceConfig);
  }

  _onProbeNoSQL() {
    const { selectedCredentialId, probeGetSample, setFormError, paging, selectedConnection } =
      this.props;
    const sourceConfig = this._buildSourceConfigFromProps();
    const sourceConfigFields = paging.sourceConfigById[selectedConnection];
    let visibleFields = sourceConfigFields.filter(
      (field) => field.name !== 'start.cron' && UIUtils.shouldRenderField(field, sourceConfig),
    );

    // validate required fields
    if (!isUiModeCode(sourceConfig)) {
      const missingFields = getEmptyRequiredFields(visibleFields, sourceConfig);
      const errorMessage = formatValidationErrorMessage(missingFields);

      if (errorMessage) {
        setFormError(FORM_TYPE_CREATE_DATA_SOURCE, errorMessage);
        return;
      }

      if (sourceConfig.db_query_mode === 'Default' && !sourceConfig.collection) {
        setFormError(FORM_TYPE_CREATE_DATA_SOURCE, 'Please select a collection to read data from.');
        return;
      }
    }
    probeGetSample(selectedCredentialId, 0, sourceConfig);
  }

  _getNexlaMonitorConfig(newConfig = null) {
    const { nexlaMonitorApiConfig } = this.props;
    let tempNexlaMonitorApiConfig = newConfig ? newConfig : nexlaMonitorApiConfig;
    let template = tempNexlaMonitorApiConfig['template'] || {};
    const advanced_templatized_api = _.get(
      tempNexlaMonitorApiConfig,
      'advanced_templatized_api',
      false,
    );
    let sourceConfig = _.cloneDeep(_.get(template, 'config', {}));

    // Updating start.cron value for advance mode
    if (has(sourceConfig, 'start.cron') && has(tempNexlaMonitorApiConfig, 'start.cron')) {
      sourceConfig['start.cron'] = tempNexlaMonitorApiConfig['start.cron'];
    }
    let fields = _.get(template, 'fields', []);

    _.forEach(sourceConfig['rest.iterations'], (iteration) => {
      let url = API_SERVER_URL + iteration['url.template'];

      // substitute parameter values into parameterized URL
      let parameterizedURL = UIUtils.replaceMacros({
        templateURL: url,
        config: tempNexlaMonitorApiConfig,
        fields,
      });

      // Getting URL Param's
      let urlParamsFields = _.filter(fields, (field) =>
        UIUtils.shouldAddURLParams(field, tempNexlaMonitorApiConfig),
      );
      let queryParamsObj = {};

      _.forEach(urlParamsFields, (field) => {
        if (has(tempNexlaMonitorApiConfig, field.name) && !!tempNexlaMonitorApiConfig[field.name]) {
          queryParamsObj = {
            ...queryParamsObj,
            [field.name]: tempNexlaMonitorApiConfig[field.name],
          };
        }
      });

      if (!_.isEmpty(queryParamsObj)) {
        parameterizedURL += '?' + queryString.stringify(queryParamsObj, true);
      }

      iteration['url.template'] = parameterizedURL;
    });

    sourceConfig = {
      ...sourceConfig,
      advanced_templatized_api,
      uiconfig: {
        template: template.id,
        ..._.omit(tempNexlaMonitorApiConfig, [
          'template',
          'start.cron',
          'advanced_templatized_api',
        ]),
      },
    };
    return sourceConfig;
  }

  _onGetParameterizedURLs(stageIndex) {
    const { apiConfig, dataMaps, dataMapSamples } = this.props;
    const { dataPathValidationResultByStage, apiResponseByStage } = this.state;

    const urlTemplate = apiConfig['rest.iterations'][stageIndex]?.['url.template'];
    const placeholders = urlTemplate?.match?.(API_URL_PLACEHOLDER_PATTERN);

    if (!placeholders || placeholders.length === 0) {
      return null;
    }

    // get placeholder values (placeholderValues[placeholder][i] = value)
    const numSamples = 5;
    const placeholderValues = {};

    _.forEach(placeholders, (placeholder) => {
      if (has(placeholderValues, placeholder)) {
        return;
      }

      placeholderValues[placeholder] = new Array(numSamples);

      const [iterationKey, iterationPrefix, iterationId, propertyName] = placeholder
        .match(/(([a-zA-Z]+)(\d+))\.(\w+)/)
        .slice(1);

      switch (iterationPrefix) {
        case Constants.IterationPrefixes.DATA_MAP:
          const dataMap = dataMaps[iterationId];

          if (!dataMap) {
            break;
          }

          const dataMapValues = dataMapSamples[dataMap.id] ? dataMapSamples[dataMap.id].flat : [];

          for (let i = 0; i < numSamples; i++) {
            if (has(dataMapValues[i], propertyName)) {
              placeholderValues[placeholder][i] = String(dataMapValues[i][propertyName]);
            }
          }

          break;

        case Constants.IterationPrefixes.STAGE:
          const iterationStageIndex = parseInt(iterationId, 10) - 1;

          if (
            iterationStageIndex < stageIndex &&
            has(dataPathValidationResultByStage, iterationStageIndex)
          ) {
            const validationResult = dataPathValidationResultByStage[iterationStageIndex];
            let response;

            if (validationResult.status) {
              try {
                response = JSON.parse(apiResponseByStage[iterationStageIndex].apiResponseContent);
              } catch (error) {
                console.log('JSON parse error', error);
              }
            } else if (has(validationResult, 'response.data.path')) {
              response = validationResult['response.data.path'].matches;
            }

            if (!response) {
              break;
            }

            for (let i = 0; i < numSamples; i++) {
              let object;

              if (_.isArray(response) && response.length > i) {
                object = response[i];
              } else if (_.isPlainObject(response)) {
                object = response;
              }

              if (!object) {
                continue;
              }

              const value = object[propertyName];

              if (_.isNumber(value) || _.isString(value) || _.isBoolean(value)) {
                placeholderValues[placeholder][i] = String(value);
              }
            }
          }

          break;

        default:
      }
    });

    // replace placeholders
    const urls = [];
    const foundURLs = [];

    for (let i = 0; i < numSamples; i++) {
      const params = [];
      let url = urlTemplate;

      for (let j = 0, lastPosition = 0; j < placeholders.length; j++) {
        const placeholder = placeholders[j];
        const placeholderValue = placeholderValues[placeholder][i];

        if (!_.isUndefined(placeholderValue)) {
          const startIndex = url.indexOf(placeholder, lastPosition);
          const endIndex = startIndex + placeholderValue.length;
          url = url.replace(placeholder, placeholderValue);
          params.push({
            placeholder,
            startIndex,
            endIndex,
          });

          lastPosition = endIndex;
        } else {
          lastPosition += placeholder.length;
        }
      }

      if (params.length > 0 && foundURLs.indexOf(url) < 0) {
        foundURLs.push(url);
        urls.push({
          url,
          params,
        });
      }
    }

    return {
      urlTemplate,
      placeholders,
      urls,
    };
  }

  _onAddRestStep(callBack) {
    const { apiConfig, updateFormData } = this.props;
    const iterations = [...apiConfig['rest.iterations']];
    const newIteration = {
      isPaginated: false,
      'iteration.type': 'paging.incrementing',
      'request.parallelism.count': 1,
      method: 'GET',
      'date.format': 'yyyy-MM-dd',
      'date.time.unit': 'dd',
    };

    // insert the new element before the first data map iteration
    const dataMapIterationIndex = _.findIndex(
      iterations,
      (iteration) => iteration['iteration.type'] === 'data.map.key.queue',
    );
    let newIterationIndex;

    if (dataMapIterationIndex < 0) {
      newIterationIndex = iterations.length;
      iterations.push(newIteration);
    } else {
      newIterationIndex = dataMapIterationIndex;
      iterations.splice(dataMapIterationIndex, 0, newIteration);
    }

    newIteration.key = this._getIterationKeyFromIteration(newIteration, newIterationIndex);

    const newAPIConfig = {
      ...apiConfig,
      'rest.iterations': iterations,
    };

    updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
      apiConfig: newAPIConfig,
    });

    // scroll to top
    const container =
      document.getElementById('configure-templatized-api-container') ||
      document.getElementById('configure-api');

    if (container) {
      container.scrollTo(0, 0);
    }

    if (callBack) {
      callBack();
    }
  }

  _onRemoveRestStep(stageIndex) {
    // remove element from rest.iterations
    const { apiConfig, selectedCredentialId, updateFormData, probeRemoveRestStage } = this.props;

    const iterations = [...apiConfig['rest.iterations']];
    iterations.splice(stageIndex, 1);

    const stageAPIConfig = apiConfig['rest.iterations'][0];

    // recalculate keys of iterations following the removed iteration
    for (let i = stageIndex; i < iterations.length; i++) {
      const iteration = iterations[i];

      if (iteration['iteration.type'] === 'data.map.key.queue') {
        break;
      }

      iterations[i] = {
        ...iteration,
        key: this._getIterationKeyFromIteration(iteration, i),
      };
    }

    /**
     * if the iteration doesn't have an url.template, set it
     */
    if (iterations.length === 1) {
      if (iterations[0]['url.template'] === undefined) {
        iterations[0]['url.template'] = stageAPIConfig['url.template'];
      }
    }

    const newAPIConfig = {
      ...apiConfig,
      'rest.iterations': iterations,
    };

    updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
      apiConfig: newAPIConfig,
    });

    // adjust the stage indices that probe responses are stored against
    probeRemoveRestStage(selectedCredentialId, stageIndex);
  }

  _onRestValidationComplete() {
    this.setState({ restValidationStageIndex: -1 });
  }

  _getIterationKeyFromIteration(iteration, stageIndex = -1) {
    return iteration['iteration.type'] === 'data.map.key.queue'
      ? _getIterationKey(iteration['map.id'])
      : _getIterationKey(null, stageIndex);
  }

  _getSelectedConnectionCategory() {
    const { selectedConnection, paging } = this.props;
    return selectedConnection ? paging.metaInfoById[selectedConnection]?.connectionCategory : null;
  }

  _getFormDataFromCredential(credentialInfo) {
    const formData = {};

    if (has(credentialInfo, 'test.url')) {
      formData.apiConfig = {
        ...this.props.apiConfig,
        'rest.iterations': [
          {
            ...this.props.apiConfig['rest.iterations'][0],
            'url.template': credentialInfo['test.url'],
          },
        ],
      };
      formData.soapConfig = {
        ...this.props.soapConfig,
        'soap.wsdl.url': credentialInfo['test.url'],
      };
    }

    return formData;
  }

  _onWebhookMetaInfoChanged(fieldName, fieldValue) {
    //TODO: temporarily only allowing webhook name to be saved in state
    if (fieldName === 'name') {
      this.setState({
        sourceName: fieldValue,
      });
    }
    if (fieldName === 'description') {
      this.setState({
        sourceDescription: fieldValue,
      });
    }
  }

  _onMetaInfoChanged({ property, value }) {
    if (property === 'name') {
      this.setState({
        sourceName: value,
      });
    } else if (property === 'description') {
      this.setState({
        sourceDescription: value,
      });
    } else {
      this.setState({
        [property]: value,
      });
    }
  }

  _onWebhookSourceCreate(sourceConfig = {}) {
    const {
      paging: { metaInfoById },
      selectedConnection,
    } = this.props;
    const { sourceName } = this.state;
    const sourceInfo = {
      name: sourceName,
      description: null,
      source_config: sourceConfig,
    };
    const { connectionCategory } = metaInfoById[selectedConnection];

    this.props.addDataSourceFromForm(
      FORM_TYPE_CREATE_DATA_SOURCE,
      selectedConnection,
      connectionCategory,
      sourceInfo,
      null,
      true,
      false, //activateSource
    );
  }

  _onEmailSourceCreate() {
    const { selectedConnection } = this.props;
    const { sourceName, sourceDescription } = this.state;
    const sourceConfig = this._buildSourceConfigFromProps();

    const sourceInfo = {
      name: sourceName,
      description: sourceDescription,
      ...sourceConfig,
    };

    this.props.addDataSourceFromForm(
      FORM_TYPE_CREATE_DATA_SOURCE,
      selectedConnection,
      CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT,
      sourceInfo,
      null,
      true,
      false, //activateSource
    );
  }

  _mapFilesWithPreview(files = []) {
    return (files || []).map((file) =>
      Object.assign(file, {
        id: `${file?.name}-${file?.size}-${file?.lastModified || Date.now()}`,
        displayName: file?.displayName || file?.name,
        displaySize: file?.displaySize ?? file?.size,
        displayType: file?.displayType || file?.type,
        displayLastModified: file?.displayLastModified ?? file?.lastModified ?? Date.now(),
        status: file?.status || 'pending',
        uploadProgress: file?.uploadProgress ?? 0,
        backendUploadProgress: file?.backendUploadProgress ?? 0,
        // keep a stable reference to the original File for upload
        __rawFile: file.__rawFile || file,
      }),
    );
  }

  _ensureFilesHaveIds(files = []) {
    let mutated = false;
    const result = (files || []).map((file) => {
      if (!file) return file;

      const hasId = !!file.id;
      const normalized = Object.assign(file, {
        displayName: file.displayName || file.name,
        displaySize: file.displaySize !== undefined ? file.displaySize : file.size,
        displayType: file.displayType || file.type,
        displayLastModified:
          file.displayLastModified !== undefined ? file.displayLastModified : file.lastModified,
        id: hasId ? file.id : `${file.name}-${file.size}-${file.lastModified || Date.now()}`,
        uploadProgress: file.uploadProgress ?? 0,
        backendUploadProgress: file.backendUploadProgress ?? 0,
        status: file.status || 'pending',
        // ensure raw file is kept for upload even after normalization
        __rawFile: file.__rawFile || file,
      });

      mutated =
        mutated ||
        !hasId ||
        normalized.uploadProgress !== file.uploadProgress ||
        normalized.backendUploadProgress !== file.backendUploadProgress ||
        normalized.status !== file.status;

      return normalized;
    });

    return { files: result, mutated };
  }

  _updateFileStatus(fileId, updates) {
    if (!fileId) return;
    this.setState((prevState) => ({
      selectedFiles: (prevState.selectedFiles || []).map((file) =>
        file.id === fileId ? { ...file, ...updates } : file,
      ),
    }));
  }

  _updateFileProgress(fileId, progress, type) {
    if (!fileId) return;
    this.setState((prevState) => ({
      selectedFiles: (prevState.selectedFiles || []).map((file) => {
        if (file.id !== fileId) return file;

        const uploadProgress = type === 'upload' ? progress : (file.uploadProgress ?? 0);
        const backendUploadProgress =
          type === 'backend' ? progress : (file.backendUploadProgress ?? 0);
        const isComplete = uploadProgress === 100 && backendUploadProgress === 100;

        return {
          ...file,
          uploadProgress,
          backendUploadProgress,
          status: file.status === 'error' ? 'error' : isComplete ? 'uploaded' : 'uploading',
        };
      }),
    }));
  }

  _simulateProgress(fileId, type, duration = 1500) {
    return new Promise((resolve) => {
      const startTime = Date.now();
      const targetProgress = type === 'upload' ? 95 : 90;

      const updateProgress = () => {
        const elapsed = Date.now() - startTime;
        const progress = Math.min(
          Math.round((elapsed / duration) * targetProgress),
          targetProgress,
        );

        this._updateFileProgress(fileId, progress, type);

        if (progress < targetProgress) {
          requestAnimationFrame(updateProgress);
        } else {
          resolve();
        }
      };

      updateProgress();
    });
  }

  async _uploadSingleFile(dataSourceId, file, uploadFileToSource) {
    const fileId = file?.id;
    if (!file || !fileId) return Promise.resolve();

    // Derive durations based on file size to make progress perceptually proportional.
    const sizeInMB = Math.max(1, (file.size || 0) / (1024 * 1024));
    const uploadDuration = Math.min(10000, Math.max(800, Math.round(sizeInMB * 500)));
    const backendDuration = Math.min(12000, Math.max(1000, Math.round(sizeInMB * 700)));

    // Mark uploading
    this._updateFileStatus(fileId, {
      status: 'uploading',
      uploadProgress: 0,
      backendUploadProgress: 0,
    });

    const uploadSim = this._simulateProgress(fileId, 'upload', uploadDuration);
    const uploadPromise = uploadFileToSource(dataSourceId, file);

    await uploadSim;
    this._updateFileProgress(fileId, 100, 'upload');

    const backendSim = this._simulateProgress(fileId, 'backend', backendDuration);
    await uploadPromise;
    await backendSim;
    this._updateFileProgress(fileId, 100, 'backend');
    this._updateFileStatus(fileId, { status: 'uploaded' });
  }

  _onFileUploadFileSelected(file) {
    this.setState((prevState) => {
      const hasExistingFiles = prevState.selectedFiles && prevState.selectedFiles.length > 0;
      const normalizedFiles = hasExistingFiles
        ? prevState.selectedFiles
        : file
          ? this._mapFilesWithPreview([file])
          : [];

      return {
        selectedFile: file,
        selectedFiles: normalizedFiles,
      };
    });
  }

  _onFileUploadFilesSelected(files) {
    const normalizedFiles = this._mapFilesWithPreview(files);

    // Append new files to existing ones, filtering out duplicates by id
    this.setState((prevState) => {
      const existingFiles = prevState.selectedFiles || [];
      const existingIds = new Set(existingFiles.map((f) => f.id));
      const newFiles = normalizedFiles.filter((f) => !existingIds.has(f.id));
      const allFiles = [...existingFiles, ...newFiles];

      return {
        selectedFiles: allFiles,
        selectedFile: allFiles.length ? allFiles[0] : null,
      };
    });
  }

  _onFileUploadFileRemoved(fileId) {
    this.setState((prevState) => {
      const updatedFiles = (prevState.selectedFiles || []).filter((file) => file.id !== fileId);
      return {
        selectedFiles: updatedFiles,
        selectedFile: updatedFiles.length ? updatedFiles[0] : null,
      };
    });
  }

  _handleRuntimeSelected = (clusterId) => this.setState({ clusterId });

  _handleSelectBucketRuntimeVisibilityChange = (visible) =>
    this.setState({ selectBucketRuntimeSectionVisible: visible });

  _validateCustomProcessor = () => {
    return new Promise((resolve, reject) => {
      const { sourceConfig } = this.props;
      const { customProcessorId, customProcessorCode } = sourceConfig;

      if (!sourceConfig['ui.use_custom_processor']) {
        return resolve();
      }

      const isCustomCodeMode = sourceConfig['ui.custom_processor_mode'] === 'custom_code';

      if (isCustomCodeMode && (!customProcessorCode || !customProcessorCode.trim())) {
        return reject('Custom processor code is required');
      }

      if (!isCustomCodeMode && !customProcessorId) {
        return reject('Please select an existing Connector Processor');
      }

      resolve();
    });
  };

  _getCustomProcessorId = async () => {
    const {
      sourceConfig,
      sourceBeingEdited,
      sourceBeingEditedId,
      updateCodeContainer,
      createCodeContainer,
    } = this.props;
    const { customProcessorId, customProcessorCode, packages, extra_data } = sourceConfig;

    if (sourceConfig['ui.use_custom_processor']) {
      if (sourceConfig['ui.custom_processor_mode'] === 'custom_code') {
        const payload = {
          name: 'Custom file processor for source',
          resource_type: 'source_custom',
          output_type: TransformType.CUSTOM,
          code_type: 'python',
          code_encoding: 'base64',
          code: Base64.encode(customProcessorCode),
          code_config: {
            packages: packages || '',
            extra_data: extra_data || '',
          },
        };
        const shouldUpdate =
          sourceBeingEditedId &&
          sourceBeingEdited?.source_config?.['ui.use_custom_processor'] &&
          sourceBeingEdited.source_config['ui.custom_processor_mode'] === 'custom_code' &&
          sourceBeingEdited.code_container_id;
        const response = shouldUpdate
          ? await updateCodeContainer(sourceBeingEdited.code_container_id, payload)
          : await createCodeContainer(payload);

        return response.result;
      }

      return customProcessorId;
    }

    return null;
  };

  //2. Create a source with credentials(new or existing creds)
  async _onRequestSourceCreation(onError) {
    let {
      paging: { metaInfoById, sourceConfigById },
      selectedConnection,
      selectedCredentialId,
      sourceBeingEdited,
      apiConfig,
    } = this.props;
    const { sourceDescription, runWithIngestion } = this.state;
    const { connectionType, connectionCategory } = metaInfoById[selectedConnection];
    let sourceName;
    let skipSourceCreation = false;

    if (
      connectionCategory === CONNECTION_CATEGORY_REST ||
      (apiConfig && apiConfig.advanced_templatized_api)
    ) {
      const iterationWithURL = _.find(apiConfig['rest.iterations'], (iteration) =>
        has(iteration, 'url.template'),
      );
      const urlTemplate = iterationWithURL?.['url.template'] ?? '';
      const { hostname, lastPath } = UIUtils.parsePartsFromURL(urlTemplate);
      sourceName =
        lastPath && lastPath !== ''
          ? `${_.capitalize(hostname)} - ${lastPath}`
          : `${_.capitalize(hostname)}`;
    } else if (connectionCategory === CONNECTION_CATEGORY_SOAP) {
      const { soapConfig } = this.props;
      sourceName = `${soapConfig['soap.service']} - ${soapConfig['soap.operation']}`;
    } else if (
      connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API ||
      connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT
    ) {
      const { templatizedAPIConfig, templatizedScriptConfig } = this.props;
      const templatizedConfig =
        connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API
          ? templatizedAPIConfig
          : templatizedScriptConfig;
      const endpointId = templatizedConfig.vendor_endpoint_id;
      const configFields = sourceConfigById[selectedConnection];
      const endpointField = _.find(configFields, {
        name: 'vendor_endpoint_id',
      });
      const endpointOption = _.find(endpointField?.options, {
        value: endpointId,
      });
      sourceName = endpointOption
        ? endpointOption.label
        : endpointId?.toString(10) ||
          this.state.sourceName ||
          metaInfoById[selectedConnection]?.displayName ||
          selectedConnection;
    } else if (
      connectionCategory === CONNECTION_CATEGORY_WEBHOOK ||
      connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT
    ) {
      //source has already been created to generate the source spec
      skipSourceCreation = true;
    } else if (connectionCategory === CONNECTION_CATEGORY_DATABASE) {
      const { selectedTable, credentials } = this.props;
      const database =
        selectedTable && has(selectedTable, 'database') ? selectedTable.database : null;
      const name = selectedTable && has(selectedTable, 'name') ? selectedTable.name : null;
      const id = selectedTable && has(selectedTable, 'id') ? selectedTable.id : null;
      const credentialName = has(credentials, selectedCredentialId)
        ? credentials[selectedCredentialId].name
        : '';

      if (database && name) {
        sourceName = `${database} - ${name}`;
      } else if (id) {
        sourceName = `${id}`;
      } else if (database) {
        sourceName = `${database}`;
      } else {
        sourceName = `${credentialName} - Query`;
      }
    } else if (connectionCategory === CONNECTION_CATEGORY_KAFKA) {
      const { sourceConfig } = this.props;
      sourceName = _.get(
        sourceConfig,
        'topic',
        _.get(
          sourceConfig,
          'source.name',
          sourceConfig['subscription'], // default value
        ), //  default value
      );
    } else if (connectionCategory === CONNECTION_CATEGORY_FILE_UPLOAD) {
      sourceName = this.state.sourceName;
    } else if (connectionCategory === CONNECTION_CATEGORY_NEXLA_MONITOR) {
      const { nexlaMonitorApiConfig } = this.props;
      let template = _.get(nexlaMonitorApiConfig, 'template', {});
      sourceName = _.get(template, 'label', CONNECTION_CATEGORY_NEXLA_MONITOR);
    } else if (connectionCategory === CONNECTION_CATEGORY_NOSQL) {
      const { sourceConfig } = this.props;
      sourceName = _.get(sourceConfig, 'collection', '');
    } else if (connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API_MULTI) {
      sourceName = this.state.sourceName;
    } else if (connectionCategory === CONNECTION_CATEGORY_SYSLOG) {
      //give a good default name if source name is not set. set it to current date-time (MMM, DD) so Syslog - MMM,dd
      const currentDate = new Date().toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
      });
      sourceName = this.state.sourceName || `Syslog - ${currentDate}`;
    } else {
      const ignorePath = CONNECTORS_WITHOUT_PATH.includes(this.props.selectedConnection);
      const bucket = ignorePath ? {} : this.props.selectedBucket || {};
      const { displayPath, displayName } = bucket;
      let leafNodeName;
      if (displayName) {
        leafNodeName = displayName;
      } else if (displayPath) {
        leafNodeName = displayPath.substr(displayPath.lastIndexOf('/') + 1);
      } else {
        leafNodeName = this.props.selectedConnection + ' - ' + this.props.selectedCredentialId;
      }
      //TODO: ftp etc source types have bucket name /. Need backend to change the types maybe?
      sourceName = leafNodeName;
    }

    if (skipSourceCreation === true) return;

    let sourceInfo = sourceBeingEdited
      ? {
          name: this.state.sourceName,
          description: sourceDescription,
        }
      : {
          name: this.state.sourceName || sourceName,
          description: sourceDescription,
        };

    const { sourceConfig: config } = this.props;
    const isSourceConfigCodeMode = isUiModeCode(config);
    const isApiConfigCodeMode = isUiModeCode(apiConfig);
    const isAdvancedConfigMode = isSourceConfigCodeMode || isApiConfigCodeMode;

    if (isAdvancedConfigMode) {
      const advancedName = config?.name ?? apiConfig?.name;
      const advancedDescription = config?.description ?? apiConfig?.description;
      this.setUIModeToCode(sourceInfo?.source_config);

      if (advancedName !== undefined && advancedName !== null) {
        sourceInfo.name = advancedName;
      }

      if (advancedDescription !== undefined && advancedDescription !== null) {
        sourceInfo.description = advancedDescription;
      }
    }

    const configuration = this._buildSourceConfigFromProps();

    if (
      (connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API &&
        !(apiConfig && apiConfig.advanced_templatized_api)) ||
      connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT
    ) {
      /**
       * template_config
       * vendor_endpoint_id
       */
      sourceInfo = { ...sourceInfo, ...cleanObject(configuration) };
    } else {
      sourceInfo.source_config = configuration;
    }

    // Strip ui.mode: "view" before sending to API — only "code" should be persisted
    if (sourceInfo.source_config && sourceInfo.source_config['ui.mode'] === UiMode.VIEW) {
      delete sourceInfo.source_config['ui.mode'];
    }
    if (sourceInfo.template_config && sourceInfo.template_config['ui.mode'] === UiMode.VIEW) {
      delete sourceInfo.template_config['ui.mode'];
    }

    if (connectionCategory === CONNECTION_CATEGORY_DATABASE) {
      const cdcEnabled =
        has(sourceInfo.source_config, 'cdc.enabled') &&
        sourceInfo.source_config['cdc.enabled'] === true;
      const selectedTableId = _.get(sourceInfo.source_config, 'table', null);
      if (cdcEnabled && !selectedTableId) {
        sourceInfo.source_config = _.omit(sourceInfo.source_config, ['table']);
      }
    }

    const isFileWithProcessor =
      (connectionCategory === CONNECTION_CATEGORY_FILE ||
        connectionCategory === CONNECTION_CATEGORY_FILE_UPLOAD) &&
      (sourceInfo.source_config['ui.use_custom_processor'] ||
        sourceInfo.source_config['ai.function']);

    if (connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API_MULTI) {
      const service = createELTService(flowTypes.streaming);
      sourceInfo = service.buildSourceInfo({
        name: this.state.sourceName,
        selectedFeeds: this.props.selectedFeeds,
        sourceConfig: this.props.sourceConfig,
      });
    }

    if (isFileWithProcessor) {
      try {
        await this._validateCustomProcessor();
      } catch (error) {
        onError(error.message);

        return;
      }

      const codeContainerId = await this._getCustomProcessorId();

      const { selectedCredentialInfo } = this.props;
      const isChunkerSelected = Boolean(sourceInfo.source_config?.['ai.function.id']);
      const chunkerId = sourceInfo.source_config?.['ai.function.id'];

      if (isChunkerSelected && getKwargsHasErrors()) {
        onError(
          'AI Function Inputs contains errors. Please resolve any duplicate keys, missing keys, or invalid number values before saving.',
        );
        return;
      }

      // If the user added kwargs while a chunker was selected and then switched
      // to custom-code mode (or otherwise deselected the chunker), the editor is
      // no longer visible but the kwargs would still be in source_config.extra_data.
      // Strip them so we don't silently persist values the user can't see.
      if (!isChunkerSelected) {
        clearKwargsFromExtraData(sourceInfo.source_config);
      }

      const paramsArray =
        Object.entries(sourceInfo.source_config)
          .filter(([key]) => key.startsWith('chunker_params.'))
          .map(([key, value]) => ({
            name: key.replace('chunker_params.', ''),
            value,
          })) || null;

      const postProcessorData = [
        {
          run_engine: 'ray',
          type: isChunkerSelected ? 'chunker' : 'customCodeProcessor',
          code_container_id: isChunkerSelected ? chunkerId : codeContainerId,
          params: isChunkerSelected && paramsArray?.length > 0 ? { props: paramsArray } : null,
        },
      ];

      const fieldsToDelete = ['customProcessorId'];
      fieldsToDelete.forEach((field) => {
        delete sourceInfo.source_config[field];
      });

      sourceInfo.source_config['post_processor'] = postProcessorData;
    }

    const flexFlowType = this.props.flowType || 'streaming';
    if (!sourceBeingEdited && flexFlowType === 'streaming' && this.state.clusterId != null)
      sourceInfo.cluster_id = this.state.clusterId;

    if (sourceBeingEdited) {
      const runWithIngestionFromForm = sourceBeingEdited.status === 'ACTIVE' && runWithIngestion;

      this.props.updateDataSourceFromForm(
        FORM_TYPE_CREATE_DATA_SOURCE,
        sourceBeingEdited.id,
        sourceInfo,
        connectionCategory,
        false,
        selectedCredentialId,
        null,
        null,
        runWithIngestionFromForm,
      );
    } else {
      const shouldForceCreateDataset = connectionCategory === CONNECTION_CATEGORY_SYSLOG;

      this.props.addDataSourceFromForm(
        FORM_TYPE_CREATE_DATA_SOURCE,
        connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API ||
          connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT ||
          connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API_MULTI
          ? connectionType
          : selectedConnection,
        connectionCategory,
        sourceInfo,
        selectedCredentialId,
        false,
        true, //shouldActivateSource
        shouldForceCreateDataset,
        this.props.parentDataSetId,
        this.props.flowType,
      );
    }
  }

  _onRequestCredentialCreation(credInfo, credentialId) {
    const credentialInfo = clone(credInfo);
    if (credInfo.template) {
      credentialInfo.auth_template_id = Number(credInfo.template);
    }
    const sourceConfigDefault = this._buildSourceConfigFromDefaults(this.props.selectedConnection);
    const newFormData = {
      sourceConfig: sourceConfigDefault,
    };

    this.props.updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, newFormData, false);
    this.props.resetFormData(FORM_TYPE_CREATE_DATA_SOURCE, [
      'credentialCreationStatus',
      'credentialProbeStatus',
      'selectedCredential',
    ]);

    if (credentialId) {
      this.props.updateCredentialFromForm(
        FORM_TYPE_CREATE_DATA_SOURCE,
        credentialId,
        credentialInfo,
      );
    } else {
      const connectionType =
        (credentialInfo && credentialInfo._vendorConnectionType) || this.props.selectedConnection;

      this.props.addCredentialFromForm(
        FORM_TYPE_CREATE_DATA_SOURCE,
        connectionType,
        credentialInfo,
      );
      //TODO: Check if we really need this anymore! There is already an early intent being fired when cred probe succeeds
      // .then((response) => {
      //   if (response && response.result) {
      //     this.setEarlyIntent(String(response.result));
      //   }
      // });
    }
  }

  /**
   * @param {number|string} credential
   * @param {boolean} fromContinueValidation - When true, Form already set awaitingValidation;
   *   do not clear it on success (onSuccess does); clear only on probe failure.
   */
  _onRequestCredentialProbe(credential, fromContinueValidation = false) {
    if (!credential) {
      return;
    }

    AnalyticsUtils.captureCustomEvent('data_source_credential_selection', {
      credential_id: credential,
      connection_type: this.props.selectedConnection,
    });

    //build source config based on selected credential info
    let sourceConfigDefault = this._buildSourceConfigFromDefaults(this.props.selectedConnection);
    this.props.updateFormData(
      FORM_TYPE_CREATE_DATA_SOURCE,
      {
        sourceConfig: sourceConfigDefault,
      },
      false,
    );
    this.props.resetFormData(FORM_TYPE_CREATE_DATA_SOURCE, ['credentialProbeStatus'], false);

    const { verifyCredentialFromForm, setFormAwaitingValidation } = this.props;

    if (!fromContinueValidation) {
      setFormAwaitingValidation(FORM_TYPE_CREATE_DATA_SOURCE, true);
    }

    const probePromise = verifyCredentialFromForm(FORM_TYPE_CREATE_DATA_SOURCE, credential);

    probePromise.catch(() => {
      if (fromContinueValidation) {
        setFormAwaitingValidation(FORM_TYPE_CREATE_DATA_SOURCE, false);
      }
    });

    probePromise.finally(() => {
      this.setState({ selectCredentialAwaitingProbe: false });
      if (!fromContinueValidation) {
        setFormAwaitingValidation(FORM_TYPE_CREATE_DATA_SOURCE, false);
      }
    });
  }

  //3. fetch probe tree
  _onRequestProbeTree(isRoot = true, selectedFolder = null) {
    this.props.probeGetConnectionTree(this.props.selectedCredentialId, isRoot, selectedFolder);
  }

  _onRequestInitialDBProbeTree(selectedFolder = null) {
    this.props.probeGetInitialDBTree(this.props.selectedCredentialId, true, selectedFolder);
  }

  _onToggleNodeProbeTree(node) {
    this.props.probeToggleTreeNode(this.props.selectedCredentialId, node);
  }

  _onProbeGetWSDL() {
    this.props.probeGetWSDL(
      this.props.selectedCredentialId,
      this.props.soapConfig['soap.wsdl.url'],
    );
  }

  _onProbeCallSOAP(payload) {
    const sourceConfig = this._buildSourceConfigFromProps();
    this.props.probeCallSOAP(this.props.selectedCredentialId, sourceConfig);
  }

  //update selected bucket/folder
  _onBucketSelected(selectedBucket) {
    const path = selectedBucket && selectedBucket.path;
    const displayPath = selectedBucket && selectedBucket.displayPath;
    const mimeType = selectedBucket && selectedBucket.mimeType;
    const idPath = selectedBucket && selectedBucket.idPath; // For leaf-ID-only connectors (Google Drive)

    const sourceConfigWithBucket = _.assign({}, this.props.sourceConfig, {
      path,
      'ui.display_path': displayPath,
      'ui.selected_file_mime_type': mimeType,
      // Save the resolved ID path for leaf-ID-only connectors (Google Drive)
      // This allows future edits to skip iterative probing
      ...(idPath ? { 'ui.id_path': idPath } : {}),
    });

    this.props.updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
      selectedBucket: selectedBucket,
      sourceConfig: sourceConfigWithBucket,
    });
  }

  _onTableSelected(selectedTable, database = null) {
    let bucketObject = {
      table: null,
      database: database,
    };

    //TODO: Need to fix with Database name
    if (selectedTable) {
      bucketObject = _.assign(
        {},
        bucketObject,
        _.omit(selectedTable, ['scanned', 'columns', 'name', 'id']),
      );
      bucketObject.table = has(selectedTable, 'name') ? selectedTable.name : null;
    }

    // if database or table changes, unset table-specific properties in
    // sourceConfig
    const { sourceConfig } = this.props;
    let newSourceConfig;

    if (
      sourceConfig &&
      selectedTable &&
      (selectedTable.name !== sourceConfig.table ||
        selectedTable.database !== sourceConfig.database)
    ) {
      newSourceConfig = _.omit(sourceConfig, [
        'mode',
        'incrementing.column.name',
        'timestamp.column.name',
        'incrementing.load.from',
        'timestamp.load.from',
      ]);
    } else {
      newSourceConfig = sourceConfig;
    }

    let sourceConfigWithBucket = _.assign({}, newSourceConfig, bucketObject);
    //  this case only when user deselect the table and select database only for cdc case
    if (
      database &&
      has(sourceConfig, 'cdc.enabled') &&
      sourceConfig['cdc.enabled'] &&
      has(sourceConfig, 'ui.cdc.type') &&
      sourceConfig['ui.cdc.type'] === 'database'
    ) {
      sourceConfigWithBucket = _.omit(sourceConfigWithBucket, ['table']);
    }

    this.props.updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
      selectedBucket: selectedTable,
      sourceConfig: sourceConfigWithBucket,
      selectedTable,
    });
  }

  _onCollectionSelected(selectedCollection) {
    let bucketObject = {
      collection: null,
      database: null,
    };

    //TODO: Need to fix with Database name
    if (selectedCollection) {
      bucketObject = _.assign(
        {},
        bucketObject,
        _.omit(selectedCollection, ['scanned', 'columns', 'name', 'id']),
      );
      bucketObject.collection = has(selectedCollection, 'name') ? selectedCollection.name : null;
    }

    const { sourceConfig } = this.props;
    const sourceConfigWithBucket = _.assign({}, sourceConfig, bucketObject);

    this.props.updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
      selectedBucket: selectedCollection,
      sourceConfig: sourceConfigWithBucket,
      selectedCollection,
    });
  }

  _handleSourceConfigChanged(data) {
    const { updateFormData } = this.props;
    const updatedSourceConfig = withUiModeDefault(data);
    const formDataUpdate = { sourceConfig: updatedSourceConfig };
    updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, formDataUpdate);

    if (this._getSelectedConnectionCategory() === CONNECTION_CATEGORY_REST) {
      const formDataUpdate = { apiConfig: updatedSourceConfig };
      updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, formDataUpdate);
    }
  }

  _handleFormDataUpdate(formData) {
    this.props.updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, formData);
  }

  _buildSourceConfigFromDefaults(selectedConnection, useEmptyConfig = false) {
    let currentSourceConfig =
      !this.props.sourceConfig || useEmptyConfig ? {} : this.props.sourceConfig;

    let sourceConfigFields = selectedConnection
      ? this.props.paging.sourceConfigById[selectedConnection]
      : [];

    _.forEach(sourceConfigFields, function (f) {
      if (has(f, 'default') && !has(currentSourceConfig, f.name)) {
        currentSourceConfig[f.name] = f.default;
      }
    });

    // omit fields which shouldn't be rendered
    const visibleFieldData = UIUtils.omitInvisibleFieldData(
      sourceConfigFields,
      currentSourceConfig,
    );

    if (_.isEmpty(visibleFieldData)) {
      return this.props.sourceConfig;
    } else {
      return visibleFieldData;
    }
  }

  _buildSourceConfigFromProps(stageIndex = -1) {
    const {
      paging: { metaInfoById, sourceConfigById },
      currentOrg,
      selectedConnection,
      apiConfig,
    } = this.props;
    const meta = metaInfoById[selectedConnection];
    const configFields = sourceConfigById[selectedConnection];
    let sourceConfig;

    if (
      meta.connectionCategory === CONNECTION_CATEGORY_REST ||
      apiConfig?.advanced_templatized_api
    ) {
      // build source config from apiConfig
      sourceConfig = _.omit(apiConfig, ['dataMapIds']);

      let iterations = sourceConfig['rest.iterations'];

      if (stageIndex > -1) {
        iterations = _.filter(
          iterations,
          (iteration, index) =>
            index <= stageIndex || iteration['iteration.type'] === 'data.map.key.queue',
        );
      }

      sourceConfig['rest.iterations'] = _.map(iterations, (iteration) => {
        const currentIterationType = iteration['iteration.type'];

        if (currentIterationType === 'data.map.key.queue') {
          return iteration;
        }

        let newIteration = { ...iteration };

        if (!newIteration.isPaginated) {
          newIteration['iteration.type'] = 'static.url';
        }

        if (newIteration['response.data.path.additional']) {
          newIteration['response.data.path.additional'] = _.split(
            newIteration['response.data.path.additional'],
            /\s*,\s*(?=\$)/,
          );
        }

        // prepend "$." to data paths
        const dataPaths = this._getDataPathFromAPIConfig(newIteration);

        _.forEach(dataPaths, (dataPath, fieldName) => {
          newIteration[fieldName] = dataPath;
        });

        return UIUtils.reduceConfig(
          _.omit(newIteration, ['isPaginated', 'contentType']),
          configFields,
        );
      });
      sourceConfig['rest.iterations'] = _.sortBy(sourceConfig['rest.iterations'], (iteration) =>
        iteration['iteration.type'] === 'data.map.key.queue' ? 0 : 1,
      );

      delete sourceConfig?.name;
      delete sourceConfig?.description;
    } else if (meta.connectionCategory === CONNECTION_CATEGORY_SOAP) {
      const { soapConfig, probeSample } = this.props;
      sourceConfig = _.omit(soapConfig, ['params']);

      const wsdl = _.get(probeSample, 'wsdl');
      const selectedServiceName = soapConfig['soap.service'];
      const selectedService = selectedServiceName
        ? _.find(wsdl.services, { name: selectedServiceName })
        : null;
      const selectedBindingName = soapConfig['soap.binding'];
      const selectedBinding = selectedBindingName
        ? _.find(selectedService.bindings, { name: selectedBindingName })
        : null;

      if (selectedBinding) {
        sourceConfig['soap.port.type'] = selectedBinding.portType;
      }

      sourceConfig['soap.params'] = {};

      _.forEach(soapConfig.params, ({ path, value }) => {
        if (value !== null) {
          sourceConfig['soap.params'][path] = value;
        }
      });
    } else if (meta.connectionCategory === CONNECTION_CATEGORY_DATABASE) {
      const { parentDataSet } = this.props;
      sourceConfig = { ...this.props.sourceConfig };

      if (sourceConfig.db_query_mode === 'Query') {
        delete sourceConfig['incrementing.column.name'];
        delete sourceConfig['incrementing.load.from'];
        delete sourceConfig['timestamp.column.name'];
        delete sourceConfig['timestamp.load.from'];
      }

      sourceConfig = UIUtils.reduceConfig(sourceConfig, configFields);
    } else if (meta.connectionCategory === CONNECTION_CATEGORY_NOSQL) {
      sourceConfig = { ...this.props.sourceConfig };

      //NSTODO: nosql doesn't have db_query_mode. instead we are forcing a mode==='default' that should be stripped out from payload.

      if (sourceConfig.mode === 'default') {
        delete sourceConfig['mode'];
      }

      // if (sourceConfig.db_query_mode === 'Query') {
      //   //remove all properties for configuring the modes
      //   delete sourceConfig['mode'];
      //   delete sourceConfig['timestamp.key'];
      //   delete sourceConfig['timestamp.load.from'];
      //   delete sourceConfig['timestamp.load.to'];
      // } else {
      //   delete sourceConfig['query'];
      // }
      let { database, collection } = sourceConfig;
      sourceConfig = {
        ...UIUtils.reduceConfig(sourceConfig, configFields),
        database,
        collection,
      };
    } else if (meta.connectionCategory === CONNECTION_CATEGORY_KAFKA) {
      const { sourceConfig: currentSourceConfig } = this.props;

      sourceConfig = UIUtils.reduceConfig(currentSourceConfig, configFields);
    } else if (meta.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_API) {
      const { templatizedAPIConfig } = this.props;
      sourceConfig = UIUtils.buildSourceFromTemplatizedAPIConfig(
        templatizedAPIConfig,
        configFields,
      );
    } else if (
      meta.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT ||
      meta.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT
    ) {
      const { templatizedScriptConfig, sourceBeingEdited, vendors } = this.props;
      const vendor = vendors?.[sourceBeingEdited?.vendor_id];
      const isSqlRunner = vendor?.name === CONNECTOR_CODE_SQL_RUNNER;
      sourceConfig = isSqlRunner
        ? UIUtils.buildSqlRunnerSourceFromTemplatizedScriptConfig(
            templatizedScriptConfig,
            configFields,
          )
        : UIUtils.buildSourceFromTemplatizedScriptConfig(templatizedScriptConfig, configFields);
    } else if (meta.connectionCategory === CONNECTION_CATEGORY_NEXLA_MONITOR) {
      sourceConfig = this._getNexlaMonitorConfig();
    } else {
      //check if any conditional params are to be rendered. if they are missing in source config add their default value.
      sourceConfig = UIUtils.configWithMissingDefaults(this.props.sourceConfig, configFields);

      if (
        (selectedConnection === 'gdrive' && sourceConfig['ui.selected_file_mime_type']) ||
        !sourceConfig['ignore.files.older.than.ms']
      ) {
        delete sourceConfig['ignore.files.older.than.ms'];
      }

      // if ui.use_custom_processor is false, remove custom processor fields
      if (!sourceConfig['ui.use_custom_processor']) {
        delete sourceConfig.customProcessorId;
        delete sourceConfig.customProcessorCode;
        delete sourceConfig.post_processor;
      }
    }

    // populate high capacity fields
    const hcFields = _.filter(configFields, (field) =>
      Constants.HC_SOURCE_FIELD_NAMES.includes(field.name),
    );

    if (UIUtils.isHCEnabled(currentOrg.id, selectedConnection)) {
      sourceConfig = UIUtils.configWithMissingDefaults(sourceConfig, hcFields);

      _.forEach(hcFields, (field) => {
        if (!UIUtils.shouldRenderField(field, sourceConfig)) {
          delete sourceConfig[field.name];
        }
      });
    } else {
      _.forEach(hcFields, (field) => {
        delete sourceConfig[field.name];
      });
    }

    if (
      meta.connectionCategory === CONNECTION_CATEGORY_FILE ||
      meta.connectionCategory === CONNECTION_CATEGORY_FILE_UPLOAD
    ) {
      sourceConfig = UIUtils.reduceConfig(sourceConfig, configFields);
    }

    return sourceConfig;
  }

  _getDataPathFromAPIConfig(apiConfig) {
    const fieldNames = ITERATION_TYPE_TO_FIELDS_MAP[apiConfig['iteration.type']];
    const dataPathFieldNames = ['response.data.path'].concat(
      _.find(fieldNames, (name) => name.endsWith('.data.path')),
    );
    const result = {};

    _.forEach(dataPathFieldNames, (dataPathFieldName) => {
      if (!apiConfig[dataPathFieldName]) {
        return;
      }

      let dataPath = apiConfig[dataPathFieldName];

      if (
        apiConfig['contentType'] === 'application/json' &&
        !dataPath.startsWith('$.') &&
        !dataPath.startsWith('$[') &&
        dataPath !== '$'
      ) {
        const prefix = dataPath.charAt(0) === '[' ? '$' : '$.';
        dataPath = `${prefix}${dataPath}`;
      }

      result[dataPathFieldName] = dataPath;
    });

    return result;
  }

  _getNonDataMapIterations(iterations = null) {
    const { apiConfig } = this.props;
    const config = iterations ? iterations : apiConfig['rest.iterations'];

    return _.filter(config, (iteration) => iteration['iteration.type'] !== 'data.map.key.queue');
  }

  _getPipelineFormPath() {
    const { previousPath, addedDataSource } = this.props;

    if (previousPath) {
      if (
        isNUIURLStartsWith(previousPath, `${ROUTE_PIPELINES}/new`) ||
        isNUIURLEquals(this.context, previousPath, ROUTE_SELECT_PIPELINE_TYPE)
      ) {
        return formatNUIURL(this.context, `${ROUTE_PIPELINES}`);
      }

      if (PIPELINE_FORM_PATH_PATTERN.test(previousPath)) {
        return previousPath;
      }
    }

    return null;
  }

  _validateSelectConnection(data, onSuccess, onError) {
    if (data.selectedConnection) {
      onSuccess();
    } else {
      onError('Please select a data connection.');
    }
  }

  onChangeTemplate = (id) => {
    const { selectedConnection, selectedCredentialInfo, paging } = this.props;
    const effectiveConnectionType =
      (selectedCredentialInfo && selectedCredentialInfo._vendorConnectionType) ||
      selectedConnection;
    const { templates, items } = effectiveConnectionType
      ? paging.connAuthById[effectiveConnectionType]
      : {};
    this.setState({
      selectedTemplate: Number(id),
      connectionAuthFields: this.getActiveItems(templates, items, Number(id)),
    });
  };

  getActiveItems = (templates, items, selectedTemplate) => {
    const template = templates?.find((t) => t.id === selectedTemplate) || templates?.[0];
    return templates && templates?.length > 1 && template
      ? items.filter((item) => template.auth_parameters.includes(item.param_id))
      : items;
  };

  _validateSelectCredential(data, onSuccess, onError) {
    const { updateFormData } = this.props;
    const { isNewCredential, selectedCredentialInfo, selectedCredentialId } = data;

    // required field validation
    if (isNewCredential) {
      //this is new credential. verify that all required fields are populated
      const { paging, selectedConnection } = this.props;
      const { templates, items } =
        paging.connAuthById[
          (selectedCredentialInfo && selectedCredentialInfo._vendorConnectionType) ||
            selectedConnection
        ] || {};

      const missingFields = getEmptyRequiredFields(
        this.getActiveItems(templates, items, this.state.selectedTemplate),
        selectedCredentialInfo,
      );

      //check if credential name has been added or not.
      if (!_.get(selectedCredentialInfo, 'cred_name')) {
        missingFields.unshift({
          name: 'cred_name',
          display_name: 'Credential Name',
        });
      }

      const errorMessage = formatValidationErrorMessage(missingFields);

      if (errorMessage) {
        onError(errorMessage);
        return;
      }
    } else if (!data.selectedCredentialId) {
      onError('Please select or create a credential');
      return;
    }

    // create new credential or probe the selected one
    const { credentialCreationStatus, credentialProbeStatus, credentials } = this.props;
    const { selectCredentialAwaitingCreation, selectCredentialAwaitingProbe } = this.state;

    this._boundValidateSelectCredential = this._validateSelectCredential.bind(this, ...arguments);

    // if credential probe was successful, credentials are valid
    if (selectCredentialAwaitingProbe) {
      this.setState({ selectCredentialAwaitingProbe: false });

      const wasNewCredential = this.probeAfterNewCredentialRef;
      this.probeAfterNewCredentialRef = false;

      if (!credentialProbeStatus.isValid) {
        const probeMessage =
          credentialProbeStatus.message || 'The selected credentials did not work.';
        if (wasNewCredential) {
          // New credential: surface error via form-error banner, clear probe status, stay on page
          // so the user can explicitly select the credential and continue.
          this.probeCredentialIdRef = null;
          updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, { credentialProbeStatus: null });
          onError(probeMessage);
        } else {
          onError(probeMessage);
        }
        return;
      }

      const selectedCredential = credentials[credentialProbeStatus.credential];

      updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
        ...this._getFormDataFromCredential(selectedCredential.credentials_non_secure_data),
        credentialCreationStatus: null,
        credentialProbeStatus: null,
        selectedCredential,
        selectedCredentialId: selectedCredential.id,
        isNewCredential: false,
      });

      if (wasNewCredential) {
        const credName = selectedCredential.cred_name || selectedCredential.name || 'Credential';
        this.probeCredentialIdRef = null;
        this.props.showSuccess?.(`${credName} created successfully`);
      }
      onSuccess();
      return;
    }

    if (isNewCredential) {
      if (selectCredentialAwaitingCreation) {
        this.setState({ selectCredentialAwaitingCreation: false });

        // if creation failed, error
        if (credentialCreationStatus.message) {
          onError(credentialCreationStatus.message);
          return;
        }

        /**
         * after the credential is created, we need to select it immediately and then probe it (closes the modal)
         */
        const createdCredentialId = credentialCreationStatus.credential;
        const createdCredential = credentials[createdCredentialId];

        updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, {
          isNewCredential: false,
          selectedCredential: createdCredential,
          selectedCredentialId: createdCredentialId,
        });

        this.probeCredentialIdRef = createdCredentialId;
        this.probeAfterNewCredentialRef = true;
        this.setState(
          {
            selectCredentialAwaitingProbe: true,
          },
          () => {
            this._onRequestCredentialProbe(createdCredentialId);
          },
        );
        return;
      }

      // request cred creation
      this.probeAfterNewCredentialRef = false;
      this.setState(
        {
          selectCredentialAwaitingCreation: true,
        },
        () => {
          let credentialId = credentialCreationStatus ? credentialCreationStatus.credential : null;
          this._onRequestCredentialCreation(selectedCredentialInfo, credentialId);
        },
      );
      return;
    }

    // If probe already completed for this credential (e.g., after edit modal where
    // updateCredentialAndProbe wrote the result to FORM_TYPE_CREATE_DATA_SOURCE),
    // use the cached result and skip re-probing.
    if (credentialProbeStatus && credentialProbeStatus.credential === selectedCredentialId) {
      const { updateFormData } = this.props;
      updateFormData(FORM_TYPE_CREATE_DATA_SOURCE, { credentialProbeStatus: null });
      this.probeAfterNewCredentialRef = false;
      if (credentialProbeStatus.isValid) {
        onSuccess();
      } else {
        onError(credentialProbeStatus.message || 'Connection test failed.');
      }
      return;
    }

    // probe selected credential
    const credentialId = selectedCredentialInfo.id || selectedCredentialId;
    this.probeCredentialIdRef = credentialId;
    this.probeAfterNewCredentialRef = false;
    this.setState({ selectCredentialAwaitingProbe: true }, () => {
      this._onRequestCredentialProbe(credentialId, true);
    });
  }

  _validateConfigureRestSource(ignored, onSuccess, onError) {
    // for each stage
    //   validate required fields
    // create data source
    // if creation successful, finish validation
    const { apiConfig, addedDataSource } = this.props;
    const { restValidationStageIndex, configureAPIAwaitingDataSource } = this.state;

    // Skip flow triggers validation if start.cron is present and non-empty
    const startCron = apiConfig?.['start.cron'];

    // Only validate flow triggers if there's no scheduled ingestion
    if (!startCron?.trim() && apiConfig?.flow_triggers && !apiConfig?.flow_triggers?.length) {
      onError(
        'Please set a trigger for this data source since "Scheduled Ingestion" is not enabled',
      );
      return;
    }

    this._boundValidateConfigureRestSource = this._validateConfigureRestSource.bind(
      this,
      ...arguments,
    );

    // if a data source has been created, validation successful
    if (configureAPIAwaitingDataSource && addedDataSource) {
      this.setState({ configureAPIAwaitingDataSource: false });
      onSuccess();
      return;
    }

    // Validate all stages' required fields at once
    const iterations = this._getNonDataMapIterations();
    if (!isUiModeCode(apiConfig)) {
      for (let stageIndex = 0; stageIndex < iterations.length; stageIndex++) {
        const requiredFieldErrorMessage =
          this._validateConfigureRestSourceRequiredFields(stageIndex);

        if (requiredFieldErrorMessage) {
          onError(requiredFieldErrorMessage);
          return;
        }
      }
    }

    // All stages validated, proceed to create data source
    this.setState(
      {
        configureAPIAwaitingDataSource: true,
        restValidationStageIndex: iterations.length,
      },
      () => {
        this._onRequestSourceCreation(onError);
      },
    );
  }

  _validateNexlaMonitorFields() {
    const {
      nexlaMonitorApiConfig,
      paging: { sourceConfigById },
      selectedConnection,
    } = this.props;

    let isAdvanceMode = _.get(nexlaMonitorApiConfig, 'advanced_templatized_api', false);
    const template = _.get(nexlaMonitorApiConfig, 'template', null);
    if (!isAdvanceMode && _.isEmpty(template)) return 'Template is not selected.';

    const templateFields = _.get(nexlaMonitorApiConfig, 'template.fields', []);
    let sourceFields = sourceConfigById[selectedConnection];
    sourceFields = _.concat(templateFields, sourceFields);

    const connectionFields = _.keyBy(sourceFields, (field) => field.name);

    let fieldNames = [];
    _.forEach(templateFields, (field) => fieldNames.push(field.name));

    const fields = _.map(fieldNames, (name) => connectionFields[name]);
    return this._validateRequiredFields(nexlaMonitorApiConfig, fields);
  }

  _validateConfigureSOAPSource(ignored, onSuccess, onError) {
    const { configureSOAPAwaitingDataSource } = this.state;
    const { addedDataSource } = this.props;

    this._boundValidateConfigureSOAPSource = this._validateConfigureSOAPSource.bind(
      this,
      ...arguments,
    );

    // if a data source has been created, validation successful
    if (configureSOAPAwaitingDataSource && addedDataSource) {
      this.setState({
        configureSOAPAwaitingDataSource: false,
      });

      onSuccess();
      return;
    }

    // required field validation
    const sourceConfig = this._buildSourceConfigFromProps();
    if (!isUiModeCode(sourceConfig)) {
      const requiredFieldsError = this._validateRequiredFields(sourceConfig);

      if (requiredFieldsError) {
        onError(requiredFieldsError);
        return;
      }
    }

    // required params validation (disabled temporarily)
    /*if (_.isEmpty(missingFields)) {
      const wsdl = _.get(probeSample, 'wsdl');
      const selectedServiceName = sourceConfig['soap.service'];
      const selectedService = _.find(wsdl.services, {
        name: selectedServiceName
      });
      const selectedBindingName = sourceConfig['soap.binding'];
      const selectedBinding = _.find(selectedService.bindings, {
        name: selectedBindingName
      });
      const selectedOperationName = sourceConfig['soap.operation'];
      const selectedOperation = _.find(selectedBinding.operations, {
        name: selectedOperationName
      });
      const params = sourceConfig['soap.params'];

      _.forEach(selectedOperation.parameters, (param) => {
        if (param.required && !has(params, param.path)) {
          missingFields.push(param);
        }
      });
    }*/

    this.setState(
      {
        configureSOAPAwaitingDataSource: true,
      },
      () => {
        this._onRequestSourceCreation(onError);
      },
    );
  }

  _validateConfigureTemplatizedAPISource(data, onSuccess, onError) {
    const { configureTemplatizedAPIAwaitingDataSource } = this.state;
    const { templatizedAPIConfig, apiConfig, addedDataSource } = this.props;

    if (apiConfig && apiConfig.advanced_templatized_api) {
      return this._validateConfigureRestSource(data, onSuccess, onError);
    }

    this._boundValidateConfigureTemplatizedAPISource =
      this._validateConfigureTemplatizedAPISource.bind(this, ...arguments);

    // if a data source has been created, validation successful
    if (configureTemplatizedAPIAwaitingDataSource && addedDataSource) {
      this.setState({ configureTemplatizedAPIAwaitingDataSource: false });
      onSuccess();
      return;
    }

    // required field validation
    if (!isUiModeCode(templatizedAPIConfig)) {
      const requiredFieldsError = this._validateRequiredFields(templatizedAPIConfig);

      if (requiredFieldsError) {
        onError(requiredFieldsError);
        return;
      }
    }

    this.setState({ configureTemplatizedAPIAwaitingDataSource: true }, () => {
      this._onRequestSourceCreation(onError);
    });
  }

  _validateConfigureTemplatizedScriptSource(ignored, onSuccess, onError) {
    const { configureTemplatizedScriptAwaitingDataSource } = this.state;
    const { templatizedScriptConfig, addedDataSource } = this.props;

    this._boundValidateConfigureTemplatizedScriptSource =
      this._validateConfigureTemplatizedScriptSource.bind(this, ...arguments);

    // if a data source has been created, validation successful
    if (configureTemplatizedScriptAwaitingDataSource && addedDataSource) {
      this.setState({
        configureTemplatizedScriptAwaitingDataSource: false,
      });

      onSuccess();
      return;
    }

    // required field validation — skip in JSON/code mode for parity with
    // _validateConfigureTemplatizedAPISource. Today the script form has no
    // JSON drawer, but the guard prevents future regressions of NEX-21287.
    if (!isUiModeCode(templatizedScriptConfig)) {
      const requiredFieldsError = this._validateRequiredFields(templatizedScriptConfig);

      if (requiredFieldsError) {
        onError(requiredFieldsError);
        return;
      }
    }

    this.setState(
      {
        configureTemplatizedScriptAwaitingDataSource: true,
      },
      () => {
        this._onRequestSourceCreation(onError);
      },
    );
  }

  _validateConfigureWebhookSource(ignored, onSuccess, onError) {
    const { configureWebhookAwaitingDataSource } = this.state;
    const { addedDataSource, sourceBeingEdited, selectedCredentialId } = this.props;

    this._boundValidateConfigureWebhookSource = this._validateConfigureWebhookSource.bind(
      this,
      ...arguments,
    );
    if (configureWebhookAwaitingDataSource && (addedDataSource || sourceBeingEdited)) {
      this.setState({
        configureWebhookAwaitingDataSource: false,
      });

      onSuccess();
      return;
    }

    // Reset flag if set but no data source exists (previous creation failed)
    if (configureWebhookAwaitingDataSource && !addedDataSource && !sourceBeingEdited) {
      this.setState({
        configureWebhookAwaitingDataSource: false,
      });
    }

    if (!addedDataSource && !sourceBeingEdited) {
      onError('Please generate a webhook URL.');
      return;
    }

    // if a data source has been created, validation successful
    const sourceInfo = {
      name: this.state.sourceName,
      description: this.state.sourceDescription,
    };
    const sourceId =
      sourceBeingEdited && has(sourceBeingEdited, 'id') ? sourceBeingEdited.id : addedDataSource.id;
    sourceInfo.source_config = this._buildSourceConfigFromProps();

    this.props.updateDataSourceFromForm(
      FORM_TYPE_CREATE_DATA_SOURCE,
      sourceId,
      sourceInfo,
      CONNECTION_CATEGORY_WEBHOOK,
      true,
      selectedCredentialId,
    );

    this.setState({
      configureWebhookAwaitingDataSource: true,
    });
  }

  _validateConfigureEmailScriptSource(data, onSuccess, onError) {
    const { configureScriptAwaitingDataSource } = this.state;
    const { addedDataSource, sourceBeingEdited, selectedCredentialId } = this.props;

    this._boundValidateConfigureScriptSource = this._validateConfigureEmailScriptSource.bind(
      this,
      ...arguments,
    );
    if (configureScriptAwaitingDataSource && (addedDataSource || sourceBeingEdited)) {
      this.setState({
        configureScriptAwaitingDataSource: false,
      });

      onSuccess();
      return;
    }

    // Reset flag if set but no data source exists (previous creation failed)
    if (configureScriptAwaitingDataSource && !addedDataSource && !sourceBeingEdited) {
      this.setState({
        configureScriptAwaitingDataSource: false,
      });
    }

    if (!addedDataSource && !sourceBeingEdited) {
      onError('Please click on create source button');
      return;
    }

    // if a data source has been created, validation successful
    this.setState(
      {
        configureScriptAwaitingDataSource: true,
      },
      () => {
        const sourceInfo = {
          name: this.state.sourceName,
          description: this.state.sourceDescription,
        };
        const sourceId =
          sourceBeingEdited && has(sourceBeingEdited, 'id')
            ? sourceBeingEdited.id
            : addedDataSource.id;

        // TODO: Email client should not require any source config be sent
        //       sourceInfo.script_config = this._buildSourceConfigFromProps();

        this.props.updateDataSourceFromForm(
          FORM_TYPE_CREATE_DATA_SOURCE,
          sourceId,
          sourceInfo,
          CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT,
          true,
          selectedCredentialId,
        );
      },
    );
  }

  _createFileDataSource(files, onError) {
    const filesToUpload = Array.isArray(files) ? files : files ? [files] : [];
    const firstFile = filesToUpload.length ? filesToUpload[0] : null;
    const isFileSizeExceeded =
      MAX_UPLOAD_FILE_SIZE && filesToUpload.some((file) => file.size > MAX_UPLOAD_FILE_SIZE);

    if (isFileSizeExceeded) {
      onError(
        `One or more files exceed the file size limit of ${bytesToString(MAX_UPLOAD_FILE_SIZE)}.`,
      );
      return;
    }

    this.setState(
      {
        configureFileUploadAwaitingDataSource: true,
      },
      () => {
        this._onRequestSourceCreation(onError);
      },
    );
  }

  _validateConfigureFileUploadSource(data, onSuccess, onError) {
    const { addedDataSource, uploadFileToSource } = this.props;

    const {
      selectedFile,
      selectedFiles,
      configureFileUploadAwaitingUpload,
      configureFileUploadAwaitingDataSource,
    } = this.state;

    const filesToUpload =
      selectedFiles && selectedFiles.length ? selectedFiles : selectedFile ? [selectedFile] : [];
    const { files: filesToUploadWithIds, mutated } = this._ensureFilesHaveIds(filesToUpload);

    // Ensure state holds normalized files before progressing so that progress updates
    // (which rely on file.id) are reflected in the UI.
    if (mutated) {
      this.setState(
        {
          selectedFiles: filesToUploadWithIds,
          selectedFile: filesToUploadWithIds.length ? filesToUploadWithIds[0] : null,
        },
        () => this._validateConfigureFileUploadSource(data, onSuccess, onError),
      );
      return;
    }

    const oversizedFile =
      MAX_UPLOAD_FILE_SIZE && filesToUploadWithIds.find((file) => file.size > MAX_UPLOAD_FILE_SIZE);

    if (oversizedFile) {
      onError(
        `The file "${oversizedFile.name}" exceeds the file size limit of ${bytesToString(
          MAX_UPLOAD_FILE_SIZE,
        )}.`,
      );
      return;
    }

    this._boundValidateConfigureFileUploadSource = this._validateConfigureFileUploadSource.bind(
      this,
      ...arguments,
    );

    // if file upload complete, validation successful
    if (configureFileUploadAwaitingUpload) {
      this.setState({
        configureFileUploadAwaitingUpload: false,
      });

      onSuccess();
      return;
    }

    // if a data source has been created, upload file
    if (configureFileUploadAwaitingDataSource && addedDataSource) {
      this.setState({
        configureFileUploadAwaitingDataSource: false,
      });

      if (filesToUpload.length) {
        this.setState(
          {
            configureFileUploadAwaitingUpload: true,
          },
          () => {
            Promise.all(
              filesToUploadWithIds.map((file) =>
                this._uploadSingleFile(addedDataSource.id, file, uploadFileToSource),
              ),
            )
              .then(() => {
                this.setState({
                  configureFileUploadAwaitingUpload: false,
                });
                onSuccess();
              })
              .catch(() => {
                this.setState({
                  configureFileUploadAwaitingUpload: false,
                  configureFileUploadAwaitingDataSource: false,
                });
                // mark failed files as error for UI feedback
                this.setState((prevState) => ({
                  selectedFiles: (prevState.selectedFiles || []).map((file) =>
                    filesToUploadWithIds.find((f) => f.id === file.id)
                      ? {
                          ...file,
                          status: 'error',
                          uploadProgress: file.uploadProgress ?? 0,
                          backendUploadProgress: file.backendUploadProgress ?? 0,
                        }
                      : file,
                  ),
                }));
                onError('File upload failed');
              });
          },
        );
      } else {
        onSuccess();
      }
      return;
    }

    // required field validation
    if (!isUiModeCode(data.sourceConfig)) {
      const requiredFieldsError = this._validateRequiredFields(data.sourceConfig);

      if (requiredFieldsError) {
        onError(requiredFieldsError);
        return;
      }
    }

    this._createFileDataSource(filesToUploadWithIds, onError);
  }

  _validateConfigureSyslogSource(data, onSuccess, onError) {
    const { addedDataSource, sourceBeingEdited } = this.props;

    const { configureSyslogAwaitingDataSource } = this.state;

    this._boundValidateConfigureSyslogSource = this._validateConfigureSyslogSource.bind(
      this,
      ...arguments,
    );

    // if a data source has been created, validation successful
    if (configureSyslogAwaitingDataSource && addedDataSource) {
      this.setState({
        configureSyslogAwaitingDataSource: false,
      });

      onSuccess();
      return;
    }

    this.setState(
      {
        configureSyslogAwaitingDataSource: true,
      },
      () => {
        this._onRequestSourceCreation(onError);
      },
    );
  }

  _validateConfigureRestSourceRequiredFields(stageIndex) {
    const { apiConfig, paging, selectedConnection } = this.props;
    const stageAPIConfig = apiConfig['rest.iterations'][stageIndex];
    const { isPaginated } = stageAPIConfig;
    const sourceConfigFields = paging.sourceConfigById;
    const connectionFields = _.keyBy(sourceConfigFields[selectedConnection], (field) => field.name);
    let fieldNames = ['url.template'];

    if (isPaginated) {
      const iterationType = stageAPIConfig['iteration.type'];
      fieldNames = fieldNames.concat(ITERATION_TYPE_TO_FIELDS_MAP[iterationType]);
    }

    const fields = _.map(fieldNames, (name) => connectionFields[name]);
    return this._validateRequiredFields(stageAPIConfig, fields);
  }

  /**
   * True when a REST stage's *missing* required fields are pagination settings only —
   * the URL is filled in but the pagination iteration's fields are blank. Detected from
   * the actual missing fields (not a heuristic), so it can drive a clearer error header.
   */
  _isRestPaginationFieldsMissing(stageIndex) {
    const { apiConfig, paging, selectedConnection } = this.props;
    const stageAPIConfig = apiConfig['rest.iterations']?.[stageIndex];

    if (!stageAPIConfig?.isPaginated) {
      return false;
    }

    const connectionFields = _.keyBy(
      paging.sourceConfigById[selectedConnection],
      (field) => field.name,
    );
    const toFields = (names) => _.map(names, (name) => connectionFields[name]).filter(Boolean);

    const missingUrl = getEmptyRequiredFields(toFields(['url.template']), stageAPIConfig);
    const paginationFieldNames =
      ITERATION_TYPE_TO_FIELDS_MAP[stageAPIConfig['iteration.type']] || [];
    const missingPagination = getEmptyRequiredFields(
      toFields(paginationFieldNames),
      stageAPIConfig,
    );

    // Pagination-specific only when the URL is fine but pagination fields are missing.
    return _.isEmpty(missingUrl) && !_.isEmpty(missingPagination);
  }

  _validateDataPath(stageAPIConfig, stageIndex = 0) {
    const dataPaths = this._getDataPathFromAPIConfig(stageAPIConfig);

    if (_.isEmpty(dataPaths)) {
      let now = Date.now();
      this.setState({
        dataPathValidationResultByStage: {
          ...this.state.dataPathValidationResultByStage,
          [stageIndex]: {
            status: true,
          },
        },
        apiResponseUpdateTime: now,
      });
      return;
    }

    const { apiResponseByStage } = this.state;
    const dataPathValidationResult = validateDataPath(
      dataPaths,
      apiResponseByStage[stageIndex],
      stageAPIConfig,
    );

    this.setState({
      dataPathValidationResultByStage: {
        ...this.state.dataPathValidationResultByStage,
        [stageIndex]: dataPathValidationResult,
      },
      apiResponseUpdateTime: Date.now(),
    });
  }

  _validateSOAPDataPath(dataPath, probeSample) {
    const callResult = _.get(probeSample, 'callResult');
    let soapResponse;

    if (callResult) {
      const { response, statusCode } = callResult;

      if (statusCode < 400) {
        soapResponse = response;
      }
    }

    let validationResult;
    let matches;
    try {
      matches = selectXPath(dataPath, soapResponse);
    } catch (error) {
      validationResult = { status: false, message: 'Failed to parse response' };
      console.error(validationResult);
    }

    if (_.isEmpty(matches)) {
      validationResult = {
        status: false,
        message: 'No match found',
        matches,
      };
    } else {
      validationResult = {
        status: true,
        message: `${matches.length} records found`,
        matches,
      };
    }

    this.setState({
      soapDataPathValidationResult: validationResult,
    });
  }

  _validateConfigureKafkaSource(data, onSuccess, onError) {
    const { configureKafkaAwaitingDataSource } = this.state;
    const { addedDataSource } = this.props;

    this._boundValidateConfigureKafkaSource = this._validateConfigureKafkaSource.bind(
      this,
      ...arguments,
    );

    // if a data source has been created, validation successful
    if (configureKafkaAwaitingDataSource && addedDataSource) {
      this.setState({
        configureKafkaAwaitingDataSource: false,
      });

      onSuccess();
      return;
    }

    // if awaiting flag is set but no data source exists, reset flag (previous creation failed)
    if (configureKafkaAwaitingDataSource && !addedDataSource) {
      this.setState({
        configureKafkaAwaitingDataSource: false,
      });
    }

    // required field validation
    if (!isUiModeCode(data.sourceConfig)) {
      const requiredFieldsError = this._validateRequiredFields(data.sourceConfig);

      if (requiredFieldsError) {
        onError(requiredFieldsError);
        return;
      }
    }

    // create data source
    this.setState(
      {
        configureKafkaAwaitingDataSource: true,
      },
      () => {
        this._onRequestSourceCreation(onError);
      },
    );
  }

  async _validateConfigureFileSource(data, onSuccess, onError) {
    const { paging, sourceConfig, selectedConnection, selectedBucket, addedDataSource } =
      this.props;
    const ignorePath = CONNECTORS_WITHOUT_PATH.includes(selectedConnection);
    const { configureFileAwaitingDataSource } = this.state;
    const isAdvancedMode = isUiModeCode(sourceConfig);

    this._boundValidateConfigureFileSource = this._validateConfigureFileSource.bind(
      this,
      ...arguments,
    );

    if (!isAdvancedMode && sourceConfig['ui.use_custom_processor']) {
      try {
        await this._validateCustomProcessor();
      } catch (error) {
        onError(error);
        return;
      }
    }

    // if a data source has been created, validation successful
    if (configureFileAwaitingDataSource && addedDataSource) {
      this.setState({
        configureFileAwaitingDataSource: false,
      });

      onSuccess();
      return;
    }

    // Reset flag if set but no data source exists (previous creation failed)
    if (configureFileAwaitingDataSource && !addedDataSource) {
      this.setState({
        configureFileAwaitingDataSource: false,
      });
    }
    const selectedConnectionMeta = selectedConnection
      ? paging.metaInfoById[selectedConnection]
      : null;

    // required field validation
    if (!selectedBucket && !ignorePath) {
      switch (selectedConnectionMeta.connectionCategory) {
        case CONNECTION_CATEGORY_FILE: {
          /**
           * If it is advanced-mode configuration, ignore this validation
           */
          if (isAdvancedMode === false) {
            onError('Please select a folder to scan.');
            return;
          }
          break;
        }
        case CONNECTION_CATEGORY_NOSQL: {
          /**
           * If it is advanced-mode configuration, ignore this validation
           */
          if (isAdvancedMode === false) {
            onError('Please select a collection to scan.');
            return;
          }
          break;
        }

        case CONNECTION_CATEGORY_DATABASE:
          if (!isAdvancedMode) {
            if (!sourceConfig.db_query_mode || sourceConfig.db_query_mode === 'Default') {
              if (!sourceConfig.database) {
                onError('Please select a database to scan.');
                return;
              }
              if (!sourceConfig.table) {
                onError('Please select a table to scan.');
                return;
              }
            }
          }

          break;
      }
    }

    if (!isAdvancedMode) {
      const requiredFieldsError = this._validateRequiredFields(sourceConfig);

      if (requiredFieldsError) {
        onError(requiredFieldsError);
        return;
      }
    }

    // create data source
    this.setState(
      {
        configureFileAwaitingDataSource: true,
      },
      () => {
        this._onRequestSourceCreation(onError);
      },
    );
  }

  _validateNexlaMonitorSource(data, onSuccess, onError) {
    const { configureNexlaMonitorAwaitingDataSource } = this.state;
    const { nexlaMonitorApiConfig, addedDataSource } = this.props;

    const isAdvanceMode = _.get(nexlaMonitorApiConfig, 'advanced_templatized_api', false);
    if (isAdvanceMode) {
      this._validateConfigureRestSource(data, onSuccess, onError);
      return;
    }

    this._boundValidateConfigureNexlaMonitorSource = this._validateNexlaMonitorSource.bind(
      this,
      ...arguments,
    );

    // if a data source has been created, validation successful
    if (configureNexlaMonitorAwaitingDataSource && addedDataSource) {
      this.setState({
        configureNexlaMonitorAwaitingDataSource: false,
      });

      onSuccess();
      return;
    }
    // required field validation
    if (!isUiModeCode(nexlaMonitorApiConfig)) {
      const requiredFieldsError = this._validateNexlaMonitorFields();

      if (requiredFieldsError) {
        onError(requiredFieldsError);
        return;
      }
    }

    this.setState(
      {
        configureNexlaMonitorAwaitingDataSource: true,
      },
      () => {
        this._onRequestSourceCreation(onError);
      },
    );
  }

  _validateConfigureELTSource(data, onSuccess, onError) {
    const { configureELTAwaitingDataSource } = this.state;
    const { sourceConfig, addedDataSource, selectedFeeds } = this.props;

    this._boundValidateConfigureELTSource = this._validateConfigureELTSource.bind(
      this,
      ...arguments,
    );

    // if a data source has been created, validation successful
    if (configureELTAwaitingDataSource && addedDataSource) {
      this.setState({ configureELTAwaitingDataSource: false });
      onSuccess();
      return;
    }

    if (isUiModeCode(sourceConfig)) {
      this.setState({ configureELTAwaitingDataSource: true }, () => {
        this._onRequestSourceCreation(onError);
      });
      return;
    }

    // Check if name is provided
    if (!this.state.sourceName) {
      onError('Please set a name for this source.');
      return;
    }

    // required field validation
    const requiredFieldsError = this.validateRequiredELTFields(sourceConfig);

    if (requiredFieldsError) {
      onError(requiredFieldsError);
      return;
    }

    // Check if at least one feed is selected
    if (!selectedFeeds || selectedFeeds.length === 0) {
      onError('Please select at least one feed.');
      return;
    }

    this.setState({ configureELTAwaitingDataSource: true }, () => {
      this._onRequestSourceCreation(onError);
    });
  }

  validateRequiredELTFields(sourceConfig, fields) {
    if (isUiModeCode(sourceConfig)) return;

    const {
      paging: { sourceConfigById },
      selectedConnection,
    } = this.props;
    const service = createELTService(flowTypes.streaming);

    const connectionFields = fields
      ? fields
      : sourceConfigById && selectedConnection
        ? sourceConfigById[selectedConnection]
        : null;

    const missingFields = service.getMissingFields(connectionFields, sourceConfig);

    if (!_.isEmpty(missingFields)) {
      const errorMessage = _.reduce(
        missingFields,
        (message, field) => `${message} ${field.display_name},`,
        'Please enter the following required fields: ',
      );

      return errorMessage.substring(0, errorMessage.length - 1);
    }
  }

  _validateRequiredFields(data, fields = null) {
    if (isUiModeCode(data)) return null;

    const {
      paging: { sourceConfigById },
      selectedConnection,
      parentDataSet,
    } = this.props;
    const connectionFields = fields
      ? fields
      : sourceConfigById && selectedConnection
        ? sourceConfigById[selectedConnection]
        : null;

    // for API Server target, don't validate start.cron
    const ignoredFields = parentDataSet ? ['start.cron'] : [];

    const missingFields = getEmptyRequiredFields(
      connectionFields?.filter((field) => field && !ignoredFields.includes(field.name)),
      data,
    );

    if (!_.isEmpty(missingFields)) {
      const errorMessage = _.reduce(
        missingFields,
        (message, field) => `${message} ${field.display_name},`,
        'Please enter the following required fields: ',
      );

      return errorMessage.substring(0, errorMessage.length - 1);
    }

    const flowTriggers =
      data?.flow_triggers ||
      data?.uiconfig?.flow_triggers ||
      data?.script_config?.flow_triggers ||
      data?.template_config?.flow_triggers;

    // start.cron - Most commonly used
    // script.start.cron - script-specific version
    // parameters.script.start.cron - parameterized version
    // script.cron - alternative script version
    // Skip flow triggers validation if start.cron is present and non-empty
    const startCron =
      data?.['start.cron'] ||
      data?.uiconfig?.['start.cron'] ||
      data?.script_config?.['start.cron'] ||
      data?.template_config?.['start.cron'] ||
      data?.['script.start.cron'] || // for script config e.g: ODOO ERP
      data?.['parameters.script.start.cron']; // for script config e.g: ELT Script Runner

    // Only validate flow triggers if there's no scheduled ingestion
    if (!startCron?.trim() && flowTriggers && !flowTriggers.length) {
      return 'Please set a trigger for this data source since "Scheduled Ingestion" is not enabled';
    }

    return null;
  }

  async _handleFormDismissed() {
    const { previousPath, addedDataSource, onDismiss } = this.props;

    if (onDismiss) {
      onDismiss(addedDataSource);
      return;
    }

    const pipelineFormPath = this._getPipelineFormPath();
    let redirectPath;

    // If user started flow creation from a project context but dismissed without creating,
    // use redirectToProjectIfNeeded to handle navigation and clear project ID
    if (this.props.currentProjectId && !addedDataSource) {
      redirectToProjectIfNeeded(
        this.props.history,
        this.props.currentProjectId,
        this.props.dispatch,
      );
      return;
    }

    // Use standard redirect logic
    if (pipelineFormPath) {
      redirectPath = pipelineFormPath;
    } else if (previousPath) {
      // navigate to pipelines
      redirectPath = previousPath;
    } else {
      redirectPath = formatNUIURL(this.context, ROUTE_PIPELINES);
    }

    if (redirectPath.includes(ROUTE_PIPELINES) && this.props.addedDataSource) {
      this.props.saveHashedState('flows.selected', this.props.addedDataSource.flow_node_id);
    }

    // Check if there's a projectId in the redux store to assign the flow to
    if (addedDataSource?.flow_node_id) {
      try {
        const projectId = this.props.currentProjectId;

        if (projectId) {
          // Avoid UI flicker by showing a loader while assigning and redirecting
          this.setState({ isRedirecting: true });
          const assignedProjectId = await assignFlowToProjectIfPresent({
            dispatch: this.props.dispatch,
            flowNodeId: addedDataSource.flow_node_id,
            currentProjectId: projectId,
          });

          if (assignedProjectId) {
            redirectToProjectIfNeeded(this.props.history, assignedProjectId, this.props.dispatch);
            return;
          } else {
            this.setState({ isRedirecting: false });
          }
        }
      } catch (error) {
        console.error('Failed to assign flow to project:', error);
        this.setState({ isRedirecting: false });
      }
    }

    // After project assignment check, if creating a new source (not editing) and it has a flow ID, navigate to edit screen
    if (!this.props.sourceBeingEditedId && addedDataSource?.origin_node_id) {
      const flowType = this.props.flowType || 'streaming'; // Default to streaming for flex flows
      redirectPath = `${ROUTE_CONNECT}${ROUTE_PIPELINES}/${flowType}/${addedDataSource.origin_node_id}/edit`;
    }

    this.setState({ redirectPath });
  }

  loadVendorInfo = (connection) => {
    const { loadFullVendor } = this.props;
    if (connection) {
      return loadFullVendor(connection);
    }
  };

  setEarlyIntent = (credentialId) => {
    const earlyIntentCaptureEnabled = getFeatureFlagValue('UI_CONNECTOR_CAPTURE_EARLY_INTENT');

    if (earlyIntentCaptureEnabled === true) {
      const { informEarlyIntent } = this.props;
      if (credentialId) {
        informEarlyIntent(credentialId);
      }
    }
    this.probeCredentialIdRef = null;
  };

  onConnectionSelected = (nextStageIndex) => {
    const { selectedConnection } = this.props;
    const enterAfterSelection = nextStageIndex === 1;
    if (selectedConnection && enterAfterSelection) {
      // Only (re)initialize when the connector actually changed. Re-entering
      // Authenticate for the SAME connector — e.g. after stepping back to Select and
      // coming forward again — must NOT wipe the user's in-progress config (cron,
      // URL, etc.). _initializeCreateForm resets the whole form, so guard against it.
      if (this._initializedConnection === selectedConnection) {
        return;
      }
      this._initializedConnection = selectedConnection;
      this.loadVendorInfo(selectedConnection)?.then(() => {
        this._initializeCreateForm(selectedConnection);
      });
      AnalyticsUtils.captureCustomEvent('data_source_connection_selected', {
        selected_connector: selectedConnection,
      });
    }
  };

  onChangeApiType = (connector) => {
    this.loadVendorInfo(connector).then(() => {
      this._initializeCreateForm(null, false, false);
    });
  };

  _handleFeedsSelected = (selectedFeeds) => {
    this.setState({ selectedFeeds });
  };

  goBack = () => {
    if (this.props.isModal) {
      this.props.onDismiss?.();
      return;
    }

    this.setState({ showAdvancedExitConfirmation: true });
  };

  _cancelAdvancedExit = () => {
    this.setState({ showAdvancedExitConfirmation: false });
  };

  _confirmAdvancedExit = () => {
    this.setState({ showAdvancedExitConfirmation: false }, () => {
      // Keep the fixed behavior: exit the page via dismiss flow (no POP).
      void this._handleFormDismissed();
    });
  };

  // Save confirmation modal logic for Flex Flow
  _handleSaveConfirmation = (runWithIngestion) => {
    const pendingValidation = this.state.pendingValidation;

    this.setState(
      {
        isSaving: true,
        showSaveConfirmation: false,
        pendingValidation: null,
      },
      () => {
        // Set the runWithIngestion state
        this.setState({ runWithIngestion }, () => {
          // Proceed with the stored pending validation
          const { validationMethod, onClick, onSuccess, onError, data } = pendingValidation || {};

          if (validationMethod) {
            validationMethod(
              data,
              () => {
                this.setState({ isSaving: false }, () => {
                  // Reset change detection after successful save
                  this._resetChangeDetection();
                  // Call the original onSuccess callback to trigger form completion
                  if (onSuccess && typeof onSuccess === 'function') {
                    onSuccess();
                  }
                });
              },
              (error) => {
                this.setState({ isSaving: false });
                // Call the original onError callback
                if (onError && typeof onError === 'function') {
                  onError(error);
                } else {
                }
              },
            );
          } else if (onClick) {
            onClick();
            this.setState({ isSaving: false });
          }
        });
      },
    );
  };

  _onCloseSaveConfirmation = () => {
    this.setState({
      showSaveConfirmation: false,
      pendingValidation: null,
    });

    // Reset the form's validation status to clear the loading indicator
    if (this.props.setFormAwaitingValidation) {
      this.props.setFormAwaitingValidation(FORM_TYPE_CREATE_DATA_SOURCE, false);
    }
  };

  // Initialize change detection for Flex Flow
  _initializeChangeDetection = () => {
    const {
      sourceConfig,
      apiConfig,
      templatizedScriptConfig,
      connectionCategory,
      sourceBeingEdited,
      vendors,
    } = this.props;
    const { sourceName, sourceDescription } = this.state;

    const isTemplatizedScript =
      connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT ||
      connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT;

    const vendor = vendors?.[sourceBeingEdited?.vendor_id];
    const isSqlRunner = isTemplatizedScript && vendor?.name === CONNECTOR_CODE_SQL_RUNNER;

    this.setState({
      initialSourceConfig: sourceConfig ? _.cloneDeep(sourceConfig) : null,
      initialApiConfig: apiConfig ? _.cloneDeep(apiConfig) : null,
      initialTemplatizedScriptConfig:
        isTemplatizedScript && templatizedScriptConfig
          ? _.cloneDeep(templatizedScriptConfig)
          : null,
      initialSourceName: sourceName,
      initialSourceDescription: sourceDescription,
    });
  };

  // Check if there are meaningful changes (similar to useChangeDetection hook)
  _hasMeaningfulChanges = () => {
    const {
      sourceConfig,
      apiConfig,
      templatizedScriptConfig,
      connectionCategory,
      sourceBeingEdited,
      vendors,
    } = this.props;
    const {
      sourceName,
      sourceDescription,
      initialSourceConfig,
      initialApiConfig,
      initialTemplatizedScriptConfig,
      initialSourceName,
      initialSourceDescription,
    } = this.state;

    // Check source config changes
    const hasSourceConfigChanges =
      initialSourceConfig && !_.isEqual(initialSourceConfig, sourceConfig);

    // Check API config changes
    const hasApiConfigChanges = initialApiConfig && !_.isEqual(initialApiConfig, apiConfig);

    // Check templatized script config changes (for sql_runner only)
    const isTemplatizedScript =
      connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT ||
      connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT;

    const vendor = vendors?.[sourceBeingEdited?.vendor_id];
    const isSqlRunner = isTemplatizedScript && vendor?.name === CONNECTOR_CODE_SQL_RUNNER;

    // Check templatized script config changes (sql_runner only)
    const hasTemplatizedScriptConfigChanges =
      isTemplatizedScript &&
      initialTemplatizedScriptConfig != null &&
      !_.isEqual(initialTemplatizedScriptConfig, templatizedScriptConfig);

    // Check name/description changes
    const hasNameChanges = initialSourceName !== sourceName;
    const hasDescriptionChanges = initialSourceDescription !== sourceDescription;

    const hasChanges =
      hasSourceConfigChanges ||
      hasApiConfigChanges ||
      hasTemplatizedScriptConfigChanges ||
      hasNameChanges ||
      hasDescriptionChanges;

    return hasChanges;
  };

  // Reset change detection after successful save
  _resetChangeDetection = () => {
    this._initializeChangeDetection();
  };

  // Wrapper method to check for save confirmation before validation
  _validateWithSaveConfirmation = (validationMethod, onSuccess, onError, data) => {
    const { sourceBeingEdited, connectionCategory } = this.props;
    const { isSaving } = this.state;

    // Use the new change detection method
    const hasChanges = this._hasMeaningfulChanges();

    // Check if we should show save confirmation modal
    if (
      sourceBeingEdited?.status === 'ACTIVE' && // Active source
      hasChanges && // Has changes (using new detection method)
      shouldRenderRunAction(sourceBeingEdited, connectionCategory) && // Can run
      !isSaving // Not already saving
    ) {
      this.setState({
        showSaveConfirmation: true,
        pendingValidation: { validationMethod, onSuccess, onError, data },
      });
      return;
    }

    validationMethod(data, onSuccess, onError);
  };

  // Wrapper methods for each validation type
  _validateConfigureRestSourceWithConfirmation = (data, onSuccess, onError) => {
    this._validateWithSaveConfirmation(this._validateConfigureRestSource, onSuccess, onError);
  };

  _validateConfigureSOAPSourceWithConfirmation = (data, onSuccess, onError) => {
    this._validateWithSaveConfirmation(this._validateConfigureSOAPSource, onSuccess, onError);
  };

  _validateConfigureTemplatizedAPISourceWithConfirmation = (data, onSuccess, onError) => {
    this._validateWithSaveConfirmation(
      this._validateConfigureTemplatizedAPISource,
      onSuccess,
      onError,
      data,
    );
  };

  _validateConfigureTemplatizedScriptSourceWithConfirmation = (data, onSuccess, onError) => {
    this._validateWithSaveConfirmation(
      this._validateConfigureTemplatizedScriptSource,
      onSuccess,
      onError,
    );
  };

  _validateConfigureWebhookSourceWithConfirmation = (data, onSuccess, onError) => {
    this._validateWithSaveConfirmation(this._validateConfigureWebhookSource, onSuccess, onError);
  };

  _validateConfigureEmailScriptSourceWithConfirmation = (data, onSuccess, onError) => {
    this._validateWithSaveConfirmation(
      this._validateConfigureEmailScriptSource,
      onSuccess,
      onError,
      data,
    );
  };

  _validateConfigureFileUploadSourceWithConfirmation = (data, onSuccess, onError) => {
    this._validateWithSaveConfirmation(
      this._validateConfigureFileUploadSource,
      onSuccess,
      onError,
      data,
    );
  };

  _validateConfigureSyslogSourceWithConfirmation = (data, onSuccess, onError) => {
    this._validateWithSaveConfirmation(
      this._validateConfigureSyslogSource,
      onSuccess,
      onError,
      data,
    );
  };

  _validateConfigureKafkaSourceWithConfirmation = (data, onSuccess, onError) => {
    this._validateWithSaveConfirmation(
      this._validateConfigureKafkaSource,
      onSuccess,
      onError,
      data,
    );
  };

  _validateConfigureFileSourceWithConfirmation = (data, onSuccess, onError) => {
    this._validateWithSaveConfirmation(this._validateConfigureFileSource, onSuccess, onError, data);
  };

  _validateConfigureELTSourceWithConfirmation = (data, onSuccess, onError) => {
    this._validateWithSaveConfirmation(this._validateConfigureELTSource, onSuccess, onError, data);
  };

  render() {
    const {
      apiConfig,
      soapConfig,
      templatizedAPIConfig,
      templatizedScriptConfig,
      scriptCredentialsData,
      paging,
      credentialsById,
      credentialsByType,
      dataMaps,
      dataMapSamples,
      vendors,
      vendorEndpoints,
      credentials,
      currentStage,
      selectedCredentialId,
      selectedCredentialInfo,
      selectedCredential,
      selectedConnection,
      probeData,
      probeSample,
      addedDataSource,
      loadDataMaps,
      getDataCredential,
      isLoadingInitialData,
      isLoadingEndpoints,
      isLoadingProbeData,
      isLoadingProbeSample,
      isLoadingProbeWSDL,
      isLoadingProbeSOAPCall,
      isLoadingCredentials,
      isLoadingDataMaps,
      isLoadingVendors,
      currentUser,
      currentOrg,
      isCreatingSource,
      sourceBeingEdited,
      sourceBeingEditedId,
      isModal,
      setFormError,
      nmTemplates,
      connectionTypes,
      nexlaMonitorApiConfig,
      sourceConfig,
      selectedFeeds,
      parentDataSet,
      parentDataSetSamples,
    } = this.props;

    const {
      redirectPath,
      apiResponseByStage,
      apiResponseUpdateTime,
      dataPathValidationResultByStage,
      soapDataPathValidationResult,
    } = this.state;
    const shouldShowAdvancedExitConfirmation = this.state.showAdvancedExitConfirmation && !isModal;

    if (redirectPath) {
      return <Redirect to={redirectPath} />;
    }

    // Show loader if we are in the middle of assigning and redirecting
    if (this.state.isRedirecting) {
      return (
        <ConnectionLoader
          loading
          message={
            sourceBeingEditedId ? 'Saving and redirecting...' : 'Creating flow and redirecting...'
          }
        />
      );
    }

    if (isLoadingInitialData) {
      return (
        <ConnectionLoader
          loading
          message={sourceBeingEditedId ? 'Loading source...' : 'Loading...'}
        />
      );
    }

    const handleChangeDataSourceDetails = ({ property, value }) => {
      this.setState({
        [property]: value,
      });
    };

    const selectedConnectionMeta = selectedConnection
      ? paging.metaInfoById[selectedConnection]
      : null;
    const effectiveConnectionType =
      (selectedCredentialInfo && selectedCredentialInfo._vendorConnectionType) ||
      selectedConnection;
    const { templates } = selectedConnection ? paging.connAuthById[effectiveConnectionType] : {};

    const connectionAuthMeta = selectedConnection
      ? paging.connAuthMeta[effectiveConnectionType]
      : null;

    const sourceConfigFields = paging.sourceConfigById
      ? selectedConnection
        ? paging.sourceConfigById[effectiveConnectionType]
        : paging.sourceConfigById[0]
      : null;
    const saveButtonLabel = sourceBeingEditedId ? 'Save' : 'Create';
    const showBackButton = !(addedDataSource || (sourceBeingEditedId && currentStage === 1));

    const { sourceConfigById } = paging;
    const advancedFields = sourceConfigById[selectedConnection]
      ?.filter((field) =>
        ['start.cron', 'runtime_selection', ...Constants.HC_SOURCE_FIELD_NAMES].includes(
          field.name,
        ),
      )
      .map((field) => {
        // disable lower HC scale factors
        if (field.name === 'hc_scale_factor') {
          const hcScaleFactorOptions = UIUtils.disableInvalidHCOptions(
            field.options,
            sourceBeingEdited &&
              sourceBeingEdited.source_config &&
              sourceBeingEdited.source_config['hc_scale_factor'],
          );

          return { ...field, options: hcScaleFactorOptions };
        }

        return field;
      });

    // For sql_runner script sources, visibleFieldData must include templatizedScriptConfig so the
    // Schedule Ingestion field (e.g. parameters.script.start.cron) gets the cron value.
    const isTemplatizedScript =
      selectedConnectionMeta?.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT ||
      selectedConnectionMeta?.connectionCategory === CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT;
    // selectedConnection is the vendor name for templatized scripts
    const isSqlRunner = isTemplatizedScript && selectedConnection === CONNECTOR_CODE_SQL_RUNNER;
    const baseConfigForVisible = isSqlRunner
      ? { ...sourceConfig, ...templatizedScriptConfig }
      : sourceConfig;

    const newData = UIUtils.configWithMissingDefaults(baseConfigForVisible, sourceConfigFields);

    // omit fields which shouldn't be rendered
    const invisibleFieldNames = sourceConfigFields
      ?.filter((field) => !UIUtils.shouldRenderField(field, newData))
      .map((field) => field.name);
    const visibleFieldData = omit(newData, invisibleFieldNames);

    let selectResourceFormPage;
    const displayConnectionType = this.props.formData?.displayConnectionType || selectedConnection;
    const selectedConnectionDetails = paging.metaInfoById[displayConnectionType];

    switch (selectedConnectionMeta?.connectionCategory) {
      case CONNECTION_CATEGORY_REST:
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            nextButtons={[
              {
                label: saveButtonLabel,
                validationMethod: this._validateConfigureRestSourceWithConfirmation,
              },
            ]}
            onValidationComplete={this._onRestValidationComplete}
            contentHeight={750}
          >
            <ConfigureAPI
              id={2}
              paging={paging}
              sourceBeingEdited={sourceBeingEdited}
              dataMaps={dataMaps}
              dataMapSamples={dataMapSamples}
              selectedConnection={selectedConnection}
              apiConfig={apiConfig}
              apiResponseByStage={apiResponseByStage}
              apiResponseUpdateTime={apiResponseUpdateTime}
              isLoadingProbeSample={isLoadingProbeSample}
              isLoadingDataMaps={isLoadingDataMaps}
              dataPathValidationResultByStage={dataPathValidationResultByStage}
              validateDataPath={this._validateDataPath}
              loadDataMaps={loadDataMaps}
              setFormError={setFormError}
              onClearAPIResponse={this._onProbeClearSample}
              onCallAPI={this._onProbeGetSample}
              onAPIConfigChanged={this._onAPIConfigChanged}
              onGetParameterizedURLs={this._onGetParameterizedURLs}
              onAddStep={this._onAddRestStep}
              onRemoveStep={this._onRemoveRestStep}
              setContextualSupport={this.props.setContextualSupport}
              unsetContextualSupport={this.props.unsetContextualSupport}
              sourceName={this.state.sourceName}
              sourceDescription={this.state.sourceDescription}
              parentDataSet={parentDataSet}
              parentDataSetSamples={this.props.parentDataSetSamples}
              editedSamples={this.state.editedSamples}
              onEditedSamplesChanged={this._handleEditedSamplesChanged}
              selectedConnectionDetails={selectedConnectionDetails}
              onSourceConfigChanged={this._handleSourceConfigChanged}
              advancedFields={advancedFields}
              visibleFieldData={visibleFieldData}
              parentDataSet={parentDataSet}
              name={this.state.sourceName}
              description={this.state.sourceDescription}
              goBack={this.goBack}
              onInputChange={handleChangeDataSourceDetails}
              onSaveAdvancedMode={this.onAPIConfigChanged}
              onError={(msg) => this.props.setFormError(FORM_TYPE_CREATE_DATA_SOURCE, msg)}
              flowType={this.props.flowType || 'streaming'}
              onSelectRuntime={this._handleRuntimeSelected}
              runtimeSelectionDisabled={Boolean(sourceBeingEditedId)}
              selectedClusterId={this.state.clusterId}
            />
          </FormPage>
        );
        break;

      case CONNECTION_CATEGORY_SOAP:
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            nextButtons={[
              {
                label: saveButtonLabel,
                validationMethod: this._validateConfigureSOAPSourceWithConfirmation,
              },
            ]}
            contentHeight={750}
          >
            <ConfigureSOAP
              sourceBeingEdited={this.props.sourceBeingEdited}
              soapConfig={soapConfig}
              visibleFieldData={visibleFieldData}
              probeSample={probeSample}
              name={this.state.sourceName}
              description={this.state.sourceDescription}
              onMetaInfoChanged={this._onMetaInfoChanged}
              sourceConfigFields={paging.sourceConfigById}
              meta={paging?.metaInfoById[selectedConnection]}
              dataPathValidationResult={soapDataPathValidationResult}
              isLoadingWSDL={isLoadingProbeWSDL}
              isLoadingOperation={isLoadingProbeSOAPCall}
              validateDataPath={this._validateSOAPDataPath}
              onLoadWSDL={this._onProbeGetWSDL}
              onLoadOperation={this._onProbeCallSOAP}
              onSOAPConfigChanged={this._onSOAPConfigChanged}
              onResetSOAPConfig={this._onResetSOAPConfig}
            />
          </FormPage>
        );
        break;

      case CONNECTION_CATEGORY_TEMPLATIZED_API:
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            nextButtons={[
              {
                label: saveButtonLabel,
                validationMethod: this._validateConfigureTemplatizedAPISourceWithConfirmation,
              },
            ]}
            contentHeight={750}
          >
            <ConfigureTemplatizedAPI
              id={2}
              sourceBeingEdited={this.props.sourceBeingEdited}
              paging={paging}
              vendorEndpoints={vendorEndpoints}
              dataMaps={dataMaps}
              dataMapSamples={dataMapSamples}
              selectedConnection={selectedConnection}
              selectedCredentialId={selectedCredentialId}
              selectedCredential={selectedCredential}
              templatizedAPIConfig={templatizedAPIConfig}
              apiConfig={apiConfig}
              apiResponse={apiResponseByStage[0]}
              apiResponseByStage={apiResponseByStage}
              apiResponseUpdateTime={apiResponseUpdateTime}
              dataPathValidationResult={dataPathValidationResultByStage[0]}
              dataPathValidationResultByStage={dataPathValidationResultByStage}
              isLoadingProbeSample={isLoadingProbeSample}
              parentDataSet={parentDataSet}
              parentDataSetSamples={this.props.parentDataSetSamples}
              editedSamples={this.state.editedSamples}
              onEditedSamplesChanged={this._handleEditedSamplesChanged}
              validateDataPath={this._validateDataPath}
              loadDataMaps={loadDataMaps}
              getDataCredential={getDataCredential}
              setFormError={setFormError}
              probeGetSample={this.props.probeGetSample}
              onClearAPIResponse={this._onProbeClearSample}
              onCallAPI={this._onProbeTemplatizedAPI}
              onCallRESTAPI={this._onProbeGetSample}
              onTemplatizedAPIConfigChanged={this._onTemplatizedAPIConfigChanged}
              onAPIConfigChanged={this._onAPIConfigChanged}
              onGetParameterizedURLs={this._onGetParameterizedURLs}
              onAddStep={this._onAddRestStep}
              onRemoveStep={this._onRemoveRestStep}
              setContextualSupport={this.props.setContextualSupport}
              unsetContextualSupport={this.props.unsetContextualSupport}
              sourceName={this.state.sourceName}
              sourceDescription={this.state.sourceDescription}
              onInputChange={handleChangeDataSourceDetails}
              selectedConnectionDetails={selectedConnectionDetails}
              sourceConfig={this.props.sourceConfig}
              onSourceConfigChanged={this._handleSourceConfigChanged}
              advancedFields={advancedFields}
              visibleFieldData={visibleFieldData}
              goBack={this.goBack}
              onSaveAdvancedMode={this.onTemplatizedAPIConfigChangedAdvancedMode}
              onError={(msg) => this.props.setFormError(FORM_TYPE_CREATE_DATA_SOURCE, msg)}
              isAPIServerTarget={!!parentDataSet}
              flowType={this.props.flowType}
              onSelectRuntime={this._handleRuntimeSelected}
              runtimeSelectionDisabled={Boolean(sourceBeingEditedId)}
              selectedClusterId={this.state.clusterId}
            />
          </FormPage>
        );
        break;

      case CONNECTION_CATEGORY_TEMPLATIZED_API_MULTI:
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            nextButtons={[
              {
                label: saveButtonLabel,
                validationMethod: this._validateConfigureELTSourceWithConfirmation,
              },
            ]}
            contentHeight={750}
          >
            <ELTSourceSetup
              isLoadingInitialData={isLoadingInitialData}
              onNameChanged={(e) =>
                handleChangeDataSourceDetails({
                  property: 'sourceName',
                  value: e?.target?.value,
                })
              }
              name={this.state.sourceName}
              description={this.state.sourceDescription}
              onDescriptionChanged={(e) =>
                handleChangeDataSourceDetails({
                  property: 'sourceDescription',
                  value: e?.target?.value,
                })
              }
              selectedConnection={selectedConnection}
              sourceConfig={this.props.sourceConfig}
              formType={FORM_TYPE_CREATE_DATA_SOURCE}
              flowType="streaming"
            />
          </FormPage>
        );
        break;

      case CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT:
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            nextButtons={[
              {
                label: saveButtonLabel,
                validationMethod: this._validateConfigureTemplatizedScriptSourceWithConfirmation,
              },
            ]}
            contentHeight={750}
          >
            <ConfigureTemplatizedScript
              id={2}
              name={this.state.sourceName}
              description={this.state.sourceDescription}
              onMetaInfoChanged={this._onMetaInfoChanged}
              paging={paging}
              vendors={vendors}
              vendorEndpoints={vendorEndpoints}
              dataMaps={dataMaps}
              sourceBeingEdited={this.props.sourceBeingEdited}
              flowType={this.props.flowType}
              isAPIServerTarget={!!this.props.parentDataSet}
              credentials={credentials}
              selectedConnection={selectedConnection}
              selectedTemplate={this.state.selectedTemplate}
              connectionAuthFields={this.state.connectionAuthFields}
              onChangeTemplate={this.onChangeTemplate}
              connectionAuthMeta={connectionAuthMeta}
              credentialsByType={credentialsByType}
              credentialsById={credentialsById}
              templatizedScriptConfig={templatizedScriptConfig}
              credentialsData={scriptCredentialsData}
              isLoadingEndpoints={isLoadingEndpoints}
              isLoadingCredentials={isLoadingCredentials}
              loadDataMaps={loadDataMaps}
              loadCredentials={this._loadCredentials}
              onChangeApiType={this.onChangeApiType}
              onScriptCredentialInputChanged={this._onScriptCredentialInputChanged}
              onValidateNewScriptCredential={this._onSaveNewScriptCredential}
              visibleFieldData={visibleFieldData}
              onTemplatizedScriptConfigChanged={this._onTemplatizedScriptConfigChanged}
            />
          </FormPage>
        );
        break;

      case CONNECTION_CATEGORY_DATABASE: {
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            validationMethod={this._validateConfigureFileSourceWithConfirmation}
            nextButtonText={saveButtonLabel}
            contentHeight={750}
            containerStyles={{ height: '100%' }}
          >
            <DatabaseConfigurator
              id={2}
              selectedCredentialId={selectedCredentialId}
              selectedConnection={selectedConnection}
              onEditedSamplesChanged={this._handleEditedSamplesChanged}
              connectionMetas={paging.metaInfoById}
              sourceConfigFields={paging.sourceConfigById}
              sourceConfig={this.props.sourceConfig}
              sourceBeingEdited={sourceBeingEdited}
              onSourceConfigChanged={this._handleSourceConfigChanged}
              updateFormData={this._handleFormDataUpdate}
              onRequestProbeTree={this._onRequestProbeTree}
              onRequestInitialDBProbeTree={this._onRequestInitialDBProbeTree}
              onGetProbeSample={this._onProbeDatabase}
              probeData={this.props.probeData}
              probeDataFlat={this.props.probeDataFlat}
              probeSample={this.props.probeSample}
              probeError={this.props.probeError}
              probeTreeLastUpdatedAt={this.props.probeTreeLastUpdatedAt}
              isLoadingProbeData={this.props.isLoadingProbeData}
              isLoadingProbeSample={this.props.isLoadingProbeSample}
              selectedDatabase={(this.props.selectedBucket || {}).database}
              selectedTable={this.props.selectedTable}
              parentDataSet={parentDataSet}
              parentDataSetSamples={parentDataSetSamples}
              onTableSelected={this._onTableSelected}
              setContextualSupport={this.props.setContextualSupport}
              unsetContextualSupport={this.props.unsetContextualSupport}
              sourceName={this.state.sourceName}
              sourceDescription={this.state.sourceDescription}
              selectedBucket={this.props.selectedBucket}
              sourceConfigFieldsList={sourceConfigFields}
              onInputChange={handleChangeDataSourceDetails}
              selectedConnectionDetails={selectedConnectionDetails}
              visibleFieldData={visibleFieldData}
              goBack={this.goBack}
              onSaveAdvancedMode={this._handleSourceConfigChanged}
              onError={(msg) => this.props.setFormError(FORM_TYPE_CREATE_DATA_SOURCE, msg)}
              flowType={this.props.flowType || 'streaming'}
              onSelectRuntime={this._handleRuntimeSelected}
              runtimeSelectionDisabled={Boolean(sourceBeingEditedId)}
              selectedClusterId={this.state.clusterId}
            />
          </FormPage>
        );
        break;
      }

      case CONNECTION_CATEGORY_WEBHOOK:
        {
          let sourceConfigFieldsByKey = _.reduce(
            paging.sourceConfigById['nexla_rest'],
            (acc, item) => {
              acc[item.name] = item;
              return acc;
            },
            {},
          );
          selectResourceFormPage = (
            <FormPage
              title="Configure"
              showBackButton={showBackButton}
              nextButtons={[
                {
                  label: 'Save',
                  validationMethod: this._validateConfigureWebhookSourceWithConfirmation,
                },
              ]}
              contentHeight={750}
            >
              <IncomingWebhookConfiguration
                selectedConnection={selectedConnection}
                sourceConfig={this.props.sourceConfig}
                sourceBeingEdited={sourceBeingEdited}
                sourceConfigFieldsByKey={sourceConfigFieldsByKey}
                sourceConfigFields={paging.sourceConfigById['nexla_rest']}
                dataSource={addedDataSource}
                isCreatingSource={isCreatingSource}
                currentUser={currentUser}
                currentOrg={currentOrg}
                onCreateSource={this._onWebhookSourceCreate}
                name={this.state.sourceName}
                onMetaInfoChanged={this._onWebhookMetaInfoChanged}
                onSourceConfigChanged={this._handleSourceConfigChanged}
                setContextualSupport={this.props.setContextualSupport}
                unsetContextualSupport={this.props.unsetContextualSupport}
              />
            </FormPage>
          );
        }
        break;

      case CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT: {
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            validationMethod={this._validateConfigureEmailScriptSourceWithConfirmation}
            nextButtonText="Save"
            contentHeight={750}
          >
            <EmailScriptConfiguration
              selectedConnection={selectedConnection}
              sourceConfig={this.props.sourceConfig}
              templatizedScriptConfig={templatizedScriptConfig}
              sourceBeingEdited={sourceBeingEdited}
              dataSource={addedDataSource}
              isCreatingSource={isCreatingSource}
              currentUser={currentUser}
              currentOrg={currentOrg}
              onCreateSource={this._onEmailSourceCreate}
              name={this.state.sourceName}
              onMetaInfoChanged={this._onWebhookMetaInfoChanged}
              onTemplatizedScriptConfigChanged={this._onTemplatizedScriptConfigChanged}
              setContextualSupport={this.props.setContextualSupport}
              unsetContextualSupport={this.props.unsetContextualSupport}
            />
          </FormPage>
        );
        break;
      }

      case CONNECTION_CATEGORY_FILE_UPLOAD:
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            nextButtons={[
              {
                label: 'Save',
                validationMethod: this._validateConfigureFileUploadSourceWithConfirmation,
              },
            ]}
            contentHeight={750}
          >
            <FileUploadConfiguration
              selectedConnection={selectedConnection}
              name={this.state.sourceName}
              selectedFile={this.state.selectedFile}
              selectedFiles={this.state.selectedFiles}
              sourceBeingEdited={sourceBeingEdited}
              sourceConfig={this.props.sourceConfig}
              onFileSelected={this._onFileUploadFileSelected}
              onFilesSelected={this._onFileUploadFilesSelected}
              onFileRemoved={this._onFileUploadFileRemoved}
              onMetaInfoChanged={this._onWebhookMetaInfoChanged}
              onSourceConfigChanged={this._handleSourceConfigChanged}
              allowMultiple
              getCustomProcessorId={this._getCustomProcessorId}
              buildSourceInfo={() => ({
                flow_type: 'streaming',
                name: selectedConnection,
                source_config: this.props.sourceConfig,
              })}
            />
          </FormPage>
        );
        break;

      case CONNECTION_CATEGORY_SYSLOG:
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            nextButtons={[
              {
                label: 'Save',
                validationMethod: this._validateConfigureSyslogSourceWithConfirmation,
              },
            ]}
            contentHeight={750}
          >
            <SyslogConfiguration
              name={this.state.sourceName}
              description={this.state.sourceDescription}
              selectedConnection={selectedConnection}
              selectedConnectionDetails={selectedConnectionDetails}
              onInputChange={handleChangeDataSourceDetails}
              sourceConfig={this.props.sourceConfig}
              sourceBeingEdited={sourceBeingEdited}
              onSourceConfigChanged={this._handleSourceConfigChanged}
            />
          </FormPage>
        );
        break;
      case CONNECTION_CATEGORY_KAFKA:
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            nextButtons={[
              {
                label: saveButtonLabel,
                validationMethod: this._validateConfigureKafkaSourceWithConfirmation,
              },
            ]}
            contentHeight={750}
          >
            <ConfigureKafkaContainer
              id={2}
              name={this.state.sourceName}
              description={this.state.sourceDescription}
              sourceBeingEdited={sourceBeingEdited}
              onMetaInfoChanged={this._onWebhookMetaInfoChanged}
              selectedConnection={selectedConnection}
              selectedCredentialId={selectedCredentialId}
              sourceConfig={this.props.sourceConfig}
              goBack={this.goBack}
              onSaveAdvancedMode={this._handleSourceConfigChanged}
              onError={(msg) => this.props.setFormError(FORM_TYPE_CREATE_DATA_SOURCE, msg)}
            />
          </FormPage>
        );
        break;

      case CONNECTION_CATEGORY_NEXLA_MONITOR:
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            validationMethod={this._validateNexlaMonitorSource}
            nextButtonText={saveButtonLabel}
            contentHeight={750}
          >
            <ConfigureNexlaMonitor
              nmTemplates={nmTemplates}
              paging={paging}
              dataMaps={dataMaps}
              dataMapSamples={dataMapSamples}
              selectedConnection={selectedConnection}
              selectedCredentialId={selectedCredentialId}
              selectedCredential={selectedCredential}
              nexlaMonitorApiConfig={nexlaMonitorApiConfig}
              apiConfig={apiConfig}
              apiResponse={apiResponseByStage[0] || apiResponseByStage[1]}
              apiResponseByStage={apiResponseByStage}
              apiResponseUpdateTime={apiResponseUpdateTime}
              dataPathValidationResult={dataPathValidationResultByStage[0]}
              dataPathValidationResultByStage={dataPathValidationResultByStage}
              isLoadingProbeSample={isLoadingProbeSample}
              validateDataPath={this._validateDataPath}
              loadDataMaps={loadDataMaps}
              getDataCredential={getDataCredential}
              setFormError={setFormError}
              sourceBeingEdited={this.props.sourceBeingEdited}
              probeGetSample={this._onProbeNexlaMonitor}
              onClearAPIResponse={this._onProbeClearSample}
              onNexlaMonitorConfigChanged={this._onNexlaMonitorConfigChanged}
              onGetParameterizedURLs={this._onGetParameterizedURLs}
              onAddStep={this._onAddRestStep}
              onRemoveStep={this._onRemoveRestStep}
              setContextualSupport={this.props.setContextualSupport}
              unsetContextualSupport={this.props.unsetContextualSupport}
              onCallRESTAPI={this._onProbeGetSample}
              onAPIConfigChanged={this._onAPIConfigChanged}
              sourceName={this.state.sourceName}
              sourceDescription={this.state.sourceDescription}
              onInputChange={handleChangeDataSourceDetails}
              selectedConnectionDetails={selectedConnectionDetails}
              sourceConfig={this.props.sourceConfig}
              onSourceConfigChanged={this._handleSourceConfigChanged}
              advancedFields={advancedFields}
              visibleFieldData={visibleFieldData}
              flowType={this.props.flowType}
            />
          </FormPage>
        );
        break;

      case CONNECTION_CATEGORY_NOSQL:
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            nextButtons={[
              {
                label: saveButtonLabel,
                validationMethod: this._validateConfigureFileSourceWithConfirmation,
              },
            ]}
            contentHeight={750}
          >
            <NoSQLConfigurator
              id={2}
              visibleFieldData={visibleFieldData}
              name={this.state.sourceName}
              description={this.state.sourceDescription}
              onMetaInfoChanged={this._onMetaInfoChanged}
              selectedCredentialId={selectedCredentialId}
              selectedConnection={selectedConnection}
              connectionMetas={paging.metaInfoById}
              sourceConfigFields={paging.sourceConfigById}
              sourceConfig={this.props.sourceConfig}
              sourceBeingEdited={sourceBeingEdited}
              onSourceConfigChanged={this._handleSourceConfigChanged}
              onRequestProbeTree={this._onRequestProbeTree}
              onRequestInitialDBProbeTree={this._onRequestInitialDBProbeTree}
              onGetProbeSample={this._onProbeNoSQL}
              probeData={this.props.probeData}
              probeDataFlat={this.props.probeDataFlat}
              probeSample={this.props.probeSample}
              probeError={this.props.probeError}
              probeTreeLastUpdatedAt={this.props.probeTreeLastUpdatedAt} // is not being used
              isLoadingProbeData={this.props.isLoadingProbeData}
              isLoadingProbeSample={this.props.isLoadingProbeSample}
              selectedDatabase={(this.props.selectedBucket || {}).database}
              selectedCollection={this.props.selectedCollection}
              onCollectionSelected={this._onCollectionSelected}
              setContextualSupport={this.props.setContextualSupport}
              unsetContextualSupport={this.props.unsetContextualSupport}
              currentOrg={currentOrg}
              goBack={this.goBack}
              onSaveAdvancedMode={this._handleSourceConfigChanged}
              onError={(msg) => this.props.setFormError(FORM_TYPE_CREATE_DATA_SOURCE, msg)}
            />
          </FormPage>
        );
        break;

      default:
        selectResourceFormPage = (
          <FormPage
            title="Configure"
            showBackButton={showBackButton}
            nextButtons={[
              {
                label: saveButtonLabel,
                validationMethod: this._validateConfigureFileSourceWithConfirmation,
              },
            ]}
            contentHeight={750}
          >
            <SelectBucket
              id={2}
              sourceName={this.state.sourceName}
              sourceDescription={this.state.sourceDescription}
              sourceBeingEdited={sourceBeingEdited}
              selectedCredentialId={selectedCredentialId}
              selectedConnection={selectedConnection}
              connectionMetas={paging.metaInfoById}
              sourceConfigFields={sourceConfigFields}
              sourceConfig={this.props.sourceConfig}
              enableFileSelection={selectedConnection === 'gdrive'}
              onSourceConfigChanged={this._handleSourceConfigChanged}
              onSelected={this._onBucketSelected}
              onRequestProbeTree={this._onRequestProbeTree}
              onToggleNodeProbeTree={this._onToggleNodeProbeTree}
              onInputChange={handleChangeDataSourceDetails}
              addedDataSource={this.props.addedDataSource}
              selectedConnectionDetails={selectedConnectionDetails}
              flowType={this.props.flowType}
              probeData={probeData}
              probeError={this.props.probeError}
              probeTreeLastUpdatedAt={this.props.probeTreeLastUpdatedAt}
              isLoadingProbeData={isLoadingProbeData}
              selectedBucket={this.props.selectedBucket}
              setContextualSupport={this.props.setContextualSupport}
              unsetContextualSupport={this.props.unsetContextualSupport}
              visibleFieldData={visibleFieldData}
              runtimeSelectionVisible={this.state.selectBucketRuntimeSectionVisible}
              goBack={this.goBack}
              onSaveAdvancedMode={this._handleSourceConfigChanged}
              onError={(msg) => this.props.setFormError(FORM_TYPE_CREATE_DATA_SOURCE, msg)}
              renderSectionFields={(section, fields, rawFields) => {
                const hasRuntimeSelection = rawFields?.some((f) => f.type === 'runtime_selection');
                const runtimeSelectionReadOnly = Boolean(sourceBeingEditedId);
                if (hasRuntimeSelection && !this.state.selectBucketRuntimeSectionVisible) {
                  return null;
                }
                return (
                  <>
                    <RawFileDataCheckbox
                      section={section}
                      sourceConfig={this.props.sourceConfig}
                      sourceConfigFields={
                        this.props.paging.allSourceConfigById?.[this.props.selectedConnection] ||
                        sourceConfigFields
                      }
                      onSourceConfigChanged={this._handleSourceConfigChanged}
                    />
                    <FileDataFormatSection
                      section={section}
                      fields={fields}
                      sourceConfig={this.props.sourceConfig}
                      buildSourceInfo={() => ({
                        code_container_id: selectedCredentialId,
                        description: this.state.sourceDescription,
                        flow_type: 'streaming',
                        name: selectedConnection,
                        source_config: this.props.sourceConfig,
                      })}
                      onSourceConfigChanged={this._handleSourceConfigChanged}
                      useFlexFlowCustomSourceConfig
                      getCustomProcessorId={this._getCustomProcessorId}
                    />
                    {hasRuntimeSelection && (
                      <>
                        <RuntimeSelectionDescription readOnly={runtimeSelectionReadOnly} />
                        <div className="runtime_selection_section_body">
                          <RuntimeSelection
                            flowType={this.props.flowType || 'streaming'}
                            connectionType={CONNECTION_CATEGORY_FILE}
                            onSelectRuntime={this._handleRuntimeSelected}
                            onVisibilityChange={this._handleSelectBucketRuntimeVisibilityChange}
                            disabled={runtimeSelectionReadOnly}
                            selectedClusterId={this.state.clusterId}
                          />
                        </div>
                      </>
                    )}
                  </>
                );
              }}
            />
          </FormPage>
        );
    }

    return (
      <div
        aria-label="add-data-source-form-container"
        className={cx({ 'resource-edit-modal': isModal })}
      >
        <Form
          title={
            <>
              {parentDataSet ? flowDataMap.api_server.shortTitle : flowDataMap.streaming.shortTitle}{' '}
              <span style={{ color: 'var(--color-greyscale-200)' }}>/</span>{' '}
              {sourceBeingEdited ? 'Editing ' : 'New '}
              {parentDataSet ? 'Connector' : 'Data Source'}
            </>
          }
          type={FORM_TYPE_CREATE_DATA_SOURCE}
          browserBackLeavesEditor
          onSubmit={this._handleFormDismissed}
          onDismiss={this._handleFormDismissed}
          isModal={isModal}
          sourceBeingEdited={this.props.sourceBeingEdited}
          sourceConfig={this.props.sourceConfig}
          apiConfig={this.props.apiConfig}
          initialSourceConfig={this.props.initialSourceConfig}
          initialApiConfig={this.props.initialApiConfig}
          alwaysShowCancel
          onRef={(f) => {
            this._form = f;
          }}
        >
          <FormPage title="Select" validationMethod={this._validateSelectConnection}>
            <SelectConnection
              id={0}
              connectorResourceType={CONNECTORS_RESOURCE_TYPES.SOURCE}
              connectionMetas={paging.metaInfoById}
              connectionTypes={
                this.props.hideSqlRunnerFromSelect
                  ? _.filter(
                      connectionTypes || paging.sourcesSupported,
                      (c) => c !== CONNECTOR_CODE_SQL_RUNNER,
                    )
                  : connectionTypes || paging.sourcesSupported
              }
              connectionsAllowed={
                this.props.hideSqlRunnerFromSelect
                  ? _.filter(
                      connectionTypes ||
                        paging.connectionsByFlowType?.streaming?.source ||
                        paging.sourcesAllowed,
                      (c) => c !== CONNECTOR_CODE_SQL_RUNNER,
                    )
                  : connectionTypes ||
                    paging.connectionsByFlowType?.streaming?.source ||
                    paging.sourcesAllowed
              }
              connectionsComingSoon={paging.soonForFlowTypes?.streaming?.source}
              connectionCategories={
                parentDataSet
                  ? [
                      CONNECTION_CATEGORY_REST,
                      CONNECTION_CATEGORY_DATABASE,
                      CONNECTION_CATEGORY_TEMPLATIZED_API,
                    ]
                  : []
              }
              selectedConnection={selectedConnection}
              onSelected={this._handleConnectionSelected}
              setContextualSupport={this.props.setContextualSupport}
              unsetContextualSupport={this.props.unsetContextualSupport}
              isLoadingVendors={isLoadingVendors}
              credentialsByType={credentialsByType}
            />
          </FormPage>
          {(!selectedConnectionMeta ||
            !_.includes(
              [
                CONNECTION_CATEGORY_WEBHOOK,
                CONNECTION_CATEGORY_TEMPLATIZED_EMAIL_SCRIPT,
                CONNECTION_CATEGORY_TEMPLATIZED_SCRIPT,
                CONNECTION_CATEGORY_FILE_UPLOAD,
                CONNECTION_CATEGORY_SYSLOG,
              ],
              selectedConnectionMeta.connectionCategory,
            )) && (
            <FormPage
              title="Authenticate"
              onEnter={this.onConnectionSelected}
              showBackButton={showBackButton}
              validationMethod={this._validateSelectCredential}
              contentHeight={750}
            >
              <AuthenticateDataSource
                id={1}
                onChangeApiType={this.onChangeApiType}
                connectionTypes={connectionTypes || paging.sourcesSupported}
                connectionMetas={paging.metaInfoById}
                vendors={vendors}
                selectedConnection={selectedConnection}
                selectedTemplate={this.state.selectedTemplate}
                onChangeTemplate={this.onChangeTemplate}
                templates={templates}
                connectionAuthFields={this.state.connectionAuthFields}
                connectionAuthMeta={connectionAuthMeta}
                dataCredentials={credentialsByType}
                credentialsById={credentialsById}
                isFormAwaitingValidation={this.props.isFormAwaitingValidation}
                isLoadingData={isLoadingCredentials}
                onCredSelectionChanged={this._handleCredSelectionChanged}
                onFormInputChanged={this._handleCredentialFormInputChanged}
                onRefreshClicked={this._loadCredentials}
                setContextualSupport={this.props.setContextualSupport}
                unsetContextualSupport={this.props.unsetContextualSupport}
              />
            </FormPage>
          )}

          {React.cloneElement(selectResourceFormPage, {
            onEnter: this.onConnectionSelected,
            loading: this.props.loadingVendorInfo,
          })}
        </Form>

        {this.state.showSaveConfirmation && (
          <CustomUserConfirmation
            title="Save Changes to Active Source"
            message="You've made changes to an active source. Choose how you want to apply these changes:"
            cancelButtonLabel="Cancel"
            yesWithChangesButtonLabel="Save & Run Now"
            okButtonLabel="Save for Next Run"
            onConfirm={(runWithIngestion) => {
              this._handleSaveConfirmation(runWithIngestion);
            }}
            onClose={() => {
              this._onCloseSaveConfirmation();
            }}
            onRunWithIngestion={(runWithIngestion) => {
              this._handleSaveConfirmation(runWithIngestion);
            }}
          />
        )}

        {shouldShowAdvancedExitConfirmation && (
          <UserConfirmation
            title={ADVANCED_EXIT_CONFIRMATION_TITLE}
            message={ADVANCED_EXIT_CONFIRMATION_MESSAGE}
            okButtonLabel={ADVANCED_EXIT_CONFIRMATION_TITLE}
            cancelButtonLabel="Cancel"
            onConfirm={this._confirmAdvancedExit}
            onCancel={this._cancelAdvancedExit}
          />
        )}
      </div>
    );
  }
}

export default withSnackbar(withRouter(connect()(AddDataSourceForm)));
